import type { Translations } from '../index';

export const de: Translations = {
  errors: {
    generic: {
      unknownTitle: 'Die Aktion konnte nicht abgeschlossen werden',
      unknownMessage: 'Ihre Arbeit ist sicher. Bitte versuchen Sie die Aktion gleich erneut.',
      badRequestTitle: 'Wir konnten diese Anfrage nicht verarbeiten',
      badRequestMessage: 'Bitte überprüfen Sie die markierten Angaben und versuchen Sie es erneut.',
      notFoundTitle: 'Nicht gefunden',
      notFoundMessage: 'Wir konnten nicht finden, wonach Sie gesucht haben. Es wurde möglicherweise verschoben oder entfernt.',
      conflictTitle: 'Das existiert bereits',
      conflictMessage: 'Dieses Element existiert bereits oder wurde anderweitig geändert. Aktualisieren Sie und versuchen Sie es erneut.',
      unsupportedFileTitle: 'Nicht unterstützte Datei',
      unsupportedFileMessage: 'Dieser Dateityp wird hier nicht unterstützt. Bitte versuchen Sie eine andere Datei.',
      fileTooLargeTitle: 'Datei zu groß',
      fileTooLargeMessage: 'Diese Datei überschreitet die zulässige Größe. Bitte verwenden Sie eine kleinere Datei.',
      retry: 'Erneut versuchen',
      dismiss: 'Schließen',
    },
    network: {
      offlineTitle: 'Sie scheinen offline zu sein',
      offlineMessage: 'Überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
      timeoutTitle: 'Das dauert länger als erwartet',
      timeoutMessage: 'Die Anfrage ist abgelaufen. Ihre Arbeit ist gespeichert — bitte versuchen Sie es erneut.',
      serviceUnavailableTitle: 'Dienst vorübergehend nicht verfügbar',
      serviceUnavailableMessage: 'Wir sind kurz nicht verfügbar. Bitte versuchen Sie es in ein paar Sekunden erneut.',
      serverErrorTitle: 'Unser Dienst hat gerade Probleme',
      serverErrorMessage: 'Wir wurden benachrichtigt und arbeiten daran. Bitte versuchen Sie es in Kürze erneut.',
    },
    auth: {
      sessionExpiredTitle: 'Ihre Sitzung ist abgelaufen',
      sessionExpiredMessage: 'Zu Ihrer Sicherheit melden Sie sich bitte erneut an, um fortzufahren.',
      signInCta: 'Anmelden',
      invalidCredentialsTitle: 'Falsche E-Mail oder falsches Passwort',
      invalidCredentialsMessage: 'Überprüfen Sie Ihre Anmeldedaten und versuchen Sie es erneut.',
      accountLockedTitle: 'Konto vorübergehend gesperrt',
      accountLockedMessage: 'Zu viele Versuche. Bitte versuchen Sie es in ein paar Minuten erneut.',
      accountDeactivatedTitle: 'Konto deaktiviert',
      accountDeactivatedMessage: 'Dieses Konto ist deaktiviert. Bitte wenden Sie sich an Ihren Administrator.',
      forbiddenTitle: 'Sie haben keinen Zugriff',
      forbiddenMessage: 'Sie haben keine Berechtigung für diese Aktion.',
      invalidCodeTitle: 'Dieser Code hat nicht funktioniert',
      invalidCodeMessage: 'Der Bestätigungscode ist ungültig oder abgelaufen. Fordern Sie einen neuen an.',
      currentPasswordWrongTitle: 'Das aktuelle Passwort ist falsch',
      currentPasswordWrongMessage: 'Geben Sie Ihr aktuelles Passwort erneut ein und versuchen Sie es erneut.',
      userExistsTitle: 'Konto existiert bereits',
      userExistsMessage: 'Ein Konto mit dieser E-Mail existiert bereits. Versuchen Sie sich anzumelden.',
    },
    credits: {
      insufficientTitle: 'Nicht genügend Credits',
      insufficientMessage: 'Sie haben nicht genügend Credits, um dies abzuschließen. Fügen Sie Credits hinzu oder führen Sie ein Upgrade durch, um fortzufahren.',
      buyCreditsCta: 'Credits kaufen',
      minAmountTitle: 'Betrag zu niedrig',
      minAmountMessage: 'Der Mindestkauf beträgt 10 Credits.',
      invalidAmountTitle: 'Geben Sie einen gültigen Betrag ein',
      invalidAmountMessage: 'Bitte geben Sie eine gültige Anzahl an Credits ein.',
      noPaymentMethodTitle: 'Zahlungsmethode hinzufügen',
      noPaymentMethodMessage: 'Fügen Sie eine Zahlungsmethode hinzu, bevor Sie fortfahren.',
      checkoutFailedTitle: 'Der Bezahlvorgang konnte nicht gestartet werden',
      checkoutFailedMessage: 'Wir konnten den Bezahlvorgang nicht öffnen. Bitte versuchen Sie es erneut.',
      subscriptionRequiredTitle: 'Abonnement erforderlich',
      subscriptionRequiredMessage: 'Sie benötigen einen aktiven kostenpflichtigen Plan, um Credits zu kaufen. Abonnieren Sie zuerst einen Plan.',
      subscribeCta: 'Pläne ansehen',
    },
    orders: {
      notFoundTitle: 'Auftrag nicht gefunden',
      notFoundMessage: 'Dieser Auftrag existiert nicht oder Sie haben keinen Zugriff darauf.',
      accessDeniedTitle: 'Zugriff verweigert',
      accessDeniedMessage: 'Sie haben keinen Zugriff auf diesen Auftrag.',
      readOnlyTitle: 'Schreibgeschützter Zugang',
      readOnlyMessage: 'Ihr Zugang ist schreibgeschützt: Sie können den Auftrag ansehen, aber nicht weiterbearbeiten',
      createFailedTitle: 'Wir konnten Ihren Auftrag nicht erstellen',
      createFailedMessage: 'Etwas hat die Auftragserstellung unterbrochen. Ihre Datei ist noch da — bitte versuchen Sie es erneut.',
    },
    corpus: {
      notFoundTitle: 'Korpus nicht gefunden',
      notFoundMessage: 'Dieser Korpus existiert nicht oder wurde entfernt.',
      duplicateTermTitle: 'Doppelter Begriff',
      duplicateTermMessage: 'Dieser Begriff ist bereits im Glossar.',
    },
    plan: {
      limitTitle: 'Limit Ihres Tarifs erreicht',
      limitMessage: 'Sie haben erreicht, was Ihr aktueller Tarif erlaubt. Führen Sie ein Upgrade durch, um fortzufahren.',
      upgradeCta: 'Tarif upgraden',
      alreadyFreeTitle: 'Sie nutzen den Gratis-Tarif',
      alreadyFreeMessage: 'Sie nutzen bereits den Gratis-Tarif. Wählen Sie einen kostenpflichtigen Tarif, um mehr freizuschalten.',
    },
    processing: {
      timeoutTitle: 'Die Verarbeitung dauert zu lange',
      timeoutMessage: 'Der Dokumentdienst ist abgelaufen. Ihr Upload ist sicher — bitte versuchen Sie es erneut.',
      failedTitle: 'Wir konnten die Verarbeitung nicht abschließen',
      failedMessage: 'Etwas hat die Verarbeitung unterbrochen. Bitte versuchen Sie es erneut.',
    },
  },
  formatTemplates: {
    title: 'Formatvorlagen',
    subtitle: "Legen Sie Blatt, Ränder, Schrift, Kopfzeile, Seitennummerierung, Füllstriche und Schlussformel fest. Die Vorlage wird bei der Prüfung eines Auftrags in Option 4 angewendet.",
    adminTitle: 'Globale Formatvorlagen',
    adminSubtitle: "EZDocu-Vorlagen für alle Konten. Jedes Konto wählt, welche es aktiviert (oder keine); sie werden nie automatisch angewendet.",
    newTemplate: 'Neue Vorlage',
    newGlobalTemplate: 'Neue globale Vorlage',
    duplicateBtn: 'Duplizieren',
    duplicateFromGlobalHint: 'Erstellt eine eigene, bearbeitbare Kopie dieser EZDocu-Vorlage',
    editBtn: 'Bearbeiten',
    deleteBtn: 'Löschen',
    confirmDeleteBtn: 'Löschen?',
    setDefaultBtn: 'Als Standard',
    defaultBadge: 'Standard',
    globalBadge: 'EZDocu',
    ownBadge: 'Eigene',
    myTemplates: 'Meine Vorlagen',
    globalTemplates: 'EZDocu-Vorlagen',
    filterAll: 'Alle',
    filterGlobal: 'Global',
    filterAccounts: 'Von Konten',
    loading: 'Vorlagen werden geladen…',
    empty: 'Sie haben noch keine eigenen Vorlagen. Duplizieren Sie eine EZDocu-Vorlage oder erstellen Sie eine neue.',
    emptyAdmin: 'Keine Vorlagen.',
    copySuffix: '(Kopie)',
    errorGeneric: 'Die Vorlage konnte nicht gespeichert werden',
    summaryHeader: 'Kopfzeile',
    summaryNumbering: 'Nummerierung',
    summaryFill: 'Füllstriche',
    summaryClosing: 'Schlussformel',
    yes: 'ja',
    off: 'nein',
    sectionGeneral: 'Allgemein',
    sectionPage: 'Blatt, Ränder und Typografie',
    sectionTypography: 'Typografie',
    sectionHeaderFooter: 'Kopf- und Fußzeile',
    sectionNumbering: 'Seitennummerierung',
    sectionFill: 'Auffüllen kurzer Zeilen',
    sectionClosing: 'Schlussformel',
    fieldName: 'Name',
    fieldDescription: 'Beschreibung',
    fieldPageFormat: 'Blattgröße',
    fieldOrientation: 'Ausrichtung',
    portrait: 'Hochformat',
    landscape: 'Querformat',
    a4: 'A4',
    letter: 'Letter',
    legal: 'Legal',
    fieldMarginTop: 'Oben (mm)',
    fieldMarginBottom: 'Unten (mm)',
    fieldMarginLeft: 'Links (mm)',
    fieldMarginRight: 'Rechts (mm)',
    fieldFontFamily: 'Schrift',
    fieldFontSize: 'Größe (pt)',
    fieldLineHeight: 'Zeilenabstand',
    fieldTextAlign: 'Textausrichtung',
    alignJustify: 'Blocksatz',
    alignLeft: 'Links',
    alignCenter: 'Zentriert',
    alignRight: 'Rechts',
    fieldParagraphSpaceAfter: 'Nach Absatz (pt)',
    fieldHeaderEnabled: 'Kopfzeile auf den Seiten',
    fieldHeaderText: 'Text der Kopfzeile',
    fieldHeaderAlign: 'Ausrichtung',
    fieldHeaderMode: 'Auf welchen Seiten',
    headerModeAll: 'Alle',
    headerModeFirst: 'Nur die erste',
    headerModeRest: 'Alle außer der ersten',
    fieldHeaderFontSize: 'Schriftgröße (pt)',
    fieldHeaderFontSizeHint: 'Wie Fließtext',
    fieldFooterEnabled: 'Fußzeile',
    fieldFooterText: 'Text der Fußzeile',
    fieldPageNumbering: 'Seiten nummerieren',
    fieldPageNumberFormat: 'Format',
    numberFormatN: '1, 2, 3',
    numberFormatNdeM: 'Seite 1 von N',
    numberFormat00n: '001, 002',
    fieldPageNumberStart: 'Beginnen bei',
    fieldPageNumberPosition: 'Position',
    posFooterCenter: 'Fußzeile, zentriert',
    posFooterRight: 'Fußzeile, rechts',
    posHeaderRight: 'Kopfzeile, rechts',
    fieldFillShortLines: 'Kurze Zeilen mit Strichen auffüllen',
    fieldFillChar: 'Zeichen',
    fieldFillScope: 'Wo',
    fillScopeParagraphEnd: 'Letzte Zeile jedes Absatzes',
    fillScopeLine: 'Jede kurze Zeile',
    fillScopeBlankOnly: 'Nur Leerzeilen',
    fieldClosingEnabled: 'Schlussformel hinzufügen',
    fieldClosingHtml: 'Text (einfaches HTML)',
    fieldClosingKeepTogether: 'Beim letzten Absatz halten (nie allein auf einer neuen Seite)',
    variablesHint: 'Verfügbare Variablen (zum Kopieren klicken):',
    previewTitle: "Live-Vorschau",
    previewDocxBtn: "Beispiel-Word",
    previewDocxError: "Beispiel-Word konnte nicht erstellt werden",
    mirrorMakeEditable: "Als eigenes Format bearbeiten",
    mirrorSheetNote: "Das Dokument bleibt genau wie heute",
    verifiedBadge: "Verifiziert",
    alreadyInMenu: "Bereits im Menü",
    detectSaveDirect: "Unverändert speichern",
    swipeForMore: "Wischen für weitere Formate →",
    orderFormatLabel: "Ausgabeformat",
    orderFormatHint: "Bestimmt, wie Option 4 erzeugt wird. Auch in der Überprüfung änderbar, ohne Neuverarbeitung.",
    previewRealLoading: "Echte Vorschau wird erstellt…",
    closingLangLabel: "Sprache der Beglaubigungsformel",
    closingLangEs: "Wie in der Vorlage geschrieben (nicht übersetzt)",
    closingLangTarget: "In die Zielsprache des Auftrags übersetzt",
    smallMarginWarn: "Ränder unter 10 mm können beim Druck abgeschnitten werden.",
    colEmpty: "Leer",
    colText: "Text",
    colPageNum: "Seitenzahl",
    colTextPlaceholder: "Spaltentext",
    colRemove: "Entfernen",
    colAdd: "Spalte hinzufügen",
    colSwitchToColumns: "Mit Spalten bauen (bis zu 4)",
    fieldFooterRule: "Gedruckte Linie über der Fußzeile",
    sectionRules: "Dokumentregeln",
    fieldLineNumbering: "Zeilen nummerieren (Gerichtsformat)",
    fieldLinesPerPage: "Zeilen pro Seite",
    fieldLineNumberRule: "Vertikale Linie",
    lineNumberingHint: "Die Nummern berechnen sich beim Bearbeiten in Word selbst neu: Sie leben im Abschnitt, nie als Text geschrieben.",
    pinBtn: "Anheften",
    pinnedBadge: "Angeheftet",
    pinHint: "Angeheftete Formate erscheinen beim Vorbereiten eines Auftrags",
    addToMenuBtn: "Zu meinem Menü",
    deleteInUseConfirm: "Dieses Format wurde in {n} Auftrag/Aufträgen verwendet. Gelieferte Aufträge ändern sich nicht. Trotzdem löschen?",
    deleteInUseConfirmOne: "Dieses Format wurde in {n} Auftrag verwendet. Gelieferte Aufträge ändern sich nicht. Trotzdem löschen?",
    deleteInUseConfirmOther: "Dieses Format wurde in {n} Aufträgen verwendet. Gelieferte Aufträge ändern sich nicht. Trotzdem löschen?",
    searchPlaceholder: "Format suchen…",
    catAll: "Alle",
    catGeneral: "Allgemein",
    catCertified: "Beglaubigt",
    catCourt: "Gericht",
    pickerNoPinned: "Keine angehefteten Formate. Heften Sie Ihre Formate an, um sie hier zu sehen.",
    uploadWordBtn: "Word hochladen",
    detectTitle: "Das steckt in Ihrem Word",
    detectReading: "Datei wird gelesen…",
    detectIntro: "Diese Eigenschaften wurden aus {file} gelesen. Nicht Gefundenes wird als solches markiert — nichts wird still befüllt.",
    detectNotFound: "Nicht gefunden",
    detectYes: "Ja",
    detectNo: "Nein",
    detectHint: "Im Editor können Sie Fehlendes ergänzen und das Ergebnis live auf dem Papier sehen.",
    detectOpenEditor: "Im Editor öffnen",
    detectFailed: "Die Datei konnte nicht gelesen werden. Ist es eine .docx bis 20 MB?",
    previewPageOf: "Seite {n} von {m}",
    previewTabScreen: "Bildschirm",
    previewTabWord: "Word",
    previewTabPdf: "PDF",
    previewAllMatch: "Bildschirm, Word und PDF stimmen überein",
    previewGuides: "Hilfslinien anzeigen",
    previewGuideHeader: "Kopfzeile",
    previewGuideFooter: "Fußzeile",
    previewGuideContent: "Inhalt",
    previewRuler: "Lineal",
    previewRulerDrag: "Ziehen, um den Rand zu ändern",
    previewSample1: "GEBURTSURKUNDE",
    previewSample2: "Ich bestätige, dass dies eine getreue Übersetzung des mir vorliegenden Originaldokuments ist. Die betreffende Person wurde in der angegebenen Stadt geboren; ihre Daten sind im entsprechenden Register eingetragen.",
    previewSample3: "Die Angaben der Urkunde stimmen mit dem vorgelegten Dokument überein; das Original weist weder Änderungen noch Rasuren auf.",
    previewClosingSignature: "Unterschrift und Siegel des Übersetzers",
    previewPageBreak: "Seitenumbruch",
    mirrorNotice: "Spiegel des Originals: Dieses Format gibt das Dokument genau so wieder, wie es heute erzeugt wird. Seite, Typografie und Regeln gelten nicht.",
    saveBtn: 'Speichern',
    savingBtn: 'Wird gespeichert…',
    cancelBtn: 'Abbrechen',
    backBtn: 'Zurück',
    unsavedConfirm: 'Sie haben ungespeicherte Änderungen. Ohne Speichern verlassen?',
    savedOk: 'Gespeichert',
    unsavedTitle: 'Ungespeicherte Änderungen',
    unsavedStay: 'Bleiben',
    unsavedLeave: 'Ohne Speichern verlassen',
    variablesLangHint: "Sprach-, Monats- und Datumsvariablen werden automatisch in der Zielsprache der Übersetzung geschrieben.",
    closingSignatureToggle: "Unterschrift und Stempel hinzufügen (Bild)",
    closingSignatureUpload: "Unterschrift/Stempel-Bild hochladen",
    closingSignatureRemove: "Bild entfernen",
    createBtn: 'Erstellen',
    defaultCardLabel: 'Standard-Formatvorlage',
    defaultCardHint: "Aktivieren Sie sie, damit Ihre Aufträge zusätzlich Option 4 mit diesem Format erhalten",
    defaultNone: "Keine Vorlage (Option 4 wird nicht erzeugt)",
    defaultManageLink: 'Vorlagen verwalten',
    defaultSaved: 'Gespeichert',
    pickerLabel: 'Vorlage',
    pickerApplying: 'Wird angewendet…',
    pickerError: 'Die Vorlage konnte nicht angewendet werden',
    pickerNone: "Original",
    wordOnly: "Die Datei muss ein Word-Dokument (.docx) sein.",
    noMatches: "Keine Formate passen zu „{q}“.",
    dropWordHere: "Legen Sie die .docx-Datei ab, um ihr Format zu lesen",
    dragWordOrClick: "Ziehen Sie eine Word-Datei hierher oder klicken Sie, um sie hochzuladen ({btn})",
    privacyNote: "Die Datei wird nur zum Auslesen der Formatierung verwendet: Der Inhalt wird nicht gespeichert und danach gelöscht.",
    fieldUnit: "Einheit",
    unitCm: "Zentimeter (cm)",
    unitIn: "Zoll (in)",
    ruleRepeatSeal: "Stempel und Unterschrift auf jeder Seite wiederholen",
    ruleDescribeIllegible: "Unleserliche Stempel/Unterschriften beschreiben",
    ruleInvalidateBack: "Rückseite entwerten",
    ruleSingleSided: "Einseitiger Druck",
    colImage: "Bild",
    colImageLogo: "Logo",
    colImageSignature: "Unterschrift",
    colImageSeal: "Stempel",
    colImageRemove: "Eigenes Bild entfernen",
    colImageUpload: "Bild hochladen",
    colImageUploading: "Wird hochgeladen…",
    colImageTooBig: "Max. 2 MB",
    colImageUploadError: "Das Bild konnte nicht hochgeladen werden",
    colSizeS: "Klein",
    colSizeM: "Mittel",
    colSizeL: "Groß",
    colSizeCustom: "Benutzerdefiniert",
    detectHeaderImage: "Bild in der Kopfzeile",
    detectFooterImage: "Bild in der Fußzeile",
    sampleFileName: "{name} (Muster {time})",
    sampleDefaultName: "Format",
    errHeaderEmpty: "Die Kopfzeile ist aktiviert, hat aber weder Text noch Spalten.",
    errClosingEmpty: "Die Schlussformel ist aktiviert, hat aber keinen Text.",
    errNameRequired: "Der Name ist erforderlich.",
    errInvalidValue: "Ein Wert liegt außerhalb des zulässigen Bereichs. Prüfen Sie Ränder, Größen, Zeilenabstand und Nummerierung.",
    lockedNotice: "Dieses Format ist geprüft: Die Norm erlaubt keine Änderung dieser Felder. Duplizieren Sie es, wenn Sie eine andere Einstellung benötigen.",
    marginsBox: "Ränder",
    marginsLink: "Gleich",
    marginsLinkHint: "Setzt alle vier Ränder gleich; solange aktiv, ändern sich beim Ändern eines Rands alle",
    bandToolbarLabel: "Blöcke bearbeiten",
    blockMoveLeft: "Nach links verschieben",
    blockMoveRight: "Nach rechts verschieben",
    blockDelete: "Block löschen",
    blockDrag: "Zum Neuordnen ziehen (oder Leertaste drücken und Pfeiltasten verwenden)",
    blockDragInstructions: "Zum Neuordnen mit der Tastatur drücken Sie die Leertaste, verschieben den Block mit den Pfeiltasten und drücken zum Ablegen erneut die Leertaste.",
    blockTextLabel: "Text des Blocks",
    blockTextPlaceholder: "Hier schreiben",
    blockTextEditorHint: "Esc zum Beenden",
    blockImageHeight: "Höhe (mm)",
    blockImageResize: "Bildhöhe",
    blockImageProfile: "{img} aus dem Profil",
    bandEmpty: "Noch keine Blöcke. Fügen Sie Text, ein Bild oder die Seitenzahl hinzu.",
    bandHeaderEmptyWarn: "Die Kopfzeile ist aktiviert, aber leer: Geben Sie etwas ein oder deaktivieren Sie sie.",
    bandAutoPageNum: "Automatische Seitenzahl: Einstellung unter „Seitennummerierung“",
    bandOrderHint: "Von links nach rechts, wie auf dem Blatt. Sie können sie auch direkt in der Vorschau bearbeiten.",
    bandClickToEdit: "Zum Bearbeiten klicken",
    blocksHeader: "Blöcke der Kopfzeile",
    blocksFooter: "Blöcke der Fußzeile",
    bandSheetHint: "Klicken Sie auf die Kopf- oder Fußzeile des Blatts, um sie zu bearbeiten",
    blockMaxReached: "Höchstens 4 Blöcke pro Leiste",
    blockPageNumExists: "Diese Leiste hat bereits die Seitenzahl",
    blockImageLocked: "Die Norm dieses Formats erlaubt hier keine Bilder",
    blockDeleted: "Block gelöscht",
    blockUndo: "Rückgängig",
    blockImageChange: "Bild ändern…",
    blockImageUploadNew: "Bild hochladen…",
    previewEditingMockup: "Bearbeitung im Entwurf",
    previewShowReal: "Echtes Blatt zeigen",
    previewZoom: "Zoom der Vorschau",
    previewZoomOut: "Verkleinern",
    previewZoomIn: "Vergrößern",
    previewZoomActual: "Originalgröße (100 %)",
    previewZoomFit: "An Breite anpassen",
    fieldHeaderDistance: "Abstand der Kopfzeile vom Rand ({unit})",
    fieldFooterDistance: "Abstand der Fußzeile vom Rand ({unit})",
    bandDistanceHint: "Wie in Word: Passt die Kopf- oder Fußzeile nicht in den Rand, rückt der Text weiter, um Platz zu machen. In den Hilfslinien markiert die gepunktete Linie diesen Abstand.",
    bandDistanceTooBig: "Der Abstand passt nicht auf dieses Blatt: Er darf höchstens {max} vom Rand betragen.",
    bandHeaderPushes: "Die Kopfzeile passt nicht in den Rand: Der Text beginnt bei {x}, wie in Word und im PDF.",
    bandFooterPushes: "Die Fußzeile passt nicht in den Rand: Der Text endet {x} vor dem Rand, wie in Word und im PDF.",
    marginsTooBig: "Die Ränder passen nicht auf dieses Blatt: Lassen Sie mindestens {min} Textbereich in Breite und Höhe.",
    bandFieldPlaceholderHeader: "Kopfzeile eingeben…",
    bandFieldPlaceholderFooter: "Fußzeile eingeben…",
    bandFieldHint: "Was Sie hier sehen, erscheint genau so auf dem Blatt, im PDF und im Word-Dokument. Klicken Sie auf das Blatt, um zu diesem Feld zurückzukehren.",
    bandAlignLeft: "Linksbündig",
    bandAlignCenter: "Zentrieren",
    bandAlignRight: "Rechtsbündig",
    bandImage: "Bild",
    bandImageHeightTitle: "Bildhöhe",
    bandImageHeightField: "Höhe in mm (5 bis 60)",
    bandImageSmaller: "Kleiner",
    bandImageBigger: "Größer",
    bandImageRemove: "Bild entfernen",
    bandImagesMax: "Höchstens {n} Bilder pro Kopf- oder Fußzeile",
    bandImageNotAllowed: "Dieses Bild kann hier nicht verwendet werden: Laden Sie es von Ihrem Computer hoch.",
    bandPageNumber: "Seitenzahl",
    bandColumns: "Spalten",
    bandColumns2: "2 Spalten",
    bandColumns3: "3 Spalten",
    bandColumnsRemove: "Spalten entfernen",
    bandColumnsOnlyOne: "Diese Kopf- oder Fußzeile hat bereits eine Spaltenzeile",
    bandLinesMax: "Die Kopf- oder Fußzeile hat bereits die maximale Zeilenzahl",
    bandNumberOff: "Die Seitennummerierung ist deaktiviert: Diese Zahl wird nicht gedruckt.",
    bandNumberInBand: "Die Seitenzahl steht dort, wo Sie sie in der Kopf- oder Fußzeile eingefügt haben.",
    bandNumberTwice: "Sowohl in der Kopf- als auch in der Fußzeile steht eine Seitenzahl.",
    bandEditorFailed: "Der Editor wurde nicht geladen. Laden Sie die Seite neu, um zu bearbeiten; Gespeichertes bleibt unverändert.",
    bandEditorRetry: "Erneut versuchen",
    bandRichNotSaved: "Der Server unterstützt diese Kopf- oder Fußzeile noch nicht: Nur ihr Text wurde gespeichert. Speichern Sie in ein paar Minuten erneut.",
    bandDialogApply: "Übernehmen",
    bandDialogCancel: "Abbrechen",
    bandTooLong: "Diese Kopf- oder Fußzeile hat zu viel Formatierung: Entfernen Sie etwas Fett, Kursiv oder Unterstreichung.",
    bandImagesTooTall: "Die Bilder nehmen bereits die maximale Höhe ein ({mm} mm).",
    bandNumberNotAllPages: "Die Kopfzeile erscheint nicht auf allen Seiten: die Seitenzahl auch nicht.",
  },
  sidebar: {
    formatTemplates: 'Formatvorlagen',
    hubspot: 'HubSpot',
    payments: 'Zahlungen',
    aiCosts: 'KI-Kosten',
    campaignCodes: 'Codes',
    ambassadorApplications: 'Botschafter-Bewerbungen',
    ambassadors: 'Botschafter',
    applications: 'Bewerbungen',
    invite: 'Einladen',
    ambassadorAccount: 'Botschafter-Konto',
    adminAccount: 'Admin-Bereich',
    ambassadorHome: 'Start',
    ambassadorReferrals: 'Meine Empfehlungen',
    ambassadorCommissions: 'Provisionen',
    ambassadorNetwork: 'Mein Netzwerk',
    asistente: 'Assistent',
    overview: 'Übersicht',
    accounts: 'Konten',
    users: 'Benutzer',
    logs: 'Protokolle',
    waitlist: 'Warteliste',
    templates: 'Vorlagen',
    analytics: 'Analysen',
    dashboard: 'Dashboard',
    orders: 'Aufträge',
    team: 'Team',
    credits: 'Credits',
    certificate: 'Zertifikat',
    settings: 'Einstellungen',
    myTasks: 'Meine Aufgaben',
    myWorkspace: 'Mein Arbeitsbereich',
    account: 'Konto',
    activity: 'Aktivität',
    plans: 'Tarife',
    features: 'Funktionen',
    signOut: 'Abmelden',
    closeSidebar: 'Seitenleiste schließen',
    openSidebar: 'Seitenleiste öffnen',
    accountMenu: 'Kontomenü',
    corpus: 'Glossar',
    myTerms: 'Meine Begriffe',
    companySettings: 'Unternehmen',
    companyDataDesc: 'Unternehmensdaten des Kontos',
    blog: 'Blog',
    landingPages: 'Landingpages',
    navMenu: 'Navigationsmenü',
    glossary: 'Glossare',
    siteCopy: 'Website-Texte',
    seo: 'SEO',
    apiKeys: 'API-Schlüssel',
    support: 'Support',
    knowledge: 'Wissen',
    eventRegistrations: 'Verlosungen / Events',
    content: 'Inhalt',
    events: 'Events',
  },
  dashboard: {
    welcome: 'Willkommen zurück',
    subtitle: 'Hier ist eine Übersicht Ihrer heutigen Aufträge.',
    newOrder: 'Neuer Auftrag',
    lowCredits: 'Wenig Credits: noch {n} verfügbar',
    creditsBalance: 'Guthaben',
    ordersInProgress: 'Aufträge in Bearbeitung',
    completedOrders: 'Abgeschlossene Aufträge',
    teamMembers: 'Teammitglieder',
    available: 'Verfügbar',
    low: 'Niedrig',
    active: 'Aktiv',
    recentOrders: 'Aktuelle Aufträge',
    viewAll: 'Alle anzeigen',
    noOrdersYet: 'Noch keine Aufträge',
    createFirstOrder: 'Erstellen Sie Ihren ersten Auftrag',
    quickActions: 'Schnellaktionen',
    uploadDocument: 'Dokument hochladen',
    startNewTranslation: 'Eine neue Übersetzung starten',
    buyCredits: 'Credits kaufen',
    addToBalance: 'Guthaben aufladen',
    inviteTeam: 'Team einladen',
    addTeamMembers: 'Teammitglieder hinzufügen',
    companyOverview: 'Unternehmensübersicht',
    thisMonth: 'Dieser Monat',
    totalOrders: 'Aufträge gesamt',
    inProgress: 'In Bearbeitung',
    completed: 'Abgeschlossen',
    recentActivity: 'Letzte Aktivitäten',
    translation: 'Übersetzung',
    translationEdit: 'Übersetzungsbearbeitung',
    lastActivity: 'Letzte Aktivität',
    noActivityYet: 'Noch keine Aktivität',
    pages: 'Seiten',
    topLanguages: 'Häufigste Sprachen',
    creditActivity: 'Credit-Aktivität',
    document: 'Dokument',
    languages: 'Spr.',
    date: 'Datum',
    ordersCount: 'Aufträge',
    archivedCount: '{n} archiviert',
    prev: 'Zurück',
    next: 'Weiter',
    noTransactions: 'Noch keine Transaktionen',
    status: 'Status',
    ocrGenerated: 'OCR',
    ocrEdit: 'OCR-Bearbeitung',
    download: 'Herunterladen',
    txTranslationCompleted: 'Auftrag {order}: Übersetzung abgeschlossen ({pages} Seiten)',
    txCreditsPurchased: 'Credits gekauft',
    txCreditsRefunded: 'Credits erstattet',
    txCreditsAdjusted: 'Credits angepasst',
    txAutoRecharge: 'Automatische Aufladung',
    hideHeader: 'Kopfbereich ausblenden',
  },
  statuses: {
    uploaded: 'Hochgeladen',
    processing: 'In Verarbeitung',
    ocrreview: 'OCR-Prüfung',
    translationreview: 'Übersetzungsprüfung',
    completed: 'Abgeschlossen',
    cancelled: 'Storniert',
    unknown: 'Unbekannt',
  },
  notifications: {
    title: 'Benachrichtigungen',
    markAllRead: 'Alle als gelesen markieren',
    noNotifications: 'Noch keine Benachrichtigungen',
    dismiss: 'Schließen',
    close: 'Schließen',
    orderAssignedTitle: 'Neuer Auftrag zugewiesen',
    orderAssignedMessage: '{by} hat Ihnen „{doc}“ zugewiesen',
    orderCompletedTitle: 'Auftrag abgeschlossen',
    orderCompletedMessage: '„{doc}“ wurde abgeschlossen',
    orderReassignedTitle: 'Auftrag neu zugewiesen',
    orderReassignedMessage: '„{doc}“ wurde {to} neu zugewiesen',
    projectCompletedTitle: 'Projekt abgeschlossen',
    projectCompletedMessage: '„{project}“ ist abgeschlossen. Der Gesamt-Download ist verfügbar.',
    finalizationRequestedTitle: 'Auftrag wartet auf Abschluss',
    finalizationRequestedMessage: '{by} bittet, „{doc}“ abzuschließen',
    finalizationReturnedTitle: 'Auftrag zurückgegeben',
    finalizationReturnedMessage: '{by} hat „{doc}“ zur Überarbeitung zurückgegeben',
  },
  time: {
    justNow: 'Gerade eben',
    minAgo: 'Vor {n} Min.',
    hourAgo: 'Vor {n} Stunde',
    hoursAgo: 'Vor {n} Stunden',
    yesterday: 'Gestern',
    daysAgo: 'Vor {n} Tagen',
    mAgo: 'Vor {n}m',
    hAgo: 'Vor {n}h',
    dAgo: 'Vor {n}d',
  },
  orders: {
    title: 'Aufträge',
    subtitle: 'Verwalten Sie Ihre Übersetzungsaufträge',
    newOrder: 'Neuer Auftrag',
    total: 'Gesamt',
    uploaded: 'Hochgeladen',
    inProgress: 'In Bearbeitung',
    completed: 'Abgeschlossen',
    thisMonth: 'Diesen Monat',
    noOrdersFound: 'Keine Aufträge gefunden',
    tryAdjusting: 'Bitte passen Sie Ihre Suche oder Filter an',
    createFirst: 'Erstellen Sie Ihren ersten Übersetzungsauftrag, um loszulegen',
    order: 'Auftrag',
    document: 'Dokument',
    type: 'Typ',
    pagesCol: 'Seiten',
    creditsCol: 'Credits',
    qualityCol: 'Qualität',
    languageCol: 'Sprache',
    status: 'Status',
    createdBy: 'Erstellt von',
    assignedTo: 'Zugewiesen an',
    client: 'Kunde',
    date: 'Datum',
    actions: 'Aktionen',
    showing: 'Anzeige',
    of: 'von',
    image: 'Bild',
    text: 'Text',
    handwritten: 'Handschriftlich',
    modeTranslate: 'Übersetzung',
    modeLayout: 'Layout',
    searchPlaceholder: 'Suche nach Dokumentname, Ersteller, Kunde oder Auftragsnummer...',
    allStatus: 'Alle Status',
    allTypes: 'Alle Typen',
    allDocTypes: 'Dokumenttyp',
    allWorkTypes: 'Auftragsart',
    view: 'Ansehen',
    clearDates: 'Datumsfilter löschen',
    verifiedBy: 'Geprüft von',
    due: 'Fällig',
    open: 'Öffnen',
    filterProjects: 'Projekte',
    filterSingle: 'Einzelaufträge',
    archived: 'Archiviert',
    toSetUp: 'Einrichten',
    cancelled: 'Storniert',
    completedOf: '{pct}% abgeschlossen · {done} von {total}',
    moveToProject: 'Zu Projekt verschieben…',
    removeFromProject: 'Aus Projekt entfernen',
    notAssigned: 'Nicht zugewiesen',
    trash: 'Papierkorb',
    trashAction: 'Löschen',
    trashConfirmTitle: 'In den Papierkorb verschieben?',
    trashConfirmMessage: 'Er verschwindet für Ihr gesamtes Team aus den Listen, dem Dashboard und den Projekten. Sie können ihn 7 Tage lang aus dem Papierkorb wiederherstellen. Es werden keine Dateien oder Daten gelöscht.',
    trashConfirmButton: 'In den Papierkorb verschieben',
    restore: 'Wiederherstellen',
    deletePermanently: 'Endgültig löschen',
    deletePermanentlyConfirmTitle: 'Endgültig löschen?',
    deletePermanentlyConfirmMessage: 'Er steht danach niemandem in Ihrem Team mehr zur Verfügung, auch nicht im Papierkorb. Dies kann nicht rückgängig gemacht werden.',
    emptyTrash: 'Papierkorb leeren',
    emptyTrashConfirmTitle: 'Papierkorb leeren?',
    emptyTrashConfirmMessage: 'Alle Aufträge im Papierkorb werden endgültig gelöscht und stehen Ihrem Team nicht mehr zur Verfügung. Dies kann nicht rückgängig gemacht werden.',
    trashNotice: 'Aufträge im Papierkorb werden nach 7 Tagen endgültig gelöscht.',
    trashEmpty: 'Der Papierkorb ist leer',
    trashDaysLeft: 'Noch {days} T.',
    trashActionFailed: 'Die Aktion konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
    trashNoPermission: 'Sie haben keine Berechtigung, Aufträge zu löschen.',
    readOnlyNotice: 'Ihr Zugang ist schreibgeschützt: Sie können Ihre Aufträge ansehen und Fertiges herunterladen, sie aber weder weiterbearbeiten noch ändern',
    readOnlyActionHint: 'Nur Lesen: Sie können diesen Auftrag nicht ändern',
    working: 'Wird verarbeitet...',
    purgedBadge: 'Daten gelöscht',
    archiveAction: 'Archivieren',
    unarchiveAction: 'Archivierung aufheben',
    archivedEmpty: 'Keine archivierten Aufträge oder Projekte',
    archiveFailed: 'Der Auftrag konnte nicht archiviert werden. Bitte versuchen Sie es erneut.',
    archivedBadge: 'Archiviert',
  },
  projects: {
    createOrder: 'Auftrag erstellen',
    createOrderHint: 'Ein Dokument',
    createProject: 'Projekt erstellen',
    createProjectHint: 'Mehrere Dokumente desselben Falls',
    newProject: 'Neues Projekt',
    name: 'Projektname',
    namePlaceholder: 'z. B. Fall Maria Roldan',
    client: 'Kunde',
    clientPlaceholder: 'Kundenname',
    reference: 'Reference #',
    referencePlaceholder: 'Eigene Nummer',
    dueDate: 'Fälligkeitsdatum',
    addNote: '+ Notiz hinzufügen',
    notePlaceholder: 'Notizen zu diesem Fall',
    defaults: 'Vorgaben für jedes Dokument',
    task: 'Was wird benötigt?',
    translation: 'Übersetzung',
    layout: 'Layout',
    decidePerDocument: 'Pro Dokument entscheiden',
    assignProject: 'Ganzes Projekt zuweisen an',
    dropFiles: 'Dateien hier ablegen oder auswählen',
    chooseFiles: 'Dateien wählen',
    createCta: 'Projekt erstellen',
    creating: 'Wird erstellt…',
    pastDate: 'Dieses Datum liegt in der Vergangenheit.',
    afterProjectDue: 'Das liegt nach dem Projektdatum ({date}).',
    prepTitle: 'Vorbereitung',
    addDocuments: 'Dokumente hinzufügen',
    addNDocuments: '{n} Dokumente hinzufügen',
    languages: 'Sprachen',
    assignTo: 'Zuweisen an',
    apply: 'Übernehmen',
    statusReady: 'Bereit',
    statusToSetUp: 'Einrichten',
    createNOrders: '{n} Aufträge erstellen',
    estimated: 'Geschätzt: {n} Credits',
    remainingPrep: '{n} Dokumente bleiben in Vorbereitung',
    archive: 'Projekt archivieren',
    archiveConfirm: 'Projekt archivieren? Sie können es später wiederherstellen.',
    unarchive: 'Wiederherstellen',
    downloadZip: 'Alles herunterladen',
    setTaskToContinue: 'Legen Sie die Aufgabe für jedes Dokument fest',
    creditsForXN: 'Credits reichen für {x} von {n} Aufträgen.',
    createX: '{x} erstellen',
    recharge: 'Credits kaufen',
    position: '#',
    auto: 'Auto',
    removePrep: 'Dieses Dokument aus der Vorbereitung entfernen?',
  },
  teamPage: {
    title: 'Team',
    subtitle: 'Verwalten Sie Ihre Teammitglieder und Einladungen',
    inviteMember: 'Mitglied einladen',
    teamMembers: 'Teammitglieder',
    pendingInvites: 'Ausstehende Einladungen',
    noMembers: 'Noch keine Teammitglieder. Laden Sie jemanden ein, um loszulegen.',
    owner: 'Inhaber',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    remove: 'Entfernen',
    joined: 'Beigetreten',
    pendingInvitations: 'Ausstehende Einladungen',
    expires: 'Läuft ab',
    sent: 'Gesendet',
    link: 'Link',
    copied: 'Kopiert',
    resend: 'Erneut senden',
    cancel: 'Abbrechen',
    teamRoles: 'Teamrollen',
    teamRolesDesc:
      '<strong>Team</strong>-Mitglieder können Aufträge erstellen und verwalten. <strong>Mitglieder</strong> können an zugewiesenen Aufträgen arbeiten. Nur Kontoinhaber können neue Mitglieder einladen und die Abrechnung verwalten.',
    inviteTeamMember: 'Teammitglied einladen',
    invitationSent: 'Einladung gesendet',
    firstName: 'Vorname',
    lastName: 'Nachname',
    emailAddress: 'E-Mail-Adresse',
    sending: 'Wird gesendet...',
    sendInvitation: 'Einladung senden',
    invitationSentTo: 'Einladung gesendet an',
    inviteLink: 'Einladungslink',
    shareLinkDesc: 'Teilen Sie diesen Link mit der Person, die Ihrem Team beitreten soll.',
    done: 'Fertig',
    copy: 'Kopieren',
    member: 'Mitglied',
    role: 'Rolle',
    status: 'Status',
    email: 'E-Mail',
    removeTeamMember: 'Teammitglied entfernen',
    removeConfirmMsg:
      'Möchten Sie <strong>{name}</strong> wirklich aus Ihrem Team entfernen? Diese Aktion kann nicht rückgängig gemacht werden. Das Mitglied verliert sofort den Zugriff auf alle Teamressourcen.',
    removeMember: 'Mitglied entfernen',
    thisMonth: 'Diesen Monat',
    roleOwner: 'Eigentümer',
    roleManager: 'Manager',
    roleReviewer: 'Prüfer',
    roleMember: 'Mitglied',
    roleManagerDesc: 'Führt das Tagesgeschäft des Kontos',
    roleReviewerDesc: 'Sieht und genehmigt die Arbeit des Teams',
    roleMemberDesc: 'Nur eigene und zugewiesene Dokumente',
    whatWillTheyDo: 'Was wird diese Person im Konto tun?',
    permissionsHint: 'Berechtigungen für das GESAMTE Konto, nicht nur für die eigene Arbeit: Was diese Person ändert, sieht das ganze Team. Gespeichert wird nur, was Sie anpassen.',
    whatThisAllows: 'Was diese Berechtigung umfasst',
    scopeDocsViewAll: 'Sieht und verteilt ALLE Aufträge des Unternehmens, nicht nur die eigenen.',
    scopeDocsApprove: 'Genehmigt und schließt Aufträge des Kontos ab, auch solche, die er nicht bearbeitet hat. Ohne diese Berechtigung wird der Auftrag zur Prüfung gesendet und wer ihn abschließen darf, wird benachrichtigt.',
    scopeDocsDelete: 'Öffnet jeden Auftrag und löscht dessen Daten und Dateien; sie sind nicht wiederherstellbar.',
    scopeCorpusEdit: 'Korpus und Glossare gehören dem Unternehmen: Änderungen wirken auf die Übersetzungen des ganzen Teams.',
    scopeCertManage: 'Zertifikatsvorlagen gehören dem Unternehmen: Alle Mitglieder nutzen sie.',
    scopeBilling: 'Sieht das Guthaben und KAUFT Credits mit der Zahlungsmethode des Unternehmens.',
    scopeTeam: 'Lädt ein, aktiviert/deaktiviert und bearbeitet andere Kontomitglieder.',
    scopeAccountEdit: 'Ändert die Unternehmensdaten (Name, Firmenname, Steuernummer, Logo) für alle.',
    scopeLogs: 'Sieht die Aktivität ALLER Kontobenutzer, nicht nur die eigene.',
    scopeDocsCreate: 'Erstellt neue Aufträge im Konto; ihre Verarbeitung verbraucht die Credits des Unternehmens.',
    scopeCertAttach: 'Fügt dem fertigen Dokument das Übersetzungszertifikat des Unternehmens bei.',
    adjustedBadge: 'Angepasst',
    permDocsViewAll: 'Alle Dokumente ansehen und zuweisen',
    permDocsApprove: 'Aufträge genehmigen und abschließen',
    permDocsDelete: 'Dokumente löschen',
    permCorpusEdit: 'Korpus und Glossare bearbeiten',
    permCertManage: 'Zertifikatvorlagen bearbeiten',
    permBilling: 'Guthaben ansehen und kaufen',
    permTeam: 'Mitglieder einladen und deaktivieren',
    permAccountEdit: 'Unternehmensdaten bearbeiten',
    permLogs: 'Aktivitätsprotokoll ansehen',
    permDocsCreate: 'Aufträge erstellen',
    permCertAttach: 'Zertifikat beim Abschließen hinzufügen',
    readOnlyBadge: 'Nur Lesen',
    adjustedOne: 'angepasst',
    adjustedMany: 'angepasst',
    permCountOne: 'Berechtigung',
    permCountMany: 'Berechtigungen',
    edit: 'Bearbeiten',
    editMemberTitle: 'Mitglied bearbeiten',
    saveChanges: 'Änderungen speichern',
    saving: 'Speichern...',
    readOnlyLabel: 'Nur Lesen',
    readOnlyHint: 'Kann die Arbeit des Teams ansehen, aber nicht ändern.',
    firstNamePlaceholder: 'Max',
    lastNamePlaceholder: 'Mustermann',
    emailPlaceholder: 'kollege@firma.com',
  },
  creditsPage: {
    title: 'Credits',
    subtitle: 'Verwalten Sie Ihre Credits und Abrechnung',
    availableBalance: 'Verfügbares Guthaben',
    creditsInfo: 'Credits',
    usedThisMonth: 'Diesen Monat verwendet',
    totalPurchased: 'Insgesamt gekauft',
    yourSubscription: 'Ihr Abonnement',
    cancelSubscription: 'Abonnement kündigen',
    currentPlan: 'Aktueller Tarif',
    unknown: 'Unbekannt',
    subscriptionEnds: 'Abonnement endet',
    nextBillingDate: 'Nächstes Abrechnungsdatum',
    willNotRenew: 'Wird nicht verlängert',
    paymentMethod: 'Zahlungsmethode',
    change: 'Ändern',
    card: 'Karte',
    expiresDate: 'Läuft ab',
    autoRenew: 'Automatische Verlängerung',
    on: 'Ein',
    off: 'Aus',
    updating: 'Wird aktualisiert...',
    subscriptionEndingSoon: 'Abonnement endet bald',
    subscriptionEndingDesc:
      'Ihr Abonnement endet am {date}. Reaktivieren Sie es, um Ihre Vorteile zu behalten.',
    reactivateNow: 'Jetzt reaktivieren',
    cancelSubscriptionQ: 'Abonnement kündigen?',
    cancelSubscriptionDesc:
      'Möchten Sie Ihr <strong>{plan}</strong>-Abonnement wirklich kündigen? Sie behalten den Zugriff bis zum <strong>{date}</strong>.',
    keepSubscription: 'Abonnement behalten',
    yesCancel: 'Ja, kündigen',
    changePlanQ: 'Tarif wechseln?',
    newPlan: 'Neuer Tarif',
    changePlanDesc:
      'Sie zahlen <strong>{new}</strong> heute, und die Credits werden sofort nach der Zahlung Ihrem Guthaben gutgeschrieben, ohne auf die Verlängerung zu warten. Ihr aktueller Plan <strong>{current}</strong> bleibt bis zur Zahlung aktiv und wird nach der Zahlungsbestätigung gekündigt.',
    changePlan: 'Tarif wechseln',
    alreadySubscribed: 'Bereits abonniert',
    alreadySubscribedDesc:
      'Sie haben den <strong>{plan}</strong>-Tarif bereits abonniert.',
    gotIt: 'Verstanden',
    autoRechargeCredits: 'Automatische Credit-Aufladung',
    whenBalanceBelow: 'Bei Guthaben unter',
    credits: 'Credits',
    rechargeAmount: 'Aufladebetrag',
    autoRecharge: 'Automatische Aufladung',
    willAdd:
      'Es werden <strong>{amount} Credits</strong> hinzugefügt, wenn das Guthaben unter <strong>{threshold}</strong> fällt',
    autoRechargeDisabled: 'Automatische Aufladung ist deaktiviert',
    saveChanges: 'Änderungen speichern',
    saving: 'Wird gespeichert...',
    noPaymentMethod: 'Keine Zahlungsmethode hinterlegt',
    addPaymentMethodFirst:
      'Sie müssen zunächst eine Zahlungsmethode hinterlegen. Tätigen Sie einen Kauf oder abonnieren Sie einen Tarif, um die automatische Aufladung zu aktivieren.',
    addPaymentMethodForRenewal: 'Zahlungsmethode zur Verlängerung hinzufügen',
    addPaymentMethodTitle: 'Zahlungsmethode für die Verlängerung hinzufügen',
    addPaymentMethodForRenewalDesc:
      'Ihr Tarif ist in diesem Zeitraum aktiv. Hinterlegen Sie eine Karte, damit der nächste Abrechnungszyklus belastet werden kann — heute wird nichts berechnet.',
    pendingPaymentMethodStatus: 'Aktiv — Zahlungsmethode erforderlich',
    nextBillingAfterPaymentMethod: 'Nach Hinterlegung einer Karte',
    buyCreditPackages: 'Credit-Pakete kaufen',
    subscriptionRequiredToBuy: 'Für den Kauf von Credits ist ein aktives kostenpflichtiges Abonnement erforderlich. Wählen Sie einen Plan, um Käufe freizuschalten.',
    noPackagesAvailable: 'Keine Credit-Pakete verfügbar',
    mostPopular: 'Am beliebtesten',
    pricingFrom: 'Ab',
    contactSalesPrice: 'Individuell',
    buyNow: 'Jetzt kaufen',
    buyCustomAmount: 'Individuellen Betrag kaufen',
    buyCustomDesc:
      'Benötigen Sie eine bestimmte Menge? Geben Sie die gewünschte Anzahl an Credits ein (1 Credit = 1 USD)',
    enterCreditsMin: 'Credits eingeben (min. 10)',
    subscriptionPlans: 'Abonnement-Tarife',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    saveUpTo: 'Bis zu 20 % sparen',
    noPlansAvailable: 'Keine Abonnement-Tarife verfügbar',
    year: 'Jahr',
    month: 'Monat',
    orMonthly: 'oder ${price}/Monat bei monatlicher Abrechnung',
    orYearly: 'oder ${price}/Jahr (spare {discount} %)',
    creditsIncluded: '{n} Credits',
    noCreditsIncluded: 'Keine Credits enthalten',
    imageBasedPages: 'Bildbasierte Seiten',
    creditPerPage: '1 Credit / Seite',
    imageBasedDesc: 'Gescannte Dokumente, Bilder, PDFs mit OCR-Bedarf',
    textBasedPages: 'Textbasierte Seiten',
    textBasedDesc: 'Digitale PDFs und Dokumente mit Textebenen',
    transactionHistory: 'Transaktionsverlauf',
    noTransactions: 'Noch keine Transaktionen',
    noTransactionsFilter: 'Keine Transaktionen in diesem Zeitraum',
    showLess: 'Weniger anzeigen',
    txFilterAll: 'Alle',
    txFilterToday: 'Heute',
    txFilterWeek: 'Diese Woche',
    txFilterMonth: 'Diesen Monat',
    exportCSV: 'CSV exportieren',
    txCount: 'Transaktionen',
    txNet: 'Netto',
    purchased: '{n} Credits gekauft',
    used: '{n} Credits verwendet',
    subscriptionHelp: 'Abonnement-Tarife stellen monatlich oder jährlich eine feste Anzahl an Credits bereit, mit denen Sie Ihre Dokumente verarbeiten können. Diese Credits werden zu Beginn jedes Abrechnungszeitraums Ihrem Guthaben gutgeschrieben.',
    subscriptionHelpTitle: 'Über Abonnements',
    subscriptionHelpContent: 'Abonnement-Tarife stellen eine feste Anzahl an Credits bereit, die zu Beginn jedes Abrechnungszeitraums (monatlich oder jährlich) Ihrem Guthaben gutgeschrieben werden. Diese Credits können zur Verarbeitung von Dokumenten per OCR, Übersetzung und anderen Diensten genutzt werden.\n\nIhr Abonnement verlängert sich automatisch zum jeweiligen Abrechnungsdatum. Sie können jederzeit kündigen und behalten bis zum Ende des laufenden Zeitraums vollen Zugriff. Falls Sie mehr Credits benötigen als in Ihrem Tarif enthalten sind, können Sie zusätzliche Credit-Pakete kaufen oder die automatische Aufladung aktivieren.',
    autoRechargeHelp: 'Die automatische Aufladung fügt Ihrem Guthaben automatisch Credits hinzu, sobald es unter einen bestimmten Schwellenwert fällt – so gehen Ihnen bei der Dokumentenverarbeitung nie die Credits aus. Schwellenwert und Aufladebetrag können individuell angepasst werden.',
    autoRechargeHelpTitle: 'Über die automatische Aufladung',
    autoRechargeHelpContent: 'Die automatische Aufladung überwacht Ihr Credit-Guthaben und kauft automatisch zusätzliche Credits, wenn dieses unter den von Ihnen festgelegten Schwellenwert fällt. So ist eine unterbrechungsfreie Dokumentenverarbeitung ohne manuellen Eingriff gewährleistet.\n\nSie legen zwei Werte fest: den Mindestguthaben-Schwellenwert (ab wann aufgeladen wird) und den Aufladebetrag (wie viele Credits hinzugefügt werden). Ihre hinterlegte Zahlungsmethode wird bei jeder ausgelösten Aufladung automatisch belastet.',
    viewPlans: 'Abonnement-Tarife ansehen',
    close: 'Schließen',
    redeemCode: 'Aktionscode',
    redeemPlaceholder: 'Code eingeben',
    redeemApply: 'Einlösen',
    redeemApplying: 'Wird eingelöst…',
    redeemSuccess: 'Code eingelöst',
    redeemError: 'Der Code konnte nicht eingelöst werden',
    redeemHint: 'Ein Kampagnencode pro Konto, für immer. Hier für Trial-Extras einlösen. Kaufvorteile gelten automatisch an der Kasse.',
    redeemPreviewTrial: '{c} Bonus-Credits',
    redeemPreviewDiscount: '{p} % Rabatt auf den Planpreis bei Stripe',
    redeemPreviewDiscountMonths: ' für {n} Monate',
    redeemPreviewPurchase: '{x}x Credits, die im Plan enthalten sind',
    redeemApplied: '{code} wurde bereits eingelöst',
    redeemAppliedDiscount: 'Der Rabatt von {p}% ist bereits im Planpreis enthalten.',
    redeemAppliedMultiplier: 'Sie erhalten {x}x enthaltene Credits, wenn Sie einen Plan aktivieren.',
    redeemAppliedPacks: 'Credit-Pakete',
    redeemAppliedPlans: 'Tarife {plans}',
    redeemAppliedNone: 'Sie haben Ihre Einlösung bereits genutzt. Codes sind ein einmaliger Vorteil pro Konto.',
    planCardCodeDiscount: 'Preis mit Ihrem Code {code}: {p}% Rabatt',
    planCardCodeMultiplier: 'Ihr Code {code} vervielfacht die Plan-Credits um {x}x',
  },
  paywall: {
    teamTitle: 'Team ist im Team-Tarif enthalten',
    teamMessage: 'Sie müssen einen Team-Tarif aktivieren, um Mitglieder einzuladen und Ihr Team zu verwalten.',
    corpusTitle: 'Glossare sind im Team-Tarif enthalten',
    corpusMessage: 'Sie müssen einen Team-Tarif aktivieren, um Terminologiesätze zu erstellen und in Übersetzungen zu verwenden.',
    cta: 'Team-Tarif aktivieren',
    openingCheckout: 'Stripe wird geöffnet…',
  },
  planGate: {
    teamTitle: 'Aktivieren Sie einen Team-Tarif für Team',
    teamBody: 'Der Gratis-Tarif enthält keine Teamverwaltung. Wählen Sie Team, um Mitglieder einzuladen und zusammenzuarbeiten.',
    activityTitle: 'Aktivieren Sie einen Team-Tarif für die Teamaktivität',
    activityBody: 'Der Gratis-Tarif enthält keinen Team-Aktivitätsverlauf. Aktivieren Sie Team, um ihn freizuschalten.',
    activateTeamCta: 'Team-Tarif aktivieren',
    openingCheckout: 'Stripe wird geöffnet…',
    memberTitle: 'Ihr Team braucht einen Tarif',
    memberBody: 'Dieses Konto ist im Gratis-Tarif. Bitten Sie den Team-Admin, einen Tarif zu kaufen, damit Sie weiterarbeiten können.',
  },
  settingsPage: {
    unsavedTitle: "Sie haben ungespeicherte Änderungen",
    unsavedMessage: "Wenn Sie jetzt gehen, gehen die Änderungen auf dieser Seite verloren.",
    unsavedSaveAndLeave: "Speichern und verlassen",
    unsavedLeave: "Ohne Speichern verlassen",
    unsavedStay: "Hier bleiben",
    personalInfo: 'Persönliche Daten',
    personalInfoDesc: 'Grundlegende Kontoinformationen',
    whatsappAvailable: 'Auf WhatsApp erreichbar',
    dateFormat: 'Datumsformat',
    dateFormatHint: 'Für die Oberfläche. Zertifizierungen verwenden das Format des Ziellandes.',
    markerStyleLabel: 'Notation visueller Elemente',
    seccionEmpresa: 'Unternehmen',
    correoEmpresa: 'Firmen-E-Mail',
    telefonoEmpresa: 'Firmentelefon',
    seccionEmpresaDesc: 'Unternehmensdaten, vom ganzen Team geteilt',
    seccionPerfil: 'Profil',
    seccionPerfilDesc: 'Ihre persönlichen Daten und Einstellungen',
    managedByAgency: 'Von Ihrer Agentur verwaltet',
    usarLaDeLaEmpresa: 'Firmeneinstellung verwenden',
    perfilNoCargado: 'Ihr Profil konnte nicht geladen werden. Laden Sie die Seite neu, bevor Sie speichern.',
    markerStyleHint: 'Trennzeichenstil für Logos, Siegel und Unterschriften in Ihren Übersetzungen.',
    markerBrackets: 'Eckige Klammern',
    markerBraces: 'Geschweifte Klammern',
    interfaceLanguage: 'Sprache der Oberfläche',
    legalName: 'Firmenname',
    legalNamePlaceholder: 'Firmenname für Rechnungen',
    taxId: 'Steuer-ID',
    taxIdHint: 'Für Firmenrechnungen',
    website: 'Webseite',
    jobTitle: 'Ihre Position',
    jobTitlePlaceholder: 'CEO, Projektleiter...',
    linkedinCompanyPage: 'LinkedIn-Seite des Unternehmens',
    preferredContactMethod: 'Bevorzugte Kontaktmethode',
    preferredContactNone: 'Keine Präferenz',
    preferredContactCall: 'Anruf',
    emailVerifyBannerTitle: 'Bestätigen Sie Ihre E-Mail-Adresse',
    emailVerifyBannerDesc: 'Bestätigen Sie, dass dies Ihre E-Mail-Adresse ist:',
    emailVerifySendCode: 'Code senden',
    emailVerifySending: 'Senden…',
    emailVerifyCta: 'Bestätigen',
    emailVerifyVerifying: 'Wird überprüft…',
    emailVerifyError: 'Code konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
    title: 'Einstellungen',
    subtitle: 'Verwalten Sie Ihr Konto und Ihre Einstellungen',
    saveChanges: 'Änderungen speichern',
    saving: 'Wird gespeichert...',
    saved: 'Gespeichert!',
    profile: 'Profil',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    accountSection: 'Konto',
    companyName: 'Unternehmensname',
    changeLogo: 'Logo ändern',
    uploadLogo: 'Logo hochladen',
    uploading: 'Wird hochgeladen...',
    remove: 'Entfernen',
    notificationsSection: 'Benachrichtigungen',
    orderStatusUpdates: 'Auftragsstatus-Updates',
    orderStatusUpdatesDesc: 'Benachrichtigung bei Statusänderungen von Aufträgen',
    teamActivity: 'Teamaktivität',
    teamActivityDesc: 'Benachrichtigungen über Aktionen von Teammitgliedern',
    lowCreditAlerts: 'Warnmeldungen bei niedrigem Guthaben',
    lowCreditAlertsDesc: 'Benachrichtigung, wenn das Guthaben unter 50 Credits fällt',
    marketingEmails: 'Marketing-E-Mails',
    marketingEmailsDesc: 'Tipps, Produktneuheiten und Angebote',
    timezone: 'Zeitzone',
    timezoneDesc: 'Legen Sie Ihre Zeitzone fest, um Datum und Uhrzeit korrekt anzuzeigen.',
    current: 'Aktuell',
    security: 'Sicherheit',
    changePassword: 'Passwort ändern',
    sessions: 'Sitzungen',
    activeSession: '1 aktive Sitzung',
    signOutAllDevices: 'Von allen Geräten abmelden',
    billing: 'Abrechnung',
    currentPlan: 'Aktueller Tarif',
    payAsYouGo: 'Pay-as-you-go',
    noPlanActive: 'Kein aktiver Tarif',
    noPlanDesc: 'Wenden Sie sich an Ihren Unternehmensadministrator für den Tarifzugang',
    noPlanDescFreelancer: 'Credits kaufen, um mit dem Übersetzen zu beginnen',
    viewInvoices: 'Rechnungen ansehen',
    changePasswordModal: 'Passwort ändern',
    changePasswordDesc: 'Geben Sie Ihr aktuelles Passwort ein und wählen Sie ein neues.',
    currentPassword: 'Aktuelles Passwort',
    enterCurrentPassword: 'Aktuelles Passwort eingeben',
    newPassword: 'Neues Passwort',
    minChars: 'Mind. 8 Zeichen',
    confirmNewPassword: 'Neues Passwort bestätigen',
    confirmYourPassword: 'Passwort bestätigen',
    changingPassword: 'Passwort wird geändert...',
    passwordChanged: 'Passwort geändert!',
    passwordChangedDesc: 'Ihr Passwort wurde erfolgreich geändert.',
    done: 'Fertig',
    passwordsNoMatch: 'Die Passwörter stimmen nicht überein',
    passwordMinLength: 'Das Passwort muss mindestens 8 Zeichen lang sein',
    logoMaxSize: 'Das Logo darf nicht größer als 5 MB sein',
    logoFormatHint: 'JPG, PNG oder WEBP. Max. 5 MB.',
    helpTitle: 'Benötigen Sie Hilfe?',
    helpDesc: 'Unser Team steht Ihnen bei allen Fragen zur Verfügung.',
    helpEmail: 'Support kontaktieren',
    helpDocs: 'Dokumentation',
    privacyPolicy: 'Datenschutzerklärung',
    termsConditions: 'Allgemeine Geschäftsbedingungen',
    allRightsReserved: 'Alle Rechte vorbehalten.',
    // Privacy & Data Retention
    privacyRetention: 'Datenschutz & Datenspeicherung',
    privacyRetentionDesc: 'Konfigurieren Sie die automatische Löschung abgeschlossener Auftragsdaten nach einer Aufbewahrungsfrist.',
    retentionPolicy: 'Aufbewahrungsrichtlinie',
    retentionPolicyDesc: 'Abgeschlossene Aufträge werden nach dem gewählten Zeitraum automatisch gelöscht. Für jede Löschung wird ein KMS-signiertes Löschzertifikat erstellt.',
    retentionDisabled: 'Deaktiviert',
    retentionDays: '{n} Tage',
    retentionSaving: 'Wird gespeichert...',
    retentionSaved: 'Gespeichert!',
    retentionNone: 'Keine automatische Löschung',
    retentionDay: '{n} Tag',
    retentionDaysLabel: '{n} Tage',
    retentionWarning: 'Eine Änderung der Aufbewahrungsrichtlinie setzt alle ausstehenden Lösch-Timer für abgeschlossene Aufträge neu.',
    retentionImmediate: 'Sofort',
    retentionImmediateWarning: 'Wenn ein Auftrag abgeschlossen wird, werden alle zugehörigen Daten und Dateien sofort dauerhaft gelöscht. Als Nachweis wird ein Löschzertifikat erstellt.',
    retentionActive: 'Aktiv',
    retentionInactive: 'Inaktiv',
    deletionCertificates: 'Löschzertifikate',
    deletionCertificatesDesc: 'Kryptografisch signierte Zertifikate für gelöschte Aufträge anzeigen.',
    viewCertificates: 'Zertifikate anzeigen',
    noCertificates: 'Noch keine Löschzertifikate vorhanden.',
    downloadCertificate: 'PDF herunterladen',
    previewCertificate: 'Vorschau',
    // Timezone picker
    searchCity: 'Stadt suchen...',
    noResults: 'Keine Ergebnisse',
    // Deletion certificate detail modal
    certDetail: {
      certificateOne: 'Zertifikat',
      certificateMany: 'Zertifikate',
      backToList: 'Zurück zur Liste',
      order: 'Auftrag',
      document: 'Dokument',
      account: 'Konto',
      deletedAt: 'Gelöscht am',
      method: 'Methode',
      retention: 'Aufbewahrung',
      retentionDaysTpl: '{n} Tage',
      integrity: 'Integrität',
      valid: 'Gültig',
      invalid: 'Ungültig',
      deletedFilesTpl: 'Gelöschte Dateien ({n})',
      purgedFieldsTpl: 'Gelöschte Felder ({n})',
      prev: 'Zurück',
      next: 'Weiter',
    },
    professionalProfile: 'Berufsprofil',
    professionalProfileDesc: 'Informationen für Zertifikate und offizielle Dokumente',
    phone: 'Telefon',
    phonePlaceholder: '+1234567890',
    phoneHint: 'Internationales Format (E.164)',
    address: 'Adresse',
    addressPlaceholder: 'Stadt, Bundesland, Land',
    association: 'Berufsverband',
    associationNoneOption: 'Keiner',
    associationOther: 'Sonstiger',
    associationCustomLabel: 'Name des Verbands',
    certificationNumber: 'Zertifizierungs- / Mitgliedsnummer',
    languagePairs: 'Sprachpaare',
    languagePairsDesc: 'Ausgangs- und Zielsprachen, in die Sie übersetzen',
    addLanguagePair: 'Paar hinzufügen',
    sourceLanguage: 'Ausgangssprache',
    targetLanguage: 'Zielsprache',
    noLanguagePairs: 'Fügen Sie mindestens ein Sprachpaar hinzu',
    removePair: 'Entfernen',
    signatureImage: 'Unterschriftsbild',
    signatureHint: 'JPG oder PNG. Max. 2 MB.',
    signatureInvalidFormat: 'Die Unterschrift muss im JPG- oder PNG-Format vorliegen',
    signatureMaxSize: 'Das Unterschriftsbild darf nicht größer als 2 MB sein',
    uploadSignature: 'Unterschrift hochladen',
    changeSignature: 'Ändern',
    removeSignature: 'Entfernen',
    saveProfile: 'Profil speichern',
    adminAccount: 'Kontoadministrator',
    adminAccountDesc: 'Wichtigste Kontaktdaten des Kontos',
    role: 'Rolle',
    subStatusActive: 'Aktiv',
    subStatusTrialing: 'Testphase',
    subStatusPastDue: 'Zahlung überfällig',
    subStatusUnpaid: 'Unbezahlt',
    subStatusCanceled: 'Gekündigt',
    subStatusIncomplete: 'Unvollständig',
    subStatusPaused: 'Pausiert',
    searchCountry: 'Land suchen…',
    noCountriesFound: 'Keine Länder gefunden',
    companyWebsitePlaceholder: 'www.firma.com',
    companyEmailPlaceholder: 'kontakt@firma.com',
    personalWebsitePlaceholder: 'www.meineuebersetzung.com',
    linkedinProfilePlaceholder: 'ihr-profil',
  },
  certificatePage: {
    title: 'Zertifikat',
    subtitle: 'Dieses Zertifikat wird automatisch als letzte Seite jeder übersetzten PDF eingefügt',
    uploadDocx: '.docx hochladen',
    newTemplate: 'Neue Vorlage',
    editingTemplate: 'Zertifikatvorlage bearbeiten',
    variables: 'Variablen',
    saveAndClose: 'Speichern & Schließen',
    saving: 'Wird gespeichert...',
    insertVariable: 'Variable einfügen:',
    dynamicVariables: 'Dynamische Variablen',
    variablesDesc: 'Zum Kopieren anklicken · Diese werden im fertigen Zertifikat automatisch ersetzt',
    clickToCopy: 'Klicken Sie auf eine Variable, um sie in die Zwischenablage zu kopieren',
    hideExamples: 'Beispiele ausblenden',
    showExamples: 'Beispiele einblenden',
    defaultTemplates: 'Standardvorlagen',
    myTemplates: 'Meine Vorlagen',
    otherTemplates: 'Andere Vorlagen',
    setActive: 'Als aktiv setzen',
    active: 'Aktiv',
    global: 'Global',
    noTemplate: 'Keine Zertifikatvorlage',
    noTemplateDesc: 'Erstellen Sie eine Vorlage, um sie automatisch Ihren übersetzten PDFs hinzuzufügen',
    createTemplate: 'Vorlage erstellen',
    uploadTemplate: 'Vorlage hochladen',
    name: 'Name',
    namePlaceholder: 'z. B. Beglaubigte Übersetzung',
    descriptionOptional: 'Beschreibung (optional)',
    descriptionPlaceholder: 'Kurze Beschreibung dieser Vorlage...',
    category: 'Kategorie',
    general: 'Allgemein',
    legal: 'Rechtlich',
    immigration: 'Einwanderung',
    academic: 'Akademisch',
    cancel: 'Abbrechen',
    creating: 'Wird erstellt...',
    createAndEdit: 'Erstellen & Bearbeiten',
    opening: 'Wird geöffnet...',
    editTemplate: 'Vorlage bearbeiten',
    activateHint: 'Aktivieren Sie eine Vorlage, um sie Ihrer Sammlung hinzuzufügen',
    templateLibrary: 'Vorlagenbibliothek',
    willBeAppended: 'Dieses Zertifikat wird allen abgeschlossenen Aufträgen angehängt',
    language: 'Sprache',
    anyLanguage: 'Beliebige Sprache',
    english: 'Englisch',
    spanish: 'Spanisch',
    portuguese: 'Portugiesisch',
    german: 'Deutsch',
    french: 'Französisch',
    clickToRename: "Zum Umbenennen klicken",
    activeTemplate: "Aktive Vorlage",
    copyHint: "Zum Kopieren klicken → Strg+V",
    copiedHint: "✓ Kopiert! Drücken Sie jetzt Strg+V (oder Cmd+V) zum Einfügen",
    copyVarTitle: "Zum Kopieren klicken → {desc}",
    view: "Ansehen",
    all: "Alle",
    close: "Schließen",
    deleteTemplate: "Vorlage löschen",
  },
  orderDetail: {
    backToOrders: 'Zurück zu den Aufträgen',
    continueOrder: 'Auftrag fortsetzen',
    error: 'Fehler',
    orderNotFound: 'Auftrag nicht gefunden',
    failedToLoad: 'Auftrag konnte nicht geladen werden',
    orderDetails: 'Auftragsdetails',
    documentType: 'Dokumenttyp',
    category: 'Kategorie',
    sourceCountry: 'Herkunftsland',
    targetCountry: 'Zielland',
    sourceLanguage: 'Ausgangssprache',
    targetLanguage: 'Zielsprache',
    totalPages: 'Seiten gesamt',
    formatTemplate: 'Formatvorlage',
    noFormatTemplate: 'Original',
    credits: 'Credits',
    consumed: 'verbraucht',
    estimated: 'geschätzt',
    created: 'Erstellt',
    createdBy: 'Erstellt von',
    assignedTo: 'Zugewiesen an',
    completed: 'Abgeschlossen',
    exportFormat: 'Exportformat',
    originalFile: 'Originaldatei',
    view: 'Ansehen',
    openInNewTab: 'In neuem Tab öffnen',
    download: 'Herunterladen',
    close: 'Schließen',
    accessDenied: 'Zugriff verweigert',
    adminNoAccess: 'Plattformadministratoren können aus Sicherheits- und Datenschutzgründen keine Dokumentinhalte einsehen. Nur Kontoinhaber, Mitglieder und Freiberufler haben Zugriff auf Dokumente.',
    translatedDocument: 'Übersetztes Dokument',
    finalDocument: 'Gestaltetes Dokument',
    deletionCertificate: 'Löschzertifikat',
    translationCertificate: 'Übersetzungszertifikat',
    fileDeleted: 'Diese Datei wurde gelöscht',
    sizeUnknown: 'Größe unbekannt',
    uploadAndDetails: 'Hochladen & Details',
    ocr: 'OCR',
    review: 'Prüfung',
    final: 'Abschluss',
    deleteData: 'Daten löschen',
    deleteOrderData: 'Auftragsdaten löschen',
    deleteOrderDesc: 'Alle Dateien (hochgeladene und fertige) werden dauerhaft gelöscht für:',
    deleteOrderPreserved: 'Der Auftragsdatensatz und das Löschzertifikat bleiben erhalten. Diese Aktion kann nicht rückgängig gemacht werden.',
    cancel: 'Abbrechen',
    dataDeletedSuccess: 'Daten erfolgreich gelöscht',
    dataDeletedFailed: 'Daten konnten nicht gelöscht werden',
    certificateLabel: 'Zertifikat',
    // Human verification
    humanVerified: 'Menschlich verifiziert',
    verify: 'Übersetzung verifizieren',
    verifyConfirmTitle: 'Übersetzung verifizieren',
    verifyConfirmDesc: 'Sie bestätigen hiermit, dass diese Übersetzung von einem menschlichen Übersetzer geprüft und genehmigt wurde. Diese Aktion fügt dem Dokument ein Verifikationssiegel hinzu.',
    verifyNotes: 'Notizen (optional)',
    verifySuccess: 'Übersetzung erfolgreich verifiziert',
    verifyFailed: 'Verifizierung der Übersetzung fehlgeschlagen',
    verifiedBy: 'Verifiziert von',
    verifiedOn: 'Verifiziert am',
    viewVerification: 'Öffentliche Verifizierung anzeigen',
    // Data purged / deletion box
    dataPurged: 'Daten gelöscht',
    loadingCertificate: 'Zertifikat wird geladen...',
    allDataDeleted: 'Alle Dateien und sensiblen Daten wurden dauerhaft gelöscht.',
    filesDeletedTpl: '{n} Dateien gelöscht',
    autoPurgeNoticeTpl: 'Automatische Löschung aktiviert — Dateien werden {time} nach Abschluss automatisch gelöscht',
    retentionMin: 'Min.',
    retentionHour: 'Stunde',
    retentionHours: 'Stunden',
    retentionDay: 'Tag',
    retentionDays: 'Tage',
    inTrashBanner: 'Dieser Auftrag befindet sich im Papierkorb. Er wird am {date} endgültig gelöscht.',
    restoreOrder: 'Auftrag wiederherstellen',
    readOnlyNotice: 'Ihr Zugang ist schreibgeschützt: Sie können den Auftrag ansehen, aber nicht weiterbearbeiten',
    finalizationPendingApprover: '{name} hat am {date} gebeten, diesen Auftrag abzuschließen.',
    reviewAndFinalize: 'Prüfen und abschließen',
    returnToRequester: 'Zurückgeben',
    returnNotePlaceholder: 'Was korrigiert werden muss (optional)',
    returnConfirm: 'Auftrag zurückgeben',
    returnFailed: 'Der Auftrag konnte nicht zurückgegeben werden. Bitte versuchen Sie es erneut.',
    finalizationPendingRequester: 'Am {date} zur Prüfung gesendet. Wer ihn abschließen darf, wurde benachrichtigt.',
    finalizationReturned: '{name} hat den Auftrag am {date} zurückgegeben.',
    finalizationReturnedNote: 'Hinweis: „{note}“',
    someoneFromTeam: 'Ein Teammitglied',
    // Localized document type & category labels
    documentTypes: { image: 'Bild', text: 'Text', handwritten: 'Handschriftlich' },
    categories: {
      birth_certificate: 'Geburtsurkunde',
      certificate: 'Bescheinigung',
      diploma: 'Diplom',
      passport: 'Reisepass',
      marriage_license: 'Heiratsurkunde',
      medical: 'Krankenakte',
      legal: 'Rechtsdokument',
      immigration: 'Einwanderungsformular',
      other: 'Sonstiges',
      academic_transcript: 'Notenübersicht',
      civil_registry: 'Personenstandsregister',
      death_certificate: 'Sterbeurkunde',
      power_of_attorney: 'Vollmacht',
      general: 'Allgemein',
    },
  },
  workspace: {
    title: 'Mein Arbeitsbereich',
    welcomeBack: 'Willkommen zurück, {name}. Sie haben {n} zugewiesene Aufgaben.',
    welcomeBackOne: 'Willkommen zurück, {name}. Sie haben {n} zugewiesene Aufgabe.',
    welcomeBackOther: 'Willkommen zurück, {name}. Sie haben {n} zugewiesene Aufgaben.',
    assigned: 'Zugewiesen',
    tasksToComplete: 'Zu erledigende Aufgaben',
    active: 'Aktiv',
    inProgress: 'In Bearbeitung',
    completed: 'Abgeschlossen',
    thisMonth: 'Diesen Monat',
    pendingTasks: 'Ausstehende Aufgaben',
    pendingTasksDesc: 'Aufträge, die Ihre Prüfung und Bearbeitung erfordern',
    noOrdersAssigned: 'Noch keine Aufträge zugewiesen',
    ordersWillAppear: 'Aufträge werden hier angezeigt, sobald sie Ihnen zugewiesen werden.',
    page: 'Seite',
    pages: 'Seiten',
    workflowTip: 'Workflow-Hinweis',
    workflowTipDesc: 'Jeder Auftrag folgt einem Workflow: <strong>Hochladen → OCR-Prüfung → Übersetzung → Abschluss</strong>. Sie müssen jeden Schritt prüfen und bestätigen, bevor Sie zum nächsten übergehen können.',
    startOrder: 'Auftrag starten',
    continueAction: 'Fortsetzen',
    reviewAction: 'Prüfen',
    viewAction: 'Ansehen',
    myOrders: 'Meine Aufträge',
    myOrdersSubtitle: 'Alle Ihnen zugewiesenen Aufträge',
    searchPlaceholder: 'Aufträge suchen...',
    totalAssigned: 'Insgesamt zugewiesen',
    noOrdersFound: 'Keine Aufträge gefunden',
    ordersAssignedAppear: 'Ihnen zugewiesene Aufträge werden hier angezeigt.',
    document: 'Dokument',
    pagesCol: 'Seiten',
    languages: 'Sprachen',
    status: 'Status',
    createdCol: 'Erstellt',
    action: 'Aktion',
    pageOf: 'Seite {p} von {total}',
    orders: 'Aufträge',
    creditPackages: 'Credit-Pakete',
    purchaseCreditsDesc: 'Credits kaufen, um Ihre Dokumente zu verarbeiten',
    viewAll: 'Alle anzeigen',
    uploadPhoto: 'Foto hochladen',
    managePreferences: 'Kontoeinstellungen verwalten',
    notifications: 'Benachrichtigungen',
    newTaskAssignments: 'Neue Aufgabenzuweisungen',
    newTaskAssignmentsDesc: 'Benachrichtigung erhalten, wenn Ihnen eine neue Aufgabe zugewiesen wird',
    taskDeadlines: 'Aufgabenfristen',
    taskDeadlinesDesc: 'Erinnerungen für bevorstehende Fristen',
    commentsAndFeedback: 'Kommentare und Feedback',
    commentsAndFeedbackDesc: 'Benachrichtigungen, wenn jemand Ihre Arbeit kommentiert',
    dailySummary: 'Tägliche Zusammenfassung',
    dailySummaryDesc: 'Eine tägliche Zusammenfassung Ihrer Aufgaben erhalten',
    account: 'Konto',
    organization: 'Organisation',
    role: 'Rolle',
    yourStats: 'Ihre Statistiken',
    tasksCompleted: 'Erledigte Aufgaben',
    pagesTranslated: 'Übersetzte Seiten',
    avgQualityScore: 'Durchschn. Qualitätswert',
    loadError: 'Ihre Aufträge konnten nicht geladen werden. Bitte versuchen Sie es in einigen Sekunden erneut.',
  },
  newOrder: {
    loadingOrder: 'Auftrag wird geladen...',
    restoreProgress: 'Bitte warten, während Ihr Fortschritt wiederhergestellt wird',
    stepProgress: 'Schritt {step} von {total}',
    stepUploadDetails: 'Hochladen & Details',
    stepProcessing: 'Verarbeitung',
    stepReview: 'Prüfung',
    stepTranslation: 'Übersetzung',
    stepDownload: 'Herunterladen',
    modeLabel: 'Modus',
    modeTranslate: 'Übersetzen',
    modeLayout: 'Layout',
    modeTranslateHint: 'Übersetzt das Dokument in eine andere Sprache, mit Zertifizierung.',
    modeLayoutHint: 'Nur Layout: rekonstruiert das Dokument in seiner Originalsprache, ohne Übersetzung.',
    layoutReadyTitle: 'Dokument bereit',
    layoutReadyDesc: 'Ihr gesetztes Dokument steht zum Download in der Originalsprache bereit.',
    downloadDocument: 'Dokument herunterladen',
    preparingDownload: 'Wird vorbereitet…',
    error: 'Fehler',
    uploadDocument: 'Dokument hochladen',
    acceptedFileTypes: 'PDF, Word (DOC, DOCX), JPG, PNG, TIFF, WebP',
    analyzingDocument: 'Dokument wird analysiert...',
    classifyingDocument: 'Dokument wird klassifiziert...',
    loadingPreview: 'Vorschau wird geladen...',
    fileTypePdf: 'PDF',
    fileTypeWord: 'Word',
    docxTooLargeToCount: 'Zu groß zum automatischen Zählen der Seiten — bitte prüfen',
    fileTypeImage: 'Bild',
    page: 'Seite',
    pages: 'Seiten',
    hasText: 'Enthält Text',
    scanned: 'Gescannt',
    fileAnalysis: 'Dateianalyse',
    complete: 'Abgeschlossen',
    textLabel: 'Text:',
    selectable: 'Auswählbar',
    methodLabel: 'Methode:',
    ocrMethod: 'OCR (1 Cr./S.)',
    directMethod: 'Direkt (1 Cr./S.)',
    paperLetter: "Letter",
    paperA4: "A4",
    paperLegal: "Legal",
    paperPortrait: "Hochformat",
    paperLandscape: "Querformat",
    handwritten: 'Handschriftlich',
    mixedContent: 'Gemischt (gedruckt + handschriftlich)',
    disableHandwritten: 'Klicken, um als gescanntes Bild zu verarbeiten',
    enableHandwritten: 'Klicken, um den Handschrift-Modus wiederherzustellen',
    manuscriptSuggestionTitle: 'Das scheint ein gescanntes Bild zu sein',
    manuscriptSuggestionBody: 'Für das sauberste Ergebnis verwenden Sie den Manuskript-Modus. Er wandelt Ihr Dokument in klaren, bearbeitbaren Text mit originalgetreuem Layout um. Wenn Sie ihn überspringen, wird der Text über das gescannte Bild gelegt, was gröber wirkt und schwerer zu bearbeiten ist.',
    manuscriptSuggestionConfirm: 'Manuskript-Modus verwenden',
    manuscriptSuggestionDismiss: 'Ohne diesen Modus fortfahren',
    manuscriptSuggestionBadge: 'Empfohlen',
    pageFormat: 'Papierformat',
    pageFormatLetter: 'Letter',
    pageFormatLegal: 'Legal',
    orientationLabel: 'Ausrichtung',
    orientationPortrait: 'Hochformat',
    orientationLandscape: 'Querformat',
    orientationSuggested: 'vorgeschlagen',
    readAloud: 'Vorlesen',
    stopReading: 'Stopp',
    loadingAudio: 'Wird geladen...',
    viewTranscript: 'Transkript anzeigen',
    transcriptTitle: 'Transkribierter Text',
    copyText: 'Kopieren',
    transcribingHandwriting: 'Handschrift wird transkribiert...',
    readingHandwriting: 'Handschrift wird per KI gelesen...',
    processingPages: 'Seiten werden verarbeitet...',
    generatingDocument: 'Dokument wird erstellt...',
    clientName: 'Kundenname',
    clientNamePlaceholder: 'z. B. Max Mustermann',
    reference: 'Reference #',
    dueDate: 'Fälligkeitsdatum',
    addInstructions: '+ Anweisungen hinzufügen',
    detailsSection: 'Details',
    languagesSection: 'Sprachen & Lokalisierung',
    teamSection: 'Team',
    documentName: 'Dokumentname',
    documentNamePlaceholder: 'z. B. Geburtsurkunde - Müller',
    documentCategory: 'Dokumentkategorie',
    sourceCountry: 'Herkunftsland',
    targetCountry: 'Zielland',
    sourceLanguage: 'Ausgangssprache',
    targetLanguage: 'Zielsprache',
    chooseTargetLanguage: 'Sprache wählen',
    targetLanguageRequired: 'Wählen Sie die Zielsprache, um fortzufahren',
    searchLanguage: 'Sprache suchen…',
    searchCountry: 'Land suchen…',
    noSearchResults: 'Keine Ergebnisse',
    sameLanguageBlocked: 'Die Zielsprache ist dieselbe wie die Ausgangssprache, es gibt also nichts zu übersetzen. Überprüfen Sie die Zielsprache des Auftrags.',
    autoDeleteLabel: 'Dateien automatisch löschen nach',
    autoDeleteAccountDefault: 'Kontostandard verwenden',
    autoDeleteImmediate: 'Sofort',
    autoDelete20min: '20 Minuten',
    autoDelete1h: '1 Stunde',
    autoDelete6h: '6 Stunden',
    autoDelete1d: '1 Tag',
    autoDelete7d: '7 Tage',
    autoDelete30d: '30 Tage',
    autoDelete90d: '90 Tage',
    estimatedCredits: 'Geschätzte Credits',
    creditCalculation: '1 Credit pro Seite × {pages}',
    assignToTeamMember: 'Teammitglied zuweisen',
    notAssigned: 'Nicht zugewiesen',
    notesInstructions: 'Notizen / Anweisungen',
    teamNotesPlaceholder: 'Anweisungen für das zugewiesene Teammitglied hinzufügen...',
    assigning: 'Wird zugewiesen...',
    analyzing: 'Wird analysiert...',
    assignNotify: 'Zuweisen & Benachrichtigen',
    questionOnPage: 'Seite',
    questionNoPosition: 'nicht verortet',
    fileTooLargeDetail: 'Das Dokument ist {size} groß, erlaubt sind höchstens {max}. Teilen Sie es auf oder verwenden Sie eine kleinere Fassung und versuchen Sie es erneut.',
    unsupportedFileDetail: 'Unterstützte Formate: PDF, Word (.doc, .docx) und Bilder (JPG, PNG, TIFF, WEBP).',
    uploadingOriginal: 'Dokument wird hochgeladen…',
    uploadFailedMessage: 'Der Auftrag wurde erstellt und zugewiesen, aber das Dokument konnte nicht hochgeladen werden. Bitte erneut versuchen; wenn es weiterhin fehlschlägt, prüfen Sie Ihre Verbindung.',
    retryUpload: 'Upload wiederholen',
    originalUploadFailed: 'Die Datei konnte nicht hochgeladen werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
    originalIncomplete: 'Die Datei ist nicht vollständig angekommen. Bitte laden Sie sie erneut hoch.',
    originalMissingTitle: 'Datei erneut auswählen',
    originalMissingMessage: 'Die Datei dieses Auftrags wurde nicht gefunden. Wählen Sie „{name}“ ({size}) erneut aus, um fortzufahren; Ihre übrigen Angaben bleiben erhalten.',
    originalMissingShort: 'Diesem Auftrag fehlt die Datei. Wählen Sie sie erneut aus, um fortzufahren.',
    originalDamaged: 'Die Datei konnte nicht gelesen werden: Sie scheint beschädigt oder passwortgeschützt zu sein. Speichern Sie sie ohne Passwort erneut und laden Sie sie noch einmal hoch.',
    originalDifferentFile: 'Das ist nicht die Datei dieses Auftrags, daher wird damit ein neuer Auftrag begonnen.',
    originalCopyPendingTitle: 'Kopie des Originals ausstehend',
    originalCopyPending: 'Wir konnten keine Kopie des Originals speichern; wir arbeiten mit Ihrem Dokument weiter und versuchen erneut, sie zu speichern.',
    startOrder: 'Auftrag starten',
    analyzeContinue: 'Analysieren & Fortfahren',
    documentPreview: 'Dokumentvorschau',
    wordDocument: 'Word-Dokument',
    contentPreview: 'Inhaltsvorschau:',
    noPreviewAvailable: 'Keine Vorschau verfügbar',
    processing: 'Wird verarbeitet...',
    resumingProcessing: 'Verarbeitung wird fortgesetzt...',
    convertingDocument: 'Dokument wird konvertiert...',
    generatingPreview: 'Vorschau wird erstellt...',
    editDocument: 'Dokument bearbeiten',
    viewOriginal: 'Original ansehen',
    saving: 'Wird gespeichert...',
    backToReview: 'Zurück zur Prüfung',
    originalDocument: 'Originaldokument',
    back: 'Zurück',
    exitOrderTitle: 'Bestellung verlassen?',
    exitOrderMessage: 'Sie kehren zur Bestellliste zurück. Ihr Fortschritt wird gespeichert — Sie können diese Bestellung jederzeit fortsetzen.',
    exitOrderConfirm: 'Ja, verlassen',
    exitOrderCancel: 'Bei der Bestellung bleiben',
    documentReview: 'Dokumentprüfung',
    of: 'von',
    stopAutoscroll: 'Automatisches Scrollen stoppen',
    autoscroll: 'Automatisches Scrollen',
    translating: 'Wird übersetzt...',
    loadingOriginal: 'Original wird geladen...',
    loadingShort: 'Wird geladen...',
    downloadDocx: 'DOCX herunterladen',
    closeOrderTitle: 'Auftrag abschließen?',
    closeOrderDesc: 'Sie haben das gesetzte Dokument bereits heruntergeladen. Sie können den Auftrag hier abschließen, ohne zur Übersetzung zu gehen, damit er nicht offen bleibt.',
    closeOrderYes: 'Auftrag abschließen',
    closeOrderNo: 'Im Auftrag bleiben',
    closeOrderFailed: 'Der Auftrag konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
    closeOrderSaving: 'Dokument wird gespeichert…',
    reflowPagesBtn: 'Seiten neu umbrechen',
    reflowPagesError: 'Die Seiten konnten nicht neu umbrochen werden. Bitte erneut versuchen.',
    rotatePage: "Dokument drehen",
    prevPage: "Vorherige Seite",
    nextPage: "Nächste Seite",
    dropHere: "Dokument hierher ziehen und ablegen",
    clickBrowse: "oder klicken, um es auf dem Computer auszuwählen",
    selectFile: "Datei auswählen",
    supportedLabel: "Unterstützt",
    progressMessages: {
      "Converting PDF to editable format...": "PDF wird in ein bearbeitbares Format konvertiert\u2026",
      "Creating order...": "Auftrag wird erstellt\u2026",
      "Loading manuscript...": "Manuskript wird geladen\u2026",
      "Loading order...": "Auftrag wird geladen\u2026",
      "Loading preview...": "Vorschau wird geladen\u2026",
      "Resuming processing...": "Verarbeitung wird fortgesetzt\u2026",
      "Generating preview...": "Vorschau wird erstellt\u2026",
      "Converting document...": "Dokument wird konvertiert\u2026",
      "Preparing document...": "Dokument wird vorbereitet\u2026",
      "Converting document to base64...": "Datei wird vorbereitet\u2026",
      "Applying crop...": "Zuschnitt wird angewendet\u2026",
      "Saving order details...": "Details werden gespeichert\u2026",
      "Uploading file to cloud storage...": "Datei wird hochgeladen\u2026",
      "Analyzing document structure...": "Struktur wird analysiert\u2026",
      "Complete! Loading results...": "Fertig! Ergebnisse werden geladen\u2026",
      "Finalizing...": "Wird abgeschlossen\u2026",
      "Almost ready...": "Fast fertig\u2026",
      "Exporting images and formats...": "Bilder und Formate werden exportiert\u2026",
      "Analyzing document...": "Dokument wird analysiert\u2026",
      "OCR complete! Deducting credits...": "OCR abgeschlossen, Credits werden abgezogen\u2026",
      "Processing complete! Loading results...": "Verarbeitung abgeschlossen, wird geladen\u2026",
      "Extracting text and formatting...": "Text und Formatierung werden extrahiert\u2026",
      "Detecting document styles...": "Stile werden erkannt\u2026",
      "Analyzing paragraphs...": "Abs\u00e4tze werden analysiert\u2026",
      "Merging text blocks...": "Textbl\u00f6cke werden zusammengef\u00fchrt\u2026",
      "Optimizing layout...": "Layout wird optimiert\u2026",
      "Finalizing document structure...": "Struktur wird abgeschlossen\u2026",
      "OCR complete, assembling result...": "OCR abgeschlossen, Ergebnis wird zusammengesetzt\u2026",
      "Deducting credits, almost ready...": "Credits werden abgezogen, fast fertig\u2026",
      "Converting to editable format...": "Wird in ein bearbeitbares Format konvertiert\u2026",
      "Processing document layout...": "Dokumentlayout wird verarbeitet\u2026",
      "Running OCR engines...": "OCR-Engines werden ausgef\u00fchrt\u2026",
      "Running text extraction...": "Text wird extrahiert\u2026",
      "Processing with OCR engines...": "Verarbeitung mit OCR-Engines\u2026",
      "Detecting text styles...": "Textstile werden erkannt\u2026",
      "Finalizing results...": "Ergebnisse werden abgeschlossen\u2026",
    } as Record<string, string>,
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    fitToWidth: 'An Breite anpassen',
    pdfPreviewError: 'PDF-Vorschau konnte nicht geladen werden',
    continueToTranslation: 'Zur Übersetzung fortfahren',
    panelOriginal: 'ORIGINAL',
    panelPreview: 'VORSCHAU',
    edit: 'Bearbeiten',
    previewNotAvailable: 'Vorschau nicht verfügbar',
    ocrResultsComparison: 'OCR-Ergebnisse – Visueller Vergleich',
    textBlocksDetected: 'Textblöcke erkannt',
    accuracy: 'Genauigkeit',
    backToComparison: 'Zurück zum Vergleich',
    editTranslation: 'Übersetzung bearbeiten',
    translation: 'Übersetzung',
    panelTranslation: 'ÜBERSETZUNG',
    updatingPreview: 'Vorschau wird aktualisiert...',
    translationPreviewNotAvailable: 'Übersetzungsvorschau nicht verfügbar',
    finishOrder: 'Auftrag abschließen',
    orderCompleted: 'Auftrag abgeschlossen!',
    orderDownloaded: 'Ihr übersetztes Dokument wurde heruntergeladen.',
    orderDownloadedLayout: 'Ihr gestaltetes Dokument wurde heruntergeladen.',
    redirecting: 'Weiterleitung...',
    finishOrderDesc: 'Diese Übersetzung herunterladen und abschließen',
    finishOrderDescLayout: 'Ihr gestaltetes Dokument herunterladen',
    document: 'Dokument',
    exportFormat: 'Exportformat',
    formatPdf: 'PDF',
    formatOdt: 'ODT (bearbeitbarer Text)',
    translationLabel: 'Übersetzung',
    autoLanguage: 'Automatisch',
    creditsToCharge: 'Abzuziehende Credits',
    creditsCharged: 'Verbrauchte Credits',
    currentBalanceLabel: 'Aktueller Kontostand: {balance} Credits. Beim OCR-Review abgebucht.',
    credits: 'Credits',
    creditBalance: 'Ihr Guthaben: {balance} Credits. Nach Abschluss: {remaining} Credits.',
    cancel: 'Abbrechen',
    downloadComplete: 'Herunterladen & Abschließen',
    insufficientCredits: 'Nicht genügend Credits',
    insufficientCreditsDesc: 'Dieser Auftrag benötigt {required} Credits und Sie haben derzeit {available}. Um ihn abzuschließen, kaufen Sie mehr Credits oder führen Sie ein Upgrade durch.',
    insufficientCreditsDescOne: 'Dieser Auftrag benötigt {required} Credit und Sie haben derzeit {available}. Um ihn abzuschließen, kaufen Sie mehr Credits oder führen Sie ein Upgrade durch.',
    creditsNeeded: 'Benötigte Credits:',
    yourBalance: 'Ihr Guthaben:',
    shortfall: 'Fehlbetrag:',
    buyCredits: 'Credits kaufen',
    upgradePlan: 'Tarif upgraden',
    bestValue: 'Bestes Angebot',
    contactOwner: 'Wenden Sie sich an Ihren Kontoinhaber, um weitere Credits hinzuzufügen.',
    preparingTexts: 'Texte werden für die Übersetzung vorbereitet...',
    translatingBlocks: '{count} Blöcke werden übersetzt...',
    translatingBlocksOne: '{count} Block wird übersetzt...',
    applyingTranslations: 'Übersetzungen werden angewendet...',
    includeCertificate: 'Zertifikat einschließen',
    savingDocument: 'Dokument wird gespeichert...',
    autosavePending: 'Nicht gespeicherte Änderungen',
    autosaveSaving: 'Wird gespeichert…',
    autosaveSaved: 'Gespeichert',
    autosaveError: 'Speichern fehlgeschlagen, neuer Versuch',
    translatingProgress: 'Wird übersetzt... ({completed}/{total})',
    generatingTranslatedPreview: 'Vorschau wird erstellt...',
    finalizingTranslation: 'Wird abgeschlossen...',
    translationFailed: 'Das Dokument konnte nicht übersetzt werden. Bitte versuchen Sie es in ein paar Minuten erneut.',
    wordSinTexto: 'Dieses Word-Dokument hat keinen bearbeitbaren Text (Zeichnung oder Schriften ohne Zeichentabelle): Verwenden Sie Option 2.',
    translationPartialTitle: 'Einige Optionen wurden nicht übersetzt',
    translationPartialMessage: 'Angezeigt werden die Optionen, die übersetzt wurden.',
    yes: 'Ja',
    no: 'Nein',
    protectPdf: 'Digitale Signatur & Schutz',
    protectPdfHint: 'Deaktivieren, wenn Sie mit Ihrem eigenen Token signieren',
    outputOptions: 'Ausgabeoptionen',
    certificateTemplate: 'Zertifikat',
    selectTemplate: 'Vorlage auswählen',
    noTemplates: 'Keine Vorlagen in dieser Kategorie',
    addTemplate: 'Vorlagen verwalten',
    humanVerifiedSeal: 'Siegel „Menschlich verifiziert"',
    attachOriginal: 'Originaldokument anhängen',
    attachOriginalHint: 'Fügt die hochgeladene Datei vor oder nach der Übersetzung an',
    attachOriginalPosition: 'Position des Originals',
    attachOriginalAtStart: 'Am Anfang',
    attachOriginalAtEnd: 'Am Ende',
    downloadPdf: 'PDF herunterladen',
    downloadDoc: 'DOC herunterladen',
    reviewDocument: 'Dokument prüfen',
    chooseFormat: 'Format wählen',
    optionWord: 'Option 1',
    optionHtml: 'Option 2',
    optionMix: 'Option 3',
    optionFormat: 'Option 4',
    optionFormatHint: 'Option 2 mit der Formatvorlage des Auftrags',
    optionFormatImages: 'Bilder',
    docHeaderLabel: 'DOKUMENTKOPF — wird auf jeder Seite des Word/PDF wiederholt',
    docFooterLabel: 'DOKUMENTFUSS — wird auf jeder Seite des Word/PDF wiederholt',
    panelTranscription: 'TRANSKRIPTION',
    hideEditorToolbar: 'Bearbeitungsleiste ausblenden',
    showEditorToolbar: 'Bearbeitungsleiste einblenden',
    verifyDocumentTitle: 'Dokument verifizieren',
    verifyDocumentDesc: 'Prüfen Sie das Originaldokument auf der linken Seite und bestätigen Sie die Felder auf der rechten Seite',
    verificationLabel: 'Verifizierung',
    correctionPlaceholder: 'Korrektur hier eingeben...',
    detectedLabel: 'Erkannt',
    hidePin: 'Markierung im Dokument ausblenden',
    showPin: 'Markierung im Dokument anzeigen',
    editedIndicator: 'Bearbeitet',
    skip: 'Überspringen',
    confirm: 'Bestätigen',
    localizationNoticeTitle: 'Datums- und Zahlenformate an das Zielland anpassen',
    localizationNoticeIntro: 'Zielland: {country}. Dort werden Datums- und Zahlenangaben anders geschrieben — auf Wunsch passen wir sie an, damit sie sich dort selbstverständlich lesen.',
    localizationNoticeSummaryTpl: 'Wir haben {items} gefunden.',
    localizationNoticeSummaryAnd: 'und',
    localizationNoticeDatesOne: '1 Datumsangabe',
    localizationNoticeDatesMany: '{n} Datumsangaben',
    localizationNoticeFiguresOne: '1 Zahl',
    localizationNoticeFiguresMany: '{n} Zahlen',
    localizationNoticeExamplesTitle: 'So würde es aussehen',
    localizationNoticeChecking: 'Dokument wird geprüft…',
    localizationNoticeMoreTpl: 'und {n} weitere Vorkommen',
    localizationNoticeTimesMany: '{n}-mal',
    localizationNoticeTypeDate: 'Datum',
    localizationNoticeTypeFigure: 'Zahl',
    localizationNoticeSafeTitle: 'Das bleibt unverändert:',
    localizationNoticeSafeBody: 'Ausweis- und Telefonnummern sowie Gesetzesangaben und Aktenzeichen werden Ziffer für Ziffer genau so übernommen wie im Original.',
    localizationNoticeAdapt: 'Anpassen',
    localizationNoticeKeep: 'Original beibehalten',
    localizationNoticeRemember: 'In diesem Konto nicht mehr fragen',
    localizationNoticeRememberHint: 'Ihre Auswahl wird als Standard für das Konto gespeichert.',
    localizationNoticeClose: 'Schließen',
    localizationNoticeIdsLabel: 'Ausweis- und Kennnummern',
    localizationNoticeIdsOne: '1 Kennnummer',
    localizationNoticeIdsMany: '{n} Kennnummern',
    localizationNoticeIdsUnchanged: 'Unverändert',
    localizationNoticeShowExamples: 'Beispiele anzeigen',
    localizationNoticeHideExamples: 'Beispiele ausblenden',
    noCreatePermissionTitle: 'Sie können keine Aufträge erstellen',
    noCreatePermissionDesc: 'Ihre Rolle in diesem Konto umfasst die Berechtigung „Aufträge erstellen“ nicht. Bitten Sie den Inhaber oder einen Manager, sie zu aktivieren. Sie können weiter an den Ihnen zugewiesenen Aufträgen arbeiten.',
    goToMyOrders: 'Zu meinen Aufträgen',
    finishNoPermissionTitle: 'Sie haben keine Berechtigung zum Abschließen',
    finishNoPermissionDesc: 'Zur Prüfung senden? Wir benachrichtigen den Inhaber und alle, die Aufträge abschließen dürfen, damit sie ihn prüfen und abschließen.',
    finishReadOnlyDesc: 'Ihr Zugang zu diesem Konto ist schreibgeschützt: Sie können den Auftrag ansehen, ihn aber weder abschließen noch zur Prüfung senden.',
    sendForReview: 'Zur Prüfung senden',
    sendingForReview: 'Wird gesendet…',
    reviewRequestSent: 'Auftrag zur Prüfung gesendet. Wer ihn abschließen darf, wurde benachrichtigt.',
    reviewRequestSentNoNotice: 'Auftrag zur Prüfung gesendet. Die Benachrichtigungen konnten gerade nicht verschickt werden; wer ihn abschließen darf, sieht es beim Öffnen des Auftrags.',
    reviewAlreadyPending: 'Dieser Auftrag wartet seit dem {date} auf Prüfung.',
    reviewRequestFailed: 'Der Auftrag konnte nicht zur Prüfung gesendet werden. Bitte versuchen Sie es erneut.',
    certificateNoPermission: 'Ihre Rolle umfasst die Berechtigung „Zertifikat beim Abschließen hinzufügen“ nicht.',
  },
  certVars: {
    translatorName: 'Name des Übersetzers',
    translatorNameDesc: 'Vollständiger Name des Übersetzers / der zugewiesenen Person',
    translatorEmail: 'E-Mail des Übersetzers',
    translatorEmailDesc: 'E-Mail des Übersetzers / der zugewiesenen Person',
    requesterName: 'Name des Auftraggebers',
    requesterNameDesc: 'Name der Person, die den Auftrag erstellt hat',
    certificationDate: 'Beglaubigungsdatum',
    certificationDateDesc: 'Datum der Beglaubigung',
    orderDate: 'Auftragsdatum',
    orderDateDesc: 'Datum der Auftragserstellung',
    completionDate: 'Abschlussdatum',
    completionDateDesc: 'Datum des Auftragsabschlusses',
    sourceLanguage: 'Ausgangssprache',
    sourceLanguageDesc: 'Sprache des Originaldokuments',
    targetLanguage: 'Zielsprache',
    targetLanguageDesc: 'Zielsprache der Übersetzung',
    sourceCountry: 'Herkunftsland',
    sourceCountryDesc: 'Land des Originaldokuments',
    targetCountry: 'Zielland',
    targetCountryDesc: 'Zielland der Übersetzung',
    documentTitle: 'Dokumenttitel',
    documentTitleDesc: 'Name des Dokuments',
    documentType: 'Dokumenttyp',
    documentTypeDesc: 'Kategorie des Dokuments',
    originalFile: 'Originaldatei',
    originalFileDesc: 'Name der ursprünglich hochgeladenen Datei',
    pageCount: 'Seitenanzahl',
    pageCountDesc: 'Anzahl der übersetzten Seiten',
    orderNumber: 'Auftragsnummer',
    orderNumberDesc: 'Nur die Auftragsnummer (z. B. RR0124-1), nicht mit der Projektnummer kombiniert.',
    projectNumber: 'Projektnummer',
    projectNumberDesc: 'Benutzerdefinierte Projektreferenz falls gesetzt, sonst der Projektname',
    companyName: 'Unternehmensname',
    companyNameDesc: 'Name des Übersetzungsunternehmens / der Agentur',
    orderNotes: 'Auftragsnotizen',
    orderNotesDesc: 'Dem Auftrag beigefügte Notizen',
    translatorPhone: 'Telefon des Übersetzers',
    translatorPhoneDesc: 'Telefonnummer aus dem Übersetzer-Profil',
    associationName: 'Berufsverband',
    associationNameDesc: 'Berufsverband (ATA, NAJIT usw.)',
    certificationNumber: 'Zertifizierungsnummer',
    certificationNumberDesc: 'Berufliche Zertifizierungs- oder Mitgliedsnummer',
    languagePairs: 'Sprachpaare',
    languagePairsDesc: 'Sprachpaare des Übersetzers (z. B. Englisch → Spanisch)',
    translatorAddress: 'Adresse des Übersetzers',
    translatorAddressDesc: 'Vollständige Adresse aus dem Übersetzer-Profil',
    translatorCity: 'Stadt',
    translatorCityDesc: 'Stadt aus der Übersetzeradresse',
    translatorState: 'Bundesland',
    translatorStateDesc: 'Bundesland / Provinz aus der Übersetzeradresse',
    translatorCountry: 'Land',
    translatorCountryDesc: 'Land aus der Übersetzeradresse',
    translatorZip: 'Postleitzahl',
    translatorZipDesc: 'Postleitzahl aus der Übersetzeradresse',
  },
  auth: {
    invalidCredentials: 'Ungültige E-Mail oder Passwort',
    userExists: 'Ein Konto mit dieser E-Mail existiert bereits',
    accountDeactivated: 'Ihr Konto wurde deaktiviert. Bitte wenden Sie sich an Ihren Administrator.',
    accountLocked: 'Konto vorübergehend gesperrt. Versuchen Sie es in {n} Minute(n) erneut.',
    accountLockedOne: 'Konto vorübergehend gesperrt. Versuchen Sie es in {n} Minute erneut.',
    accountLockedOther: 'Konto vorübergehend gesperrt. Versuchen Sie es in {n} Minuten erneut.',
    tooManyAttemptsLocked: 'Zu viele Fehlversuche. Konto für {n} Minuten gesperrt.',
    tooManyAttemptsLockedOne: 'Zu viele Fehlversuche. Konto für {n} Minute gesperrt.',
    tooManyAttemptsLockedOther: 'Zu viele Fehlversuche. Konto für {n} Minuten gesperrt.',
    verifyEmailTitle: 'Bestätigen Sie Ihre E-Mail-Adresse',
    verifyEmailDesc: 'Wir haben einen 6-stelligen Code gesendet an',
    verifyEmailCta: 'Bestätigen & fortfahren',
    verifyEmailWrong: 'Falsche E-Mail? Zurück',
    welcomeBack: 'Willkommen zurück',
    signInSubtitle: 'Melden Sie sich an, um zu Ihrem Dashboard zu gelangen',
    createAccount: 'Konto erstellen',
    startFreeTrial: 'Starten Sie noch heute Ihre kostenlose Testphase',
    firstName: 'Vorname',
    firstNamePlaceholder: 'Jana',
    lastName: 'Nachname',
    lastNamePlaceholder: 'Mustermann',
    registerAsCompany: 'Als Unternehmen registrieren',
    companyName: 'Unternehmensname',
    companyNamePlaceholder: 'Ihr Unternehmensname',
    companyLogo: 'Unternehmenslogo',
    emailAddress: 'E-Mail-Adresse',
    emailPlaceholder: 'sie@beispiel.de',
    password: 'Passwort',
    passwordPlaceholder: 'Mind. 8 Zeichen',
    enterPassword: 'Passwort eingeben',
    signIn: 'Anmelden',
    signingIn: 'Anmeldung läuft...',
    creatingAccount: 'Konto wird erstellt...',
    uploadingLogo: 'Logo wird hochgeladen...',
    forgotPassword: 'Passwort vergessen?',
    noAccount: 'Noch kein Konto?',
    createAnAccount: 'Konto erstellen',
    alreadyHaveAccount: 'Bereits ein Konto?',
    signInLink: 'Anmelden',
    continueWithGoogle: 'Weiter mit Google',
    continueWithLinkedIn: 'Weiter mit LinkedIn',
    orEmailPassword: 'oder weiter mit',
    oauthFailed: 'Mit diesem Konto konnte nicht angemeldet werden. Bitte erneut versuchen.',
    oauthGoogleOriginError: 'Google hat diesen Ursprung ({origin}) abgelehnt. In der Google Cloud Console → Anmeldedaten → Web-Client genau diese URL unter autorisierte JavaScript-Ursprünge eintragen. Eine nicht-Web Client-ID verursacht ebenfalls Error 401.',
    authFailed: 'Authentifizierung fehlgeschlagen',
    connectionError: 'Verbindungsfehler. Bitte versuchen Sie es erneut.',
    tooManyRequests: 'Zu viele Versuche. Bitte warten Sie ein paar Minuten und versuchen Sie es erneut.',
    sessionError: 'Sitzung konnte nicht erstellt werden',
    // Password requirements
    pwdMinLength: 'Mindestens 8 Zeichen',
    pwdUppercase: 'Mindestens ein Großbuchstabe',
    pwdLowercase: 'Mindestens ein Kleinbuchstabe',
    pwdNumber: 'Mindestens eine Zahl',
    pwdSpecialChar: 'Mindestens ein Sonderzeichen (!@#$%^&*)',
    pwdStrengthWeak: 'Schwach',
    pwdStrengthFair: 'Ausreichend',
    pwdStrengthGood: 'Gut',
    pwdStrengthStrong: 'Stark',
    // Forgot password
    forgotPasswordTitle: 'Passwort zurücksetzen',
    forgotPasswordDesc: 'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Bestätigungscode.',
    sendCode: 'Code senden',
    sendingCode: 'Wird gesendet...',
    verificationCode: 'Bestätigungscode eingeben',
    verificationCodeDesc: 'Wir haben einen 6-stelligen Code gesendet an',
    verifyCode: 'Code verifizieren',
    verifyingCode: 'Wird verifiziert...',
    resendCode: 'Code erneut senden',
    resendIn: 'Erneut senden in {n}s',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Passwort bestätigen',
    confirmPasswordPlaceholder: 'Passwort bestätigen',
    resetPassword: 'Passwort festlegen',
    resettingPassword: 'Wird zurückgesetzt...',
    passwordResetSuccess: 'Passwort zurückgesetzt!',
    passwordResetSuccessDesc: 'Ihr Passwort wurde erfolgreich geändert. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.',
    backToSignIn: 'Zurück zur Anmeldung',
    passwordsNoMatch: 'Die Passwörter stimmen nicht überein',
    passwordMinLength: 'Das Passwort muss mindestens 8 Zeichen lang sein',
    // Inactivity
    sessionExpired: 'Sitzung abgelaufen',
    sessionExpiredDesc: 'Sie wurden aufgrund von Inaktivität abgemeldet. Bitte melden Sie sich erneut an.',
    // Success
    accountCreatedSuccess: 'Konto erfolgreich erstellt! Bitte melden Sie sich an.',
    // Auth page chrome + mockup
    backToHome: 'Zurück zur Startseite',
    mockupTitleOrders: 'Verwalten Sie all Ihre Aufträge',
    mockupDescOrders: 'Verfolgen Sie Dokumente, Sprachen und Status an einem Ort.',
    mockupTitleEditor: 'KI-gestützter Übersetzungseditor',
    mockupDescEditor: 'OCR-Prüfung nebeneinander mit Echtzeit-Übersetzung.',
    mockupTitleTeam: 'Für Teams und Unternehmen',
    mockupDescTeam: 'Verwalten Sie Übersetzer, Prüfer und Admins gemeinsam.',
    mockupTitleCredits: 'Guthaben und Abrechnung auf einen Blick',
    mockupDescCredits: 'Nutzung überwachen, Guthaben kaufen und Ausgaben verfolgen.',
    mockupTabOrders: 'Aufträge',
    mockupTabEditor: 'Editor',
    mockupTabTeam: 'Team',
    mockupTabCredits: 'Guthaben',
    mockupNavOrders: 'Aufträge',
    mockupNavWorkspace: 'Arbeitsbereich',
    mockupNavTeam: 'Team',
    mockupNavCredits: 'Guthaben',
    mockupNavSettings: 'Einstellungen',
    mockupHeaderOrders: 'Aufträge',
    mockupHeaderWorkspace: 'Arbeitsbereich',
    mockupHeaderCompanyDashboard: 'Unternehmens-Dashboard',
    mockupHeaderCreditsBilling: 'Guthaben & Abrechnung',
    mockupSearchOrders: 'Aufträge suchen...',
    mockupNewOrder: '+ Neuer Auftrag',
    mockupColDocument: 'Dokument',
    mockupColLanguage: 'Sprache',
    mockupColStatus: 'Status',
    mockupColDate: 'Datum',
    mockupStatusCompleted: 'Abgeschlossen',
    mockupStatusInReview: 'In Prüfung',
    mockupStatusProcessing: 'In Bearbeitung',
    mockupStatusPending: 'Ausstehend',
    mockupStepUpload: 'Hochladen',
    mockupStepOcr: 'OCR',
    mockupStepReview: 'Prüfen',
    mockupStepExport: 'Exportieren',
    mockupOriginalLabel: 'Original (ES)',
    mockupTranslationLabel: 'Übersetzung (EN)',
    mockupTotalOrders: 'Aufträge gesamt',
    mockupTeamMembers: 'Teammitglieder',
    mockupThisMonth: 'Dieser Monat',
    mockupTeamActivity: 'Team-Aktivität',
    mockupRoleTranslator: 'Übersetzer',
    mockupRoleReviewer: 'Prüfer',
    mockupRoleAdmin: 'Admin',
    mockupRowOrders: 'Aufträge',
    mockupAvailableCredits: 'Verfügbares Guthaben',
    mockupProPlan: 'Pro-Plan',
    mockupBusinessPlan: 'Business-Plan',
    mockupRecentTransactions: 'Letzte Transaktionen',
    mockupCredits: 'Credits',
    logoTooLarge: 'Das Logo muss kleiner als 5 MB sein.',
    mockupCompanyAdmin: 'Firmen-Admin',
    mockupDocBirthCertificate: 'Geburtsurkunde',
    mockupDocMarriageLicense: 'Heiratsurkunde',
    mockupDocDiploma: 'Diplom',
    mockupDocMedicalRecord: 'Krankenakte',
    mockupDocPowerOfAttorney: 'Vollmacht',
    mockupTxBirthCertificate: 'Übersetzung Geburtsurkunde',
    mockupTxCreditPurchase: 'Credit-Kauf ({n})',
    mockupTxDiplomaOcr: 'Diplom: OCR + Übersetzung',
  },
  activityPage: {
    title: 'Teamaktivität',
    subtitle: 'Verfolgen Sie, woran Ihre Teammitglieder arbeiten',
    exportCSV: 'CSV exportieren',
    totalActivities: 'Aktivitäten gesamt',
    clients: 'Kunden',
    ocrOperations: 'OCR-Vorgänge',
    translations: 'Übersetzungen',
    searchPlaceholder: 'Suche nach Mitgliedsname, Auftrags-ID, Kundenname...',
    allActions: 'Alle Aktionen',
    ocrGenerated: 'OCR erstellt',
    ocrEdited: 'OCR bearbeitet',
    translationGenerated: 'Übersetzung erstellt',
    translationEdited: 'Übersetzung bearbeitet',
    downloadAction: 'Herunterladen',
    statusCompleted: 'Status: Abgeschlossen',
    member: 'Mitglied',
    time: 'Zeit',
    order: 'Auftrag',
    action: 'Aktion',
    details: 'Details',
    loading: 'Aktivitäten werden geladen...',
    noActivity: 'Keine Aktivitäten gefunden',
    showing: 'Anzeige',
    of: 'von',
    total: 'gesamt',
    orderCreated: 'Auftrag erstellt',
    ocrCompleted: 'OCR abgeschlossen',
    translationGen: 'Übersetzung erstellt',
    translationEdit: 'Übersetzungsbearbeitung',
    processing: 'In Verarbeitung',
    completed: 'Abgeschlossen',
    translationReview: 'Übersetzungsprüfung',
    ocrReview: 'OCR-Prüfung',
    orderAssigned: 'Aufgabe zugewiesen',
    tasksAssigned: 'Aufgaben zugewiesen',
    allMembers: 'Alle Mitglieder',
    client: 'Kunde',
    noClient: 'N/A',
    clearDates: 'Datumsfilter löschen',
    role: 'Rolle',
    orderTrashed: 'In den Papierkorb verschoben',
    orderRestored: 'Aus dem Papierkorb wiederhergestellt',
    orderArchived: 'Archiviert',
    orderUnarchived: 'Archivierung aufgehoben',
    orderDeleted: 'Endgültig gelöscht',
    orderDeletedAuto: 'Endgültig gelöscht (automatisch, 7 Tage)',
    trashEmptied: 'Papierkorb geleert',
    orderReassigned: 'Aufgabe neu zugewiesen',
    orderUnassigned: 'Zuweisung entfernt',
    referenceChanged: 'Referenz geändert',
    orderCancelled: 'Auftrag storniert',
    humanVerification: 'Menschliche Prüfung',
    projectCreated: 'Projekt erstellt',
    otherAction: 'Andere Aktion',
    loadError: 'Die Aktivität konnte nicht geladen werden. Bitte versuchen Sie es in einigen Minuten erneut.',
    finalizationRequested: 'Zur Prüfung gesendet',
    finalizationReturned: 'Auftrag zurückgegeben',
    creditClaimSubmitted: 'Credits reklamiert',
    creditClaimFileOpened: 'Support hat eine Datei der Reklamation geöffnet',
    languagesConfirmed: 'Dokumentsprachen bestätigt',
    languagesDecided: 'Sprachoptionen für die Übersetzung',
  },
  corpus: {
    title: 'Meine Begriffe',
    subtitle: 'Verwalten Sie Ihre Übersetzungsbegriffe nach Sprache und Kategorie.',
    folders: 'Ordner',
    createFolder: 'Neuer Ordner',
    createCorpus: 'Neues Begriffsset',
    createError: 'Begriffsset konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    glossary: 'Begriffe',
    documents: 'Dokumente',
    style: 'Stil',
    knowledge: 'Wissensbasis',
    sourceTerm: 'Ausgangsbegriff',
    targetTerm: 'Zielbegriff',
    context: 'Kontext / Notizen',
    addTerm: 'Begriff hinzufügen',
    importCsv: 'CSV importieren',
    exportCsv: 'CSV exportieren',
    importPreview: 'Vorschau',
    importConfirm: 'Importieren',
    importSuccess: 'importiert',
    importDuplicates: 'Duplikate übersprungen',
    importErrors: 'Fehler',
    importTotal: 'Einträge gesamt',
    importDragOrClick: 'CSV-Datei hierher ziehen oder zum Durchsuchen klicken',
    importCsvFormat: "Format: Spalte A = Ausgangsbegriff, B = Zielbegriff, C = Kontext (optional). Eine Kopfzeile ist optional.",
    importing: 'Wird importiert...',
    export: 'Exportieren',
    terms: 'Begriffe',
    noCorpus: 'Noch keine Begriffe',
    selectCorpus: 'Begriffsset auswählen',
    formal: 'Formal',
    neutral: 'Neutral',
    plain: 'Einfach',
    noFolders: 'Noch keine Ordner. Erstellen Sie einen, um Ihre Begriffe zu organisieren.',
    noEntries: 'Noch keine Begriffe. Fügen Sie Ihren ersten Begriff hinzu.',
    search: 'Suchen...',
    name: 'Name',
    description: 'Beschreibung',
    sourceLanguage: 'Ausgangssprache',
    targetLanguage: 'Zielsprache',
    customInstructions: 'Benutzerdefinierte Anweisungen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    corpora: 'Begriffssets',
    folder: 'Ordner',
    back: 'Zurück',
    create: 'Erstellen',
    showing: 'Anzeige',
    of: 'von',
    noResults: 'Keine Ergebnisse',
    confirmDeleteFolder: 'Diesen Ordner löschen? Die enthaltenen Begriffssets werden in „Kein Ordner" verschoben.',
    confirmDeleteCorpus: 'Dieses Begriffsset und alle Einträge löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    confirmDeleteTerm: 'Diesen Begriff löschen?',
    prev: 'Zurück',
    next: 'Weiter',
    comingSoonMilestone: 'Demnächst verfügbar',
    folderPlaceholder: 'Recht, Medizin, Wissenschaft...',
    corpusNamePlaceholder: 'Rechtliche Urkunden ES→DE',
    instructionsPlaceholder: 'Z. B.: Verwenden Sie das formelle „Sie". Datumsformat TT.MM.JJJJ beibehalten...',
    noFolder: 'Kein Ordner',
    color: 'Farbe',
    whatIsCorpus: 'Was sind „Meine Begriffe"?',
    whatIsCorpusDesc: 'Ihre persönliche Begriffsbibliothek. Fügen Sie Begriffe, Beispieldokumente und Stilregeln hinzu, damit die KI Ihre bevorzugten Übersetzungen verwendet.',
    corpusInFolder: 'Begriffssets in diesem Ordner',
    shared: 'Geteilt',
    category: 'Kategorie',
    writingStyle: 'Schreibstil',
    formalDesc: 'Präzises Fachvokabular, strukturierte Sätze.',
    neutralDesc: 'Balance zwischen Formalität und Zugänglichkeit.',
    plainDesc: 'Kurze Sätze, einfaches Vokabular.',
    createNewCorpus: 'Neues Begriffsset erstellen',
    configureDesc: 'Konfigurieren Sie Ihre Referenzbibliothek und fügen Sie Inhalte hinzu.',
    corpusNameRequired: 'Name des Begriffssets *',
    corpusNameExample: 'Z. B.: Strafrecht, Kardiologie, Protokolle...',
    corpusUseDesc: 'Wofür werden Sie dieses Begriffsset verwenden',
    exampleDocs: 'Beispieldokumente',
    exampleDocsDesc: 'Laden Sie frühere Übersetzungen als Stil- und Formatreferenz hoch.',
    originalDoc: 'Original',
    translatedDoc: 'Übersetzung',
    docPairTip: 'Bessere Ergebnisse mit vollständigem Paar (Original + Übersetzung). Sie können auch nur eines hochladen.',
    knowledgeDesc: 'Artikel, Leitfäden oder Referenzmaterial, das die KI beim Übersetzen konsultiert.',
    uploadArticle: 'Artikel hochladen',
    acceptedFormats: 'Akzeptierte Formate: PDF, DOCX, TXT. Max. 10 MB pro Datei.',
    dragFileHere: 'Datei hier ablegen',
    tmxCsvFormat: 'TMX, CSV oder Excel (Spalte A = Original, Spalte B = Übersetzung)',
    addManually: 'Begriffe manuell hinzufügen',
    generateAI: 'Mit KI generieren',
    share: 'Teilen',
    viewTabs: 'Tabs',
    viewScroll: 'Scrollen',
    unorganized: 'Ohne Ordner',
    add: 'Hinzufügen',
    styleExtracted: 'Stil extrahiert',
    noDocuments: 'Noch keine Beispieldokumente. Laden Sie ein Paar hoch, um die Übersetzungsqualität zu verbessern.',
    noKnowledge: 'Noch keine Artikel. Laden Sie Referenzmaterial für die KI hoch.',
    articles: 'Artikel',
    uploadPair: 'Paar hochladen',
    notes: 'Notizen',
    found: 'gefunden',
    sourceColumn: 'Quelle',
    targetColumn: 'Ziel',
    removeFile: 'Entfernen',
    glossaryFileError: 'Format nicht unterstützt. Laden Sie Ihr Glossar als Excel, CSV, TSV oder TMX hoch.',
    glossarySpreadsheetError: 'Dieses Tabellenformat kann nicht gelesen werden. Öffnen Sie es und speichern Sie es als .xlsx oder CSV, dann laden Sie es hoch.',
    glossaryTooManyTerms: 'Die Datei enthält {count} Begriffe, das Maximum pro Datei sind 100.000. Teilen Sie sie in mehrere Dateien auf.',
    glossaryEmptyError: 'Keine gültigen Einträge in der Datei gefunden.',
    docFileError: 'Bitte laden Sie eine textbasierte Datei hoch (PDF, DOCX, TXT).',
    knowledgeFileError: 'Bitte laden Sie eine textbasierte Datei hoch (PDF, DOCX, TXT).',
    fileTooLarge: 'Die Datei muss kleiner als 10 MB sein.',
    uploadingGlossary: 'Glossar wird importiert...',
    uploadingDocuments: 'Dokumente werden hochgeladen...',
    uploadingKnowledge: 'Wird hochgeladen',
    quickStartTitle: 'So funktioniert es',
    step1Title: '1. Glossar erstellen',
    step1Desc: 'Fügen Sie Ihre Glossarbegriffe hinzu (CSV, TSV oder TMX), damit die KI Ihre bevorzugten Übersetzungen verwendet.',
    step2Title: '2. Beispieldokumente hinzufügen',
    step2Desc: 'Laden Sie frühere Übersetzungen hoch, damit die KI Ihren Stil und Ton erlernt.',
    step3Title: '3. Übersetzen',
    step3Desc: 'Wählen Sie beim Erstellen eines Auftrags Ihr Glossar aus. Ihre Begriffe werden automatisch angewendet.',
    termsTotal: "{terms} insgesamt",
    pageRange: "{from}–{to} von {total}",
    importConfirmTerms: "{terms} importieren",
    close: "Schließen",
    badgeAi: "KI",
    badgeLearned: "Gelernt",
    confirmDeleteDocument: "Dieses Beispieldokument löschen?",
    confirmDeleteKnowledge: "Diese Datei aus der Wissensbasis löschen?",
    loadError: "Dieses Begriffsset konnte nicht geladen werden. Möglicherweise wurde es gelöscht oder Sie haben keinen Zugriff.",
    planLimitError: "Ihr Tarif erlaubt keine weiteren Begriffssets. Wechseln Sie zu einem höheren Tarif, um weitere zu erstellen.",
    uploadingFile: "{file} wird hochgeladen…",
    deleteFolder: "Ordner löschen",
  },
  admin: {
    asistente: {
      title: 'Datenassistent',
      subtitle: 'Stellen Sie Fragen in natürlicher Sprache zu Segmenten, Verbrauch und Abwanderungsrisiko.',
      inputPlaceholder: 'Frage eingeben...',
      send: 'Senden',
      thinking: 'Denke nach...',
      suggestedTitle: 'Vorgeschlagene Fragen',
      suggestion1: 'Wie viele neue Nutzer gab es heute?',
      suggestion2: 'Geben Sie mir den heutigen Bericht.',
      suggestion3: 'Erstellen Sie einen Bericht über die Nutzer, die sich angemeldet und weniger als 10 % ihres Plans verbraucht haben.',
      suggestion4: 'Welche zahlenden Kunden waren länger als 10 Tage inaktiv?',
      suggestion5: 'Gibt es doppelte Konten mit demselben Namen?',
      exportButton: 'Als XLSX exportieren',
      emptyState: 'Stellen Sie eine Frage zu Ihren Kunden, um zu beginnen.',
      errorGeneric: 'Die Frage konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.',
      sendReportNow: 'Bericht jetzt senden',
      sendReportSending: 'Wird gesendet...',
      sendReportSuccess: 'Bericht gesendet.',
      sendReportError: 'Der Bericht konnte nicht gesendet werden.',
      dashboardSegments: 'Heutige Segmente',
      dashboardAlerts: 'Warnungen und Anomalien',
      dashboardLoadError: 'Die heutige Zusammenfassung konnte nicht geladen werden.',
      chatSectionTitle: 'Fragen Sie den Assistenten',
      segmentTrial: 'Aktive Testphase',
      segmentNoUsage: 'Kein Verbrauch',
      segmentPartial: 'Teilweiser Verbrauch',
      segmentFull: 'Voller Verbrauch',
      newAccountsToday: 'Neue Konten heute',
      ambassadors: 'Botschafter',
      alertInactive: 'Inaktiv seit 10+ Tagen',
      alertUsageDrop: 'Verbrauchsrückgang',
      alertLowConsumption: 'Geringer Verbrauch',
      alertUncharged: 'Unbelastete Bestellungen',
      alertDuplicates: 'Doppelte Registrierungen',
      alertScheduledCancellation: 'Geplante Kündigung',
      downloadReport: 'Bericht herunterladen',
      downloadingReport: 'Wird erstellt...',
      downloadReportError: 'Der Bericht konnte nicht erstellt werden.',
      promptSegmentListTpl: '{segment}: Geben Sie mir die Liste der Konten.',
      promptNewAccounts: 'Wie viele neue Konten gab es heute? Geben Sie mir die Liste.',
      promptAmbassadors: 'Geben Sie mir die Übersicht der Botschafter.',
      promptScheduledCancellation: 'Geben Sie mir die Liste der Konten mit geplanter Kündigung.',
      promptInactive: 'Geben Sie mir die Liste der zahlenden Konten, die seit über 10 Tagen inaktiv sind.',
      promptUsageDrop: 'Geben Sie mir die Liste der Konten mit Verbrauchsrückgang in den letzten 30 Tagen.',
      promptLowConsumption: 'Geben Sie mir die Liste der zahlenden Konten mit geringem Verbrauch seit der letzten Planzuteilung.',
      promptUncharged: 'Geben Sie mir die Liste der abgeschlossenen Aufträge ohne Credit-Abbuchung.',
      promptDuplicates: 'Geben Sie mir die Liste möglicher doppelter Registrierungen nach Namen.',
    },
    translationEngines: {
      header: 'Übersetzungs-Engines',
      subtitle: 'Steuere, welche Engines Dokumente übersetzen. Serverseitig durchgesetzt — die Engine wird tatsächlich umgeschaltet/blockiert, nicht nur in der Oberfläche ausgeblendet.',
      tab: 'Übersetzung',
      deeplLabel: 'DeepL',
      deeplDesc: 'Übersetzung mit DeepL erlauben (schnelle maschinelle Übersetzung, keine Korpus-Glossare). Gilt nur, wenn der Auftrag KEIN Korpus hat.',
      claudeLabel: 'Claude',
      claudeDesc: 'Übersetzung mit Claude für Aufträge OHNE Korpus erlauben (kontextbewusste Übersetzung).',
      corpusLabel: 'Korpus → immer Claude',
      corpusDesc: 'Fest (nicht konfigurierbar): Ein Auftrag mit Korpus wird immer mit Claude übersetzt — Korpus-Glossare laufen nur über Claude.',
      alwaysOn: 'Immer an',
      bothDisabled: 'Beide Engines sind deaktiviert — Aufträge OHNE Korpus haben keine Engine. (Aufträge mit Korpus werden weiterhin mit Claude übersetzt.)',
      effectiveTitle: 'Effektives Verhalten',
      effectiveWithCorpus: 'Mit Korpus: nur Claude (Korpus) — immer, auch wenn der Claude-Schalter aus ist.',
      effectiveWithoutCorpusPrefix: 'Ohne Korpus:',
      noneEnabled: 'keine aktiviert',
    },
    orderDetail: {
      back: 'Zurück',
      documentInfo: 'Dokumentinfo',
      category: 'Kategorie',
      type: 'Typ',
      pages: 'Seiten',
      step: 'Schritt',
      exportFormat: 'Exportformat',
      certificate: 'Zertifikat',
      digitalSignature: 'Digitale Signatur',
      humanVerified: 'Von Mensch geprüft',
      attachOriginal: 'Original anhängen',
      originalFile: 'Originaldatei',
      translation: 'Übersetzung',
      sourceLanguage: 'Ausgangssprache',
      targetLanguage: 'Zielsprache',
      sourceCountry: 'Ausgangsland',
      targetCountry: 'Zielland',
      translationMethod: 'Übersetzungsmethode',
      people: 'Personen',
      account: 'Konto',
      createdBy: 'Erstellt von',
      creditsAndDates: 'Guthaben & Daten',
      creditsEstimated: 'Geschätztes Guthaben',
      creditsConsumed: 'Verbrauchtes Guthaben',
      created: 'Erstellt',
      updated: 'Aktualisiert',
      completed: 'Abgeschlossen',
      processingTime: 'Verarbeitungszeit',
      platformCostBreakdown: 'Plattform-Kostenaufstellung',
      service: 'Dienst',
      usage: 'Nutzung',
      costUsd: 'Kosten (USD)',
      total: 'Gesamt',
      yes: 'Ja',
      no: 'Nein',
      mode: 'Modus',
      referenceNumber: 'Referenz',
      clientName: 'Kunde',
      dueDate: 'Fälligkeitsdatum',
      verificationId: 'Verifizierungs-ID',
      viewVerification: 'Öffentliche Verifizierung anzeigen',
      humanVerifiedBy: 'Verifiziert von',
      translationApprovedBy: 'Übersetzung freigegeben von',
      filesPurgedTpl: 'Dateien am {date} gelöscht',
      deletionCertificateLink: 'Löschzertifikat anzeigen',
      notFound: 'Auftrag nicht gefunden',
      fetchFailed: 'Der Auftrag konnte nicht geladen werden',
      formatTemplate: 'Formatvorlage',
      assignedTo: 'Zugewiesen an',
      notes: 'Notizen',
      usagePagesTpl: '{n} Seiten',
      usageTokensTpl: '{n} Tokens',
      usageCharsTpl: '{n} Zeichen',
      claudeOcr: 'Claude AI (OCR)',
      claudeTranslation: 'Claude AI (Übersetzung)',
      claudeVision: 'Claude AI (Vision)',
      modeDeeplClaude: 'Option 1 (DeepL + Claude AI)',
      modeGoogle: 'Option 1 (Google)',
      modeCorpus: 'Korpus',
    },
    common: {
      systemOnline: 'System online',
      allTime: 'Gesamter Zeitraum',
      realTime: 'Echtzeit',
      search: 'Suchen',
      save: 'Speichern',
      cancel: 'Abbrechen',
      create: 'Erstellen',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      close: 'Schließen',
      done: 'Fertig',
      loading: 'Laden...',
      saving: 'Speichern...',
      success: 'Erfolg',
      error: 'Fehler',
      confirmDelete: 'Dieses Element löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      cannotBeUndone: 'Diese Aktion kann nicht rückgängig gemacht werden.',
      actions: 'Aktionen',
      status: 'Status',
      name: 'Name',
      description: 'Beschreibung',
      title: 'Titel',
      category: 'Kategorie',
      type: 'Typ',
      date: 'Datum',
      language: 'Sprache',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      draft: 'Entwurf',
      total: 'Gesamt',
      page: 'Seite',
      of: 'von',
      previous: 'Zurück',
      next: 'Weiter',
      showing: 'Zeige',
      noResults: 'Keine Ergebnisse',
      allStatus: 'Alle Status',
      exportCSV: 'CSV exportieren',
      view: 'Ansehen',
      add: 'Hinzufügen',
      remove: 'Entfernen',
      refresh: 'Aktualisieren',
      copy: 'Kopieren',
      copied: 'Kopiert',
      select: 'Auswählen',
      applying: 'Wird angewendet...',
    },
    overview: {
      title: 'Admin-Dashboard',
      subtitle: 'Systemübersicht und -verwaltung',
      totalOrders: 'Aufträge gesamt',
      activeAccounts: 'Aktive Konten',
      totalUsers: 'Benutzer gesamt',
      creditsBalance: 'Credits-Saldo',
      humanVerified: 'Manuell verifiziert',
      totalRevenue: 'Gesamtumsatz',
      today: 'Heute',
      thisWeek: 'Diese Woche',
      thisMonth: 'Diesen Monat',
      platformCostsAllTime: 'Plattformkosten (gesamt)',
      totalCost: 'Gesamtkosten',
      avgPerOrder: 'Ø / Auftrag',
      avgPerPage: 'Ø / Seite',
      ordersProcessed: 'Verarbeitete Aufträge',
      totalPages: 'Seiten gesamt',
      costByService: 'Kosten nach Service',
      awsTextract: 'AWS Textract',
      googleDocAI: 'Google Document AI',
      claudeAI: 'Claude AI',
      deepl: 'DeepL',
      ocrExtraction: 'OCR-Extraktion',
      ocrComplementary: 'OCR ergänzend',
      visionPostEdit: 'Vision + Nachbearbeitung',
      translation: 'Übersetzung',
      pages: 'Seiten',
      costPerPage: 'Kosten/Seite',
      ocrColor: 'OCR (Farbe)',
      visionClass: 'Vision (Klass.)',
      postEdit: 'Nachbearbeitung',
      characters: 'Zeichen',
      words: 'Wörter',
      costPerMillion: 'Kosten/1M Zeichen',
      detailedUsage: 'Detaillierte Nutzung',
      service: 'Service',
      purpose: 'Zweck',
      usage: 'Nutzung',
      cost: 'Kosten (USD)',
      ocrTextExtraction: 'OCR Textextraktion',
      ocrColorDetection: 'OCR Farberkennung',
      visionClassification: 'Visuelle Klassifikation',
      translationPostEdit: 'Übersetzungsnachbearbeitung',
      totalPlatformCost: 'Gesamte Plattformkosten',
      tokens: 'Tokens',
      chars: 'Zeichen',
      topLanguagePairs: 'Top-Sprachpaare',
      ordersByStatus: 'Aufträge nach Status',
      noLanguagePairData: 'Noch keine Sprachpaardaten verfügbar',
      percentOfOrders: '% der Gesamtaufträge',
      orders: 'Aufträge',
      noOrderData: 'Keine Auftragsdaten verfügbar',
      totalOrdersLabel: 'Aufträge gesamt',
      activitySummary: 'Aktivitätszusammenfassung',
      ordersToday: 'Aufträge heute',
      creditsConsumed: 'Verbrauchte Credits',
      completed: 'abgeschlossen',
      inProgress: 'in Bearbeitung',
      totalAccounts: 'gesamt',
      newThisWeek: 'diese Woche',
      newThisMonth: 'neu diesen Monat',
      verified: 'verifiziert',
      ofCompleted: 'von',
      sold: 'verkauft',
      consumed: 'verbraucht',
      creditsSold: 'Verkaufte Credits',
      totalPurchased: 'Gesamt gekauft von Kunden',
      unusedAcrossAccounts: 'Ungenutzte Credits über alle Konten',
      used: 'Verwendet',
      remaining: 'Verbleibend',
      available: 'Verfügbar',
      balance: 'Saldo',
      imageBased: 'Bildbasiert',
      textBased: 'Textbasiert',
      documents: 'Dokumente',
      documentsByType: 'Dokumente nach Typ',
      pagesByType: 'Seiten nach Dokumenttyp',
      imagePages: 'Bildseiten',
      textPages: 'Textseiten',
      noDocData: 'Noch keine Dokumentdaten verfügbar',
      noPageData: 'Noch keine Seitendaten verfügbar',
      activeUsers: 'aktiv',
      teamUsers: 'Team',
      memberUsers: 'Mitglieder',
      statusUploaded: 'Hochgeladen',
      statusProcessing: 'Verarbeitung',
      statusOcrReview: 'OCR-Prüfung',
      statusTranslationReview: 'Übersetzungsprüfung',
      statusCompleted: 'Abgeschlossen',
      plusTodayTpl: '+{n} heute',
      plusThisWeekTpl: '+{n} diese Woche',
      costEnvTitle: 'Umgebung der Claude-Kosten',
      apply: 'Anwenden',
      salesHint: 'Klicken Sie, um jeden Verkauf zu sehen: wer, wann, was und wie viel',
      salesTitle: 'Verkaufsdetails',
      salesModeAll: 'Alle',
      salesModeLive: 'Live-Modus',
      salesModeTest: 'Testmodus',
      opsOption1: 'Option 1 (DeepL)',
      opsOption2: 'Option 2 (Claude AI)',
      opsCorpus: 'Korpus (Claude AI + Korpus)',
      envProduction: 'Produktion',
      claudeEnvErrorTpl: 'Die Kosten für {env} konnten nicht gelesen werden ({error}). Prüfen Sie, ob in der Umgebung der Schlüssel und das Service-Secret konfiguriert sind.',
      totalTokens: 'Tokens gesamt',
      vision: 'Vision',
      docClassification: 'Dokumentklassifizierung',
      classifications: 'Klassifizierungen',
      tokensLabel: 'Tokens',
      costLabel: 'Kosten',
      infraTitle: 'Infrastruktur (Railway) — laufender Monat',
      infraNote: 'Geschätzte Nutzung seit Monatsbeginn laut Railway-API (CPU, Speicher, Netzwerk, Volumes).',
      infraNotConnectedTpl: 'Nicht verbunden. Setzen Sie {token} im Dienst api-gateway, um die Infrastrukturkosten je Umgebung zu sehen.',
      usersOverview: 'Benutzerübersicht',
      activeCountTpl: '{n} aktiv',
      usersUnit: 'Benutzer',
      userTypeTeam: 'Team',
      userTypeMember: 'Mitglied',
      userTypeFreelance: 'Freelancer',
      userTypeAdmin: 'Admin',
      docTypeTitle: 'Aufschlüsselung nach Dokumenttyp',
      docTypeNote: 'Alle Dokumenttypen: 1 Credit/Seite',
      docsUnit: 'Dok.',
      pagesUnit: 'Seiten',
      documentsLabel: 'Dokumente',
      pagesProcessed: 'Verarbeitete Seiten',
      docTypeCountsTpl: '({docs} Dok., {pages} Seiten)',
    },
    accounts: {
      title: 'Konten',
      subtitle: 'Alle registrierten Konten verwalten',
      searchPlaceholder: 'Konten suchen...',
      noAccountsFound: 'Keine Konten gefunden',
      account: 'Konto',
      owner: 'Inhaber',
      members: 'Mitglieder',
      plan: 'Plan',
      credits: 'Credits',
      created: 'Erstellt',
      payAsYouGo: 'Nutzungsbasiert',
      activate: 'Aktivieren',
      suspend: 'Sperren',
      viewDetails: 'Details ansehen',
      addCredits: 'Credits hinzufügen',
      statusActive: 'Aktiv',
      statusTrial: 'Testphase',
      statusSuspended: 'Gesperrt',
      adjustCredits: 'Credits anpassen',
      currentBalance: 'Aktueller Saldo',
      creditsAmount: 'Credits-Menge',
      amountPlaceholder: 'z. B. 100 (negativ zum Abziehen)',
      amountHint: 'Positiv zum Hinzufügen, negativ zum Abziehen',
      reason: 'Grund',
      reasonPlaceholder: 'z. B. Kulanz-Credits, Rechnungskorrektur...',
      newBalance: 'Neuer Saldo',
      creditsAppliedSuccess: 'Credits erfolgreich angewendet',
      failedToAdjust: 'Credits konnten nicht angepasst werden',
      networkError: 'Netzwerkfehler. Bitte versuchen Sie es erneut.',
      applyCredits: 'Credits anwenden',
      applying: 'Wird angewendet...',
      showing: 'Zeige',
      accountsLabel: 'Konten',
      changePlan: 'Plan ändern',
      noPlan: 'Kein Plan',
      assignPlan: 'Plan zuweisen',
      selectPlan: 'Plan auswählen',
      billingCycle: 'Abrechnungszyklus',
      monthly: 'Monatlich',
      yearly: 'Jährlich',
      applyCreditsLabel: 'Plan-Credits zum aktuellen Guthaben hinzufügen',
      currentPlan: 'Aktueller Plan',
      newPlan: 'Neuer Plan',
      planChangedSuccess: 'Plan erfolgreich aktualisiert',
      failedToChangePlan: 'Plan konnte nicht geändert werden',
      freelanceOnly: 'Nur Freelancer (1 Mitglied)',
      companyPlan: 'Firmenplan',
      removePlan: 'Plan entfernen',
      memberLimitExceeded: 'Konto hat mehr Mitglieder als dieser Plan erlaubt',
      freeMembersKeepHint: 'Mitglieder bleiben im Konto. Team bleibt gesperrt, bis ein bezahlter Tarif gekauft wird.',
      freeCreditModeLabel: 'Credits beim Wechsel zu Free',
      freeCreditKeepPlus5: 'Aktuelles Guthaben + 5',
      freeCreditOnly5: 'Nur 5 (Rest entfernen)',
      removePlanWarning: 'Kündigt das Stripe-Abo sofort und setzt das Guthaben auf 0.',
      ownerViewHint: 'Der Tarif ändert auch die Ansicht des Inhabers: Mit Team-Tarif erscheint die Team-Ansicht. Gilt beim nächsten Login.',
      lastActive: 'Letzte Aktivität',
      never: 'Nie',
      trialColumn: 'Testphase',
      trialExpired: 'Abgelaufen',
      trialOneDay: '1 Tag',
      trialDays: n => `${n} Tage`,
      planPriceLineTpl: '{monthly}/Monat · {yearly}/Jahr · {credits} Credits/Monat',
    },
    users: {
      title: 'Benutzer',
      subtitle: 'Alle Plattformbenutzer verwalten',
      searchPlaceholder: 'Benutzer nach Name oder E-Mail suchen...',
      user: 'Benutzer',
      email: 'E-Mail',
      accountLabel: 'Konto',
      userType: 'Typ',
      role: 'Rolle',
      lastLogin: 'Letzter Login',
      status: 'Status',
      noUsersFound: 'Keine Benutzer gefunden',
      allTypes: 'Alle Typen',
      allRoles: 'Alle Rollen',
      typeAdmin: 'Admin',
      typeTeam: 'Team',
      typeMember: 'Mitglied',
      typeUser: 'Benutzer',
      roleOwner: 'Inhaber',
      roleAdmin: 'Admin',
      roleManager: 'Manager',
      roleMember: 'Mitglied',
      roleFreelancer: 'Freiberufler',
      activate: 'Aktivieren',
      deactivate: 'Deaktivieren',
      impersonate: 'Identität annehmen',
      viewActivity: 'Aktivität ansehen',
      never: 'Nie',
      showing: 'Zeige',
      usersLabel: 'Benutzer',
      subtitleActivity: 'Überwachen Sie Benutzeraktivität und Engagement',
      exportExcel: 'Nach Excel exportieren',
      exportEmail: 'E-Mail',
      exportPlan: 'Tarif',
      exportCreditsAvailable: 'Verfügbare Credits',
      exportConsumedAccount: 'Verbraucht (Konto)',
      exportConsumedUser: 'Verbraucht (Benutzer)',
      onlineNow: 'Jetzt online',
      activeToday: 'Heute aktiv',
      byRole: 'Nach Rolle',
      teamShort: 'Team',
      memberShort: 'Mitglied',
      userShort: 'Benutzer',
      allActivity: 'Alle Aktivitäten',
      filterOnline: 'Jetzt online',
      filterRecent: 'Kürzlich aktiv',
      filterActiveStatus: 'Status: Aktiv',
      filterSuspendedStatus: 'Status: Gesperrt',
      statusOnline: 'Online',
      statusRecently: 'Kürzlich',
      statusOffline: 'Offline',
      statusSuspendedBadge: 'Gesperrt',
      lastActive: 'Zuletzt aktiv',
      lastPage: 'Letzte Seite',
      joined: 'Beigetreten',
      noAccount: 'Kein Konto',
      moreAccountsTpl: '+{n} weitere',
      showingRangeTpl: 'Zeige {from}-{to} von {total} Benutzern',
      timeJustNow: 'gerade eben',
      timeMinAgoTpl: 'vor {n}m',
      timeHourAgoTpl: 'vor {n}h',
      timeDayAgoTpl: 'vor {n}T',
      timeWeekAgoTpl: 'vor {n}W',
      platformAdminLabel: 'Plattform-Admin',
      platformAdminBadge: 'Plattform-Admin',
      platformAdminDescription: 'Gewährt Zugriff auf /admin, ohne die Team- oder Planrolle zu ändern. Ansicht wechseln wie bei Botschaftern.',
      platformAdminReloginHint: 'Sie müssen sich ab- und wieder anmelden, damit die Änderung wirksam wird.',
      platformAdminGrant: 'Zum Plattform-Admin machen',
      platformAdminRevoke: 'Plattform-Admin entfernen',
      platformAdminGranted: 'Plattform-Admin erteilt',
      platformAdminRevoked: 'Plattform-Admin entfernt',
      platformAdminFailed: 'Plattform-Admin konnte nicht aktualisiert werden',
      platformAdminConfirmGrant: 'Diesem Nutzer Plattform-Admin geben? Team-/Planansicht bleibt, erneute Anmeldung nötig.',
      platformAdminConfirmRevoke: 'Plattform-Admin für diesen Nutzer entfernen? Erneute Anmeldung nötig.',
      deleteUser: 'Benutzer löschen…',
      deleteTitle: 'Benutzer dauerhaft löschen',
      deleteWarningTpl: 'Diese Aktion {strong}. Zum Fortfahren wird ein 6-stelliger Bestätigungscode an die in den Einstellungen hinterlegte Admin-E-Mail gesendet.',
      deleteWarningStrong: 'kann nicht rückgängig gemacht werden',
      sendCode: 'Code senden',
      enterCodeTpl: 'Geben Sie den an {email} gesendeten Code ein (läuft in 10 Minuten ab).',
      adminEmailFallback: 'die Admin-E-Mail',
      deletePermanently: 'Endgültig löschen',
      codeSendFailed: 'Der Code konnte nicht gesendet werden',
      invalidCode: 'Ungültiger Code',
      somethingWrong: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
      userDeleted: 'Benutzer gelöscht',
      userDeletedTpl: '{name} wurde dauerhaft gelöscht.',
      exportSheet: 'Benutzer und Credits',
    },
    orders: {
      title: 'Alle Aufträge',
      subtitle: 'Alle Aufträge über Konten hinweg ansehen und verwalten',
      searchPlaceholder: 'Aufträge nach Nummer oder Dokumentname suchen...',
      totalOrders: 'Aufträge gesamt',
      completed: 'Abgeschlossen',
      inProgress: 'In Bearbeitung',
      totalPlatformCost: 'Gesamte Plattformkosten',
      orderNum: 'Auftrag Nr.',
      document: 'Dokument',
      account: 'Konto',
      pages: 'Seiten',
      credits: 'Credits',
      quality: 'Qualität',
      cost: 'Kosten (USD)',
      status: 'Status',
      date: 'Datum',
      actions: 'Aktionen',
      viewBtn: 'Ansehen',
      logsBtn: 'Logs',
      noOrdersFound: 'Keine Aufträge gefunden.',
      platformCostBreakdown: 'Aufschlüsselung der Plattformkosten',
      awsTextract: 'AWS Textract',
      googleDocAI: 'Google Doc AI',
      claudeAI: 'Claude AI',
      deepl: 'DeepL',
      grandTotal: 'Gesamtsumme',
      allServicesCombined: 'alle Services kombiniert',
      detailedUsageBreakdown: 'Detaillierte Nutzungsaufschlüsselung',
      allTimeAggregated: 'Historisch aggregierte Nutzung aller Aufträge',
      service: 'Service',
      purpose: 'Zweck',
      usage: 'Nutzung',
      costUsd: 'Kosten (USD)',
      ocrTextExtraction: 'OCR (Textextraktion)',
      ocrComplementary: 'OCR (ergänzend)',
      visionClassification: 'Vision (Klassifikation)',
      translationClaude: 'Übersetzung (Claude)',
      translation: 'Übersetzung',
      totalLbl: 'Gesamt',
      orderLogsTitle: 'Auftrags-Logs',
      loadingLogs: 'Logs werden geladen...',
      noLogsFound: 'Keine Logs für diesen Auftrag gefunden.',
      timestamp: 'Zeitstempel',
      action: 'Aktion',
      creditsCol: 'Credits',
      pagesLower: 'Seiten',
      charsLower: 'Zeichen',
      tokensLower: 'Tokens',
      statusUploaded: 'Hochgeladen',
      statusProcessing: 'Verarbeitung',
      statusOcrReview: 'OCR-Prüfung',
      statusTranslationReview: 'Übersetzungsprüfung',
      statusCompleted: 'Abgeschlossen',
      allStatus: 'Alle Status',
      actionOrderCreated: 'Auftrag erstellt',
      actionOcrCompleted: 'OCR abgeschlossen',
      actionOcrGenerated: 'OCR generiert',
      actionOcrEdited: 'OCR bearbeitet',
      actionTranslationGen: 'Übers. generiert',
      actionTranslationEdit: 'Übers. bearbeitet',
      actionDownload: 'Download',
      actionProcessing: 'Verarbeitung',
      actionCompleted: 'Abgeschlossen',
      actionTranslationReview: 'Übersetzungsprüfung',
      actionOcrReview: 'OCR-Prüfung',
      exportCSV: 'CSV exportieren',
      wordsLower: 'Wörter',
      ordersLower: 'Aufträge',
      showingRangeTpl: 'Zeige {from}-{to} von {total} Aufträgen',
      orderLogsForTpl: 'Auftrags-Logs — {orderNumber}',
      visibilityAll: 'Sichtbarkeit: alle',
      visibilityActive: 'Aktiv',
      visibilityTrash: 'Im Papierkorb',
      visibilityDeleted: 'Endgültig gelöscht',
      visibilityArchived: 'Archiviert',
      badgeInTrash: 'Im Papierkorb',
      badgeDeleted: 'Endgültig gelöscht',
      deletedAuto: 'Automatisch (7 Tage im Papierkorb)',
      byTpl: '{date} · von {name}',
      inTrashSince: 'Im Papierkorb seit',
      statusCancelled: 'Storniert',
      actorAuto: 'Automatisch',
      userCol: 'Benutzer',
      csvOrderNumber: 'Auftragsnummer',
      csvDocumentName: 'Dokumentname',
      csvAccount: 'Konto',
      csvStatus: 'Status',
      csvPages: 'Seiten',
      csvCreditsEstimated: 'Geschätzte Credits',
      csvCreditsConsumed: 'Verbrauchte Credits',
      csvSourceLanguage: 'Ausgangssprache',
      csvTargetLanguage: 'Zielsprache',
      csvOrderDate: 'Auftragsdatum',
      csvLogTimestamp: 'Zeitpunkt des Eintrags',
      csvLogAction: 'Aktion',
      csvLogCredits: 'Credits des Eintrags',
      csvLogUser: 'Benutzer des Eintrags',
      csvTrashedAt: 'Im Papierkorb seit',
      csvDeletedAt: 'Gelöscht am',
      csvDeletedReason: 'Löschgrund',
    },
    waitlist: {
      title: 'Warteliste',
      subtitle: 'Founding-User-Anmeldungen von der Landing-Page',
      totalSignups: 'Anmeldungen gesamt',
      companies: 'Unternehmen',
      wantBetaAccess: 'Wollen Beta-Zugang',
      latestSignup: 'Letzte Anmeldung',
      searchPlaceholder: 'Nach Name, E-Mail, Unternehmen oder Rolle suchen...',
      noEntriesFound: 'Keine Einträge in der Warteliste gefunden',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      company: 'Unternehmen',
      role: 'Rolle',
      pagesPerWeek: 'Seiten/Wo.',
      biggestPain: 'Größtes Problem',
      priceWillingness: 'Zahlungsbereitschaft',
      betaInterest: 'Beta-Interesse',
      language: 'Sprache',
      signedUp: 'Angemeldet',
      signedUpAt: 'Angemeldet am',
      deleteEntry: 'Eintrag löschen',
      viewDetails: 'Details ansehen',
      deleteConfirm: 'Diesen Eintrag löschen?',
      csvName: 'Name',
      csvEmail: 'E-Mail',
      csvPhone: 'Telefon',
      csvCompany: 'Unternehmen',
      csvRole: 'Rolle',
      csvPagesWeek: 'Seiten/Woche',
      csvBiggestPain: 'Größtes Problem',
      csvPriceWillingness: 'Zahlungsbereitschaft',
      csvBetaInterest: 'Beta-Interesse',
      csvLanguage: 'Sprache',
      csvDate: 'Datum',
    },
    analytics: {
      title: 'Analytik',
      subtitle: 'Plattformleistung und -einblicke',
      totalOrders: 'Aufträge gesamt',
      activeAccounts: 'Aktive Konten',
      ordersProcessed: 'Verarbeitete Aufträge',
      creditsConsumed: 'Verbrauchte Credits',
      ordersByStatus: 'Aufträge nach Status',
      topLanguagePairs: 'Top-Sprachpaare',
      documentsByType: 'Dokumente nach Typ',
      pagesByDocType: 'Seiten nach Dokumenttyp',
      imageBased: 'Bildbasiert',
      textBased: 'Textbasiert',
      imagePages: 'Bildseiten',
      textPages: 'Textseiten',
      documents: 'Dokumente',
      pages: 'Seiten',
      noOrderData: 'Noch keine Auftragsdaten verfügbar',
      noLanguagePairData: 'Noch keine Sprachpaardaten verfügbar',
      noDocData: 'Noch keine Dokumentdaten verfügbar',
      noPageData: 'Noch keine Seitendaten verfügbar',
      statusUploaded: 'Hochgeladen',
      statusProcessing: 'Verarbeitung',
      statusOcrReview: 'OCR-Prüfung',
      statusTranslationReview: 'Übersetzungsprüfung',
      statusCompleted: 'Abgeschlossen',
      manuscript: 'Handschriftlich',
    },
    blog: {
      title: 'Blog · Ranqio-Artikel',
      subtitle: 'Inhalte über API eingespielt + SEO-, OG-, JSON-LD- und Statusbearbeitung.',
      searchPlaceholder: 'Nach Titel suchen...',
      allStatuses: 'Alle Status',
      statusDraft: 'Entwurf',
      statusScheduled: 'Geplant',
      statusPublished: 'Veröffentlicht',
      statusArchived: 'Archiviert',
      noArticles: 'Keine Artikel.',
      titleCol: 'Titel',
      status: 'Status',
      locale: 'Locale',
      author: 'Autor',
      publishedAt: 'Veröffentlicht',
      actions: 'Aktionen',
      viewOnSite: 'Auf der Website ansehen',
      editSeo: 'SEO bearbeiten',
      deleteArticle: 'Löschen',
      deleteConfirm: 'Diesen Artikel löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      articles: 'Artikel',
      pageOf: 'Seite {p} von {t}',
      errorSave: 'Fehler beim Speichern.',
      loadFailed: 'Der Artikel konnte nicht geladen werden.',
      savedOk: 'Änderungen gespeichert.',
      notFound: 'Artikel nicht gefunden.',
      back: 'Zurück',
      backToArticles: 'Zurück zu den Artikeln',
      sectionBasic: 'Grundinformationen',
      slugHint: 'Legt die endgültige URL /blog/[slug] fest.',
      fieldExcerpt: 'Auszug',
      excerptHint: 'Kurzer Text für Listen und die Standard-Meta-Description.',
      sectionSeo: 'SEO · Suche',
      schemasHint: 'Array aus { type, jsonLd }-Objekten. Wird in <head> eingefügt.',
      sectionFeaturedImage: 'Beitragsbild',
      altText: 'Alternativtext',
      sectionPublication: 'Veröffentlichung',
      fieldPublishDate: 'Veröffentlichungsdatum',
      sectionInfo: 'Informationen',
      viewPublished: 'Veröffentlichten Artikel ansehen →',
    },
    copy: {
      title: 'Website-Texte',
      subtitle: 'Bearbeiten Sie die Texte der Haupt-Landing-Page in allen Sprachen. Änderungen bleiben im Entwurf, bis Sie Veröffentlichen drücken.',
      discardDraft: 'Entwurf verwerfen',
      saveDraft: 'Entwurf speichern',
      publish: 'Veröffentlichen',
      publishing: 'Veröffentliche',
      draftSaved: '✓ Entwurf gespeichert. Noch nicht öffentlich sichtbar.',
      publishedMsg: '🚀 Veröffentlicht. Besucher sehen jetzt die Änderungen.',
      errorSaveDraft: 'Fehler beim Speichern des Entwurfs',
      errorPublish: 'Fehler beim Veröffentlichen',
      discardConfirm: 'Entwurf verwerfen und zur veröffentlichten Version zurückkehren?',
      draftDiscarded: 'Entwurf verworfen',
      loadingError: 'Fehler beim Laden der Texte',
      unpublishedChanges: 'Es gibt unveröffentlichte Änderungen in',
      pressPublish: 'Drücken Sie Veröffentlichen, damit Besucher sie sehen.',
      unsaved: 'nicht gespeichert',
      draftBadge: 'Entwurf',
      pendingChanges: 'Unveröffentlichte Änderungen',
    },
    nav: {
      title: 'Navigationsmenü',
      subtitle: 'Konfigurieren Sie die Header-Elemente. Erstellen Sie Links zu Seiten, Dropdowns mit Unterelementen oder externe Links.',
      newItem: 'Neues Element',
      noItems: 'Noch keine Elemente. Erstellen Sie das erste, damit es im Header erscheint.',
      dragHint: '💡 Ziehen Sie die Elemente am Griff links, um sie zu sortieren.',
      itemCreated: 'Element erstellt',
      itemUpdated: 'Element aktualisiert',
      saveError: 'Fehler beim Speichern',
      deleteConfirm: 'Dieses Element löschen? Untergeordnete Elemente werden ebenfalls gelöscht.',
      newItemTitle: 'Neues Element',
      editItemTitle: 'Element bearbeiten',
      kind: 'Typ',
      kindLink: 'Externer Link (URL)',
      kindLanding: 'Landing-Page (in EZDocuAI erstellt)',
      kindDropdown: 'Dropdown (mit Unterelementen)',
      url: 'URL',
      urlHint: 'z. B.: https://docs.beispiel.com oder /pricing',
      landingPage: 'Landing-Page',
      landingHint: 'Wenn die Landing umbenannt oder gelöscht wird, wird der Link automatisch aktualisiert/deaktiviert.',
      selectPlaceholder: '— Auswählen —',
      parentItem: 'Übergeordnetes Element (optional)',
      parentHint: 'Zum Einfügen in ein Dropdown',
      noParent: '— Kein übergeordnetes (Top-Level) —',
      activeLabel: 'Aktiv (im Header sichtbar)',
      addSubItem: 'Unterelement hinzufügen',
      dragReorder: 'Ziehen zum Sortieren',
      deleteItem: 'Löschen',
      inactive: 'inaktiv',
      items: 'Elemente',
      kindLinkShort: 'Link',
      kindLandingShort: 'Landingpage',
      kindDropdownShort: 'Dropdown-Menü',
      itemsOne: '{n} Element',
      itemsOther: '{n} Elemente',
    },
    seo: {
      title: 'SEO und Metadaten',
      subtitle: 'Optimieren Sie Ihre Website für Suchmaschinen und soziale Netzwerke.',
      tabGeneral: 'Allgemein',
      tabRobots: 'Robots',
      tabSitemap: 'Sitemap',
      tabPages: 'Seiten',
      errorLoading: 'Fehler beim Laden der Konfiguration',
      settingsSaved: 'Konfiguration gespeichert',
      errorSaving: 'Fehler beim Speichern',
      saveChanges: 'Änderungen speichern',
      addSocialProfile: 'Soziales Profil hinzufügen',
      generalSection: 'Allgemeine Einstellungen',
      siteName: 'Seitenname',
      siteNamePlaceholder: 'EZDocuAI',
      siteUrl: 'Seiten-URL',
      siteUrlPlaceholder: 'https://www.ezdocu.ai',
      titleTemplate: 'Titel-Template',
      titleTemplateHint: 'Verwenden Sie %s dort, wo der jeweilige Seitentitel steht',
      titleTemplatePlaceholder: '%s | EZDocuAI',
      defaultTitle: 'Standardtitel',
      titleCounterLabel: 'Titel',
      defaultDescription: 'Standardbeschreibung',
      descriptionCounterLabel: 'Beschreibung',
      ogImage: 'Bild für soziale Netzwerke (OG)',
      ogImageHint: 'Empfohlene Größe: 1200×630px. Laden Sie hoch oder fügen Sie eine URL ein.',
      ogImagePlaceholder: 'https://… oder laden Sie ein Bild hoch',
      googleVerification: 'Google-Verifizierungscode',
      googleVerificationPlaceholder: 'google-site-verification=...',
      socialProfiles: 'Soziale Profile',
      socialProfilePlaceholder: 'https://www.instagram.com/ezdocu',
      googlePreview: 'Google-Vorschau',
      socialPreview: 'Social-Media-Vorschau',
      indexingSection: 'Seiten-Indexierung',
      allowGoogleIndex: 'Google erlauben, die Seite zu indexieren',
      allowGoogleIndexHint: 'Wenn deaktiviert, erscheint die Seite nicht in Suchmaschinen.',
      blockedPathsSection: 'Für Crawler gesperrte Pfade',
      blockedPathsHint: 'Diese Pfade werden nicht von Google oder anderen Suchmaschinen gecrawlt.',
      blockedPathPlaceholder: '/zu-sperrender-pfad/',
      aiPolicySection: 'Richtlinie für KI-Crawler',
      aiPolicyAllowAll: 'Alle erlauben',
      aiPolicyAllowAllDesc: 'Google, Bing, ChatGPT, Claude können zugreifen',
      aiPolicyBlockTraining: 'Training blockieren',
      aiPolicyBlockTrainingDesc: 'Erlaubt KI-Suche, blockiert Training (GPTBot, CCBot)',
      aiPolicyBlockAll: 'Alle KI-Bots blockieren',
      aiPolicyBlockAllDesc: 'Erlaubt nur traditionelle Suchmaschinen',
      robotsPreviewSection: 'robots.txt-Vorschau',
      sitemapSection: 'Sitemap-Einstellungen',
      autoGenerateSitemap: 'Sitemap automatisch erzeugen',
      autoGenerateSitemapHint: 'Enthält statische Seiten, aktive Landing-Pages und CMS-Inhalte.',
      sitemapUpdated: 'Sitemap aktualisiert',
      sitemapUrlCopied: 'URL kopiert',
      includedContentSection: 'Enthaltene Inhalte',
      includedStaticPages: 'Statische Seiten (Start, Pricing, Blog)',
      includedLandingPages: 'Aktive dynamische Landing-Pages',
      includedBlogArticles: 'Veröffentlichte Blog-Artikel',
      excludedHint: 'Private Seiten (Dashboard, Workspace) werden automatisch ausgeschlossen.',
      metaBasicSection: 'Basis-Meta',
      metaTitleLabelTpl: 'Meta title ({n}/60 empfohlen)',
      metaDescriptionLabelTpl: 'Meta description ({n}/155 empfohlen)',
      focusKeyword: 'Focus keyword',
      canonicalUrl: 'Kanonische URL',
      canonicalPlaceholder: 'https://www.ezdocu.ai/...',
      noindexLabel: 'noindex',
      nofollowLabel: 'nofollow',
      openGraphSection: 'Open Graph',
      ogTitle: 'OG title',
      ogDescription: 'OG description',
      ogImageUrl: 'OG image URL',
      ogImageUrlPlaceholder: 'https://...',
      twitterSection: 'Twitter Cards',
      twitterCard: 'Twitter card',
      twitterSite: 'Twitter @site',
      twitterSitePlaceholder: '@ezdocuai',
      twitterTitle: 'Twitter title',
      twitterDescription: 'Twitter description',
      twitterImage: 'Twitter image URL',
      jsonLdSection: 'JSON-LD',
      jsonLdLabel: 'Schemas (Array aus { type, jsonLd })',
      jsonLdHint: 'Wird beim Rendern der Seite in <head> eingefügt.',
      jsonLdInvalid: 'Ungültiges JSON-LD',
      changesPublished: 'Änderungen veröffentlicht',
      previewGoogle: 'Google-Vorschau',
      previewOg: 'OG-Vorschau',
      infoSection: 'Info',
      pageKeyLabel: 'Seitenschlüssel',
      lastEdited: 'Zuletzt bearbeitet',
    },
    apiKeys: {
      title: 'API-Schlüssel',
      subtitle: 'Verwalten Sie Zugriffsschlüssel für externe Integrationen (Ranqio usw.). Sie können einen Webhook konfigurieren, um Bestätigungen zu erhalten, wenn EZDocuAI einen Artikel verarbeitet.',
      noKeys: 'Noch keine API-Schlüssel erstellt.',
      webhookDeleted: 'Webhook gelöscht',
      webhookSaved: 'Webhook gespeichert',
      saveError: 'Fehler beim Speichern',
      copiedToClipboard: '✓ In Zwischenablage kopiert',
      statusActive: 'aktiv',
      statusRevoked: 'widerrufen',
      webhookBadge: 'webhook',
      rateLimitTpl: '{n}/Min.',
      lastUsedTpl: 'zuletzt verwendet: {when}',
      lastUsedNever: 'nie',
      lastDeliveryTpl: 'letzte Zustellung: HTTP {status}',
      noDeliveriesYet: 'noch keine Zustellungen',
      editWebhook: 'Webhook bearbeiten',
      configureWebhook: 'Webhook konfigurieren',
      webhookUrlLabel: 'Webhook-URL',
      webhookUrlPlaceholder: 'https://ihre-domain.com/webhooks/ezdocu',
      webhookUrlHint: 'EZDocuAI sendet hier einen signierten POST, sobald ein Artikel über diesen API-Schlüssel erstellt, aktualisiert oder gelöscht wird.',
      secretLabel: 'Secret (optional)',
      secretPlaceholder: 'Wird automatisch generiert, wenn leer gelassen',
      secretHint: 'Wird zum Signieren jeder Anfrage (HMAC-SHA256) im Header X-EZDocu-Signature verwendet.',
      showSecret: 'Anzeigen',
      hideSecret: 'Verbergen',
      saveSecretWarning: '⚠ Speichern Sie dieses Secret — es wird nicht erneut angezeigt',
      deleteWebhook: 'Webhook löschen',
      cancel: 'Abbrechen',
      save: 'Speichern',
      payloadExample: 'Webhook-Payload (Beispiel)',
    },
    landingPages: {
      title: 'Landing-Pages',
      subtitle: 'Verwalten Sie dynamische Landing-Pages: Angebote, Aktionen, Events.',
      newPage: 'Neue Seite',
      noPages: 'Noch keine Landing-Pages',
      createFirst: 'Erste erstellen',
      deleteConfirm: 'Diese Landing-Page löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      totalLbl: 'Gesamt',
      activeLbl: 'Aktiv',
      draftsLbl: 'Entwürfe',
      titleCol: 'Titel',
      slug: 'Slug',
      status: 'Status',
      updated: 'Aktualisiert',
      actions: 'Aktionen',
      activeBadge: 'Aktiv',
      draftBadge: 'Entwurf',
      viewSite: 'Ansehen',
      editPage: 'Bearbeiten',
      deletePage: 'Löschen',
      slugTitleRequired: 'Slug und Titel sind erforderlich',
      errorCreate: 'Fehler beim Erstellen',
      errorSave: 'Fehler beim Speichern',
      errorPublish: 'Fehler beim Veröffentlichen',
      draftSavedMsg: '✓ Entwurf gespeichert. Noch nicht öffentlich sichtbar.',
      publishedMsg: '🚀 Veröffentlicht. Besucher sehen die Änderungen jetzt.',
      draftDiscarded: 'Entwurf verworfen',
      draftUnpublished: 'Unveröffentlichter Entwurf',
      errorCreatePage: 'Fehler beim Erstellen der Seite',
      errorSaveDraft: 'Fehler beim Speichern des Entwurfs',
      notFound: 'Seite nicht gefunden',
      discardConfirm: 'Alle Änderungen am Entwurf verwerfen? Sie kehren zur veröffentlichten Version zurück.',
      confirmUnpublish: 'Diese Seite zurückziehen?\n\nBesucher sehen sie nicht mehr; sie liefert 404.',
      confirmPublishTpl: 'Diese Seite veröffentlichen?\n\nSie ist dann öffentlich unter /{slug} sichtbar.',
      unpublishedMsg: 'Seite zurückgezogen (404 für die Öffentlichkeit)',
      visibleMsg: 'Seite öffentlich sichtbar',
      newTitle: 'Neue Landingpage',
      editTitle: 'Landingpage bearbeiten',
      badgePublished: 'Veröffentlicht',
      badgeUnpublished: 'Nicht veröffentlicht (404 für die Öffentlichkeit)',
      publicUrl: 'Öffentliche URL:',
      toggleTitleUnpublish: 'Die Seite ist danach nicht mehr öffentlich sichtbar',
      toggleTitlePublish: 'Macht sie wieder öffentlich sichtbar',
      unpublish: 'Zurückziehen',
      publishPage: 'Seite veröffentlichen',
      discardDraft: 'Entwurf verwerfen',
      preview: 'Vorschau',
      createPage: 'Seite erstellen',
      saveDraft: 'Entwurf speichern',
      publish: 'Veröffentlichen',
      editingDraftTpl: 'Sie bearbeiten einen Entwurf. Klicken Sie auf {publish}, damit Besucher die Änderungen sehen, oder auf {preview}, um sie vorher zu prüfen.',
      sectionBasic: 'Grundinformationen',
      slugLockedHint: '🔒 Nicht bearbeitbar. Die URL lässt sich nach dem Erstellen nicht ändern (externe Links würden brechen).',
      slugUrlHintTpl: 'URL: /{slug}',
      fieldTitle: 'Titel *',
      fieldPublishedFrom: 'Veröffentlicht ab',
      publishedFromHint: 'Nur zur Information. Die tatsächliche Sichtbarkeit hängt von der Schaltfläche Veröffentlichen/Zurückziehen ab.',
      fieldExpires: 'Läuft ab am',
      expiresHint: 'Nur zur Information.',
      sectionContent: 'Inhalt',
      sectionSeo: 'SEO',
      fieldOgImage: 'OG-Bild (soziale Netzwerke)',
      ogImageHint: '1200×630 px empfohlen. Laden Sie es von Ihrem Computer hoch oder fügen Sie eine URL ein.',
      ogImagePlaceholder: 'https://… oder ein Bild hochladen',
      previewGoogle: 'Google-Vorschau',
      previewOg: 'OG-Vorschau',
    },
    templates: {
      title: 'Zertifikatvorlagen',
      subtitle: 'Verwalten Sie globale Zertifikatvorlagen, die für alle Konten verfügbar sind.',
      noTemplates: 'Noch keine Vorlagen',
      uploadTemplate: 'Vorlage hochladen',
      newTemplate: 'Neue Vorlage',
      editTemplate: 'Vorlage bearbeiten',
      activateTemplate: 'Aktivieren',
      deactivateTemplate: 'Deaktivieren',
      default: 'Standard',
      global: 'Global',
      custom: 'Benutzerdefiniert',
      uploadDocx: 'DOCX hochladen',
      globalTemplatesStat: 'Globale Vorlagen',
      activeStat: 'Aktiv',
      defaultStat: 'Standard',
      inactiveStat: 'Inaktiv',
      categoryGeneral: 'Allgemein',
      categoryLegal: 'Juristisch',
      categoryImmigration: 'Einwanderung',
      categoryAcademic: 'Akademisch',
      allTemplatesFilter: 'Alle Vorlagen',
      colTemplate: 'Vorlage',
      colCategory: 'Kategorie',
      colAccount: 'Konto',
      colFlags: 'Flags',
      colCreated: 'Erstellt',
      colActions: 'Aktionen',
      colActive: 'Aktiv',
      loadingTemplates: 'Vorlagen werden geladen...',
      noTemplatesFound: 'Keine Vorlagen gefunden.',
      flagDefault: 'Standard',
      flagGlobal: 'Global',
      editBtn: 'Bearbeiten',
      newGlobalTemplate: 'Neue globale Vorlage',
      uploadTemplateDialog: 'Vorlage hochladen',
      nameLabel: 'Name',
      namePlaceholder: 'z. B. Übersetzungszertifikat',
      descriptionLabel: 'Beschreibung (optional)',
      descriptionPlaceholder: 'Kurze Beschreibung dieser Vorlage',
      categoryLabel: 'Kategorie',
      languageLabel: 'Sprache',
      anyLanguage: 'Beliebige Sprache',
      languageEnglish: 'Englisch',
      languageSpanish: 'Spanisch',
      languagePortuguese: 'Portugiesisch',
      cancelBtn: 'Abbrechen',
      createAndEdit: 'Erstellen und bearbeiten',
      creatingBtn: 'Erstellung...',
      editingGlobalTemplate: 'Globale Vorlage wird bearbeitet',
      variablesBtn: 'Variablen',
      clickToCopyHint: 'Klicken zum Kopieren → Strg+V',
      copiedTooltip: '✓ Kopiert!',
      clickToCopyTooltip: 'Klicken zum Kopieren → {description}',
      saveAndClose: 'Speichern & Schließen',
      savingBtn: 'Speichern...',
      variableTranslatorName: 'Vollständiger Name des Übersetzers',
      variableTranslatorEmail: 'E-Mail-Adresse des Übersetzers',
      variableCertificationDate: 'Datum der Zertifizierung',
      variableOrderDate: 'Datum der Auftragserstellung',
      variableCompletionDate: 'Datum des Auftragsabschlusses',
      variableSourceLanguage: 'Originalsprache des Dokuments',
      variableTargetLanguage: 'Übersetzungssprache',
      variableSourceCountry: 'Herkunftsland',
      variableTargetCountry: 'Zielland',
      variableDocumentTitle: 'Titel des Dokuments',
      variableDocumentType: 'Kategorie/Typ des Dokuments',
      variablePageCount: 'Anzahl der Seiten',
      variableOrderNumber: 'Referenznummer des Auftrags',
      variableProjectNumber: 'Referenznummer des Projekts',
      failedToPrepareTpl: 'Vorlage konnte nicht vorbereitet werden: {message}',
      failedToSaveTpl: 'Vorlage konnte nicht gespeichert werden: {message}',
      failedToSaveGeneric: 'Vorlage konnte nicht gespeichert werden. Details finden Sie in der Konsole.',
      failedToCreate: 'Vorlage konnte nicht erstellt werden',
    },
    accountDetail: {
      loadFailed: 'Das Konto konnte nicht geladen werden',
      loadDetailsFailed: 'Die Kontodetails konnten nicht geladen werden',
      notFound: 'Konto nicht gefunden',
      backToAccounts: 'Zurück zu den Konten',
      subtitle: 'Kontodetails',
      typeFreelance: 'Freelancer',
      typeCompany: 'Unternehmen',
      trialEndsTpl: 'Testphase endet am {date}',
      legalName: 'Firmenname',
      taxId: 'Steuer-ID',
      website: 'Website',
      yes: 'Ja',
      no: 'Nein',
      dateFormat: 'Datumsformat',
      retention: 'Aufbewahrung',
      noAutoPurge: 'Keine automatische Löschung',
      retentionDaysTpl: '{n} Tage',
      orders: 'Aufträge',
      completed: 'Abgeschlossen',
      inProgress: 'In Bearbeitung',
      withFormat: 'Mit Format',
      recentOrders: 'Neueste Aufträge',
      colOrder: 'Auftrag',
      colDocument: 'Dokument',
      colLanguages: 'Sprachen',
      colFormat: 'Format',
      colPages: 'Seiten',
      colCredits: 'Credits',
      colStatus: 'Status',
      colCreated: 'Erstellt',
      noOrders: 'Dieses Konto hat noch keine Aufträge.',
      ordersUnavailable: 'Die Auftragsaktivität ist gerade nicht verfügbar.',
      spentToday: 'Heute verbraucht',
      spentThisMonth: 'Diesen Monat verbraucht',
      recentTransactions: 'Letzte Buchungen',
      balanceAfterTpl: 'Saldo {n}',
      noTransactions: 'Noch keine Credit-Buchungen.',
      txPurchase: 'Kauf',
      txConsumption: 'Verbrauch',
      txRefund: 'Erstattung',
      txAdjustment: 'Anpassung',
      txAutoRecharge: 'Automatische Aufladung',
      txSubscription: 'Abonnement',
      txCampaignBonus: 'Kampagnenbonus',
      txReferral: 'Empfehlung',
      txClawback: 'Rückbuchung',
      teamMembers: 'Teammitglieder',
      firstName: 'Vorname',
      lastName: 'Nachname',
      activeRelTpl: 'Aktiv {time}',
      lastLoginRelTpl: 'Letzte Anmeldung {time}',
      neverLoggedIn: 'Nie angemeldet',
      pendingInvitations: 'Ausstehende Einladungen',
      pending: 'Ausstehend',
      expiresTpl: 'Läuft ab am {date}',
    },
    userDetail: {
      loadFailed: 'Der Benutzer konnte nicht geladen werden',
      loadDetailsFailed: 'Die Benutzerdetails konnten nicht geladen werden',
      notFound: 'Benutzer nicht gefunden',
      backToUsers: 'Zurück zu den Benutzern',
      noAccounts: 'Dieser Benutzer gehört zu keinem Konto.',
      ordersOne: '{n} Auftrag',
      ordersOther: '{n} Aufträge',
      noOrders: 'Dieser Benutzer hat noch keine Aufträge.',
    },
    plans: {
      title: 'Planverwaltung',
      popular: 'Beliebt',
      saved: 'Gespeichert',
      monthlyPrice: 'Monatspreis',
      yearlyPrice: 'Jahrespreis',
      creditsMonth: 'Credits/Monat',
      creditsYear: 'Credits/Jahr',
      yearlyDiscount: 'Jahresrabatt %',
      buttonText: 'Button-Text',
      yes: 'Ja',
      no: 'Nein',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      description: 'Beschreibung',
      descriptionPlaceholder: 'Planbeschreibung...',
      limitsTitle: 'Limits (leer = unbegrenzt)',
      limitMaxCorpora: 'Max. Korpora',
      limitMaxMembers: 'Max. Mitglieder',
      limitHistoryDays: 'Verlauf (Tage)',
      limitRetentionDays: 'Max. Aufbewahrung (Tage)',
      featuresTitle: 'Funktionen',
      featureHumanVerifiedSeal: 'Human-Verified-Siegel',
      featureManuscripts: 'Handschriften',
      featureConfidential: 'Vertraulicher Modus',
      featurePostEdit: 'Post-Editing-Assistent',
      featureOtp: 'OTP-Verifizierung',
      featureApi: 'API-Zugang',
      featureSso: 'SSO / SAML',
      featureWhiteLabel: 'White-Label',
      benefits: 'Vorteile',
      moreTpl: '+{n} weitere',
    },
    settingsBcc: {
      supportPlaceholder: 'ops@firma.de, support@firma.de',
      eventPlaceholder: 'vertrieb@firma.de, finanzen@firma.de',
      salesPlaceholder: 'vertrieb@firma.de, leitung@firma.de',
    },
    features: {
      title: 'Funktionsschalter',
      subtitle: 'Plattformfunktionen aktivieren oder deaktivieren',
      loadFailed: 'Die Funktionsschalter konnten nicht geladen werden',
      retry: 'Erneut versuchen',
      totalFeatures: 'Funktionen gesamt',
      enabled: 'Aktiviert',
      disabled: 'Deaktiviert',
      categories: 'Kategorien',
      searchPlaceholder: 'Funktionen suchen...',
      all: 'Alle',
      catCore: 'Kern',
      catTranslation: 'Übersetzung',
      catBilling: 'Abrechnung',
      catNotifications: 'Benachrichtigungen',
      catIntegrations: 'Integrationen',
      warning: 'Das Deaktivieren von Kernfunktionen kann das System beeinträchtigen. Änderungen gelten sofort.',
      empty: 'Keine Funktionsschalter vorhanden. Laden Sie die Standardschalter, um zu beginnen.',
      seed: 'Standardschalter laden',
      noMatch: 'Keine Funktion entspricht Ihrer Suche.',
    },
    hubspot: {
      subtitle: 'Synchronisierung EZDocu → HubSpot (Kontakte, Unternehmen und Zuordnungen)',
      loadFailed: 'Der Synchronisierungsstatus konnte nicht geladen werden.',
      actionFailed: 'Die Aktion ist fehlgeschlagen. Prüfen Sie die Logs von auth-ms.',
      retryFailed: 'Fehlgeschlagene wiederholen',
      syncAll: 'Alles synchronisieren',
      confirmSyncAll: 'ALLE Benutzer und Konten erneut für HubSpot einreihen?',
      notConfiguredTpl: 'Die Synchronisierung ist inaktiv: {token} ist in auth-ms nicht konfiguriert.',
      pending: 'Ausstehend',
      processing: 'In Bearbeitung',
      done: 'Abgeschlossen',
      failed: 'Fehlgeschlagen',
      contactsSynced: 'Synchronisierte Kontakte',
      companiesSynced: 'Synchronisierte Unternehmen',
      recentFailures: 'Letzte Fehler',
      colObject: 'Objekt',
      colId: 'ID',
      colAttempts: 'Versuche',
      colLastError: 'Letzter Fehler',
      colDate: 'Datum',
      noFailures: 'Keine Fehler: Alles wird normal synchronisiert.',
    },
    knowledge: {
      title: 'Hilfecenter',
      subtitleTpl: 'Veröffentlichte Artikel erscheinen unter {path} und speisen den KI-Assistenten des Support-Widgets.',
      newArticle: '+ Neuer Artikel',
      loadFailed: 'Die Artikel konnten nicht geladen werden.',
      searchPlaceholder: 'Nach Titel, Kennung oder Bereich suchen…',
      emptyNone: 'Es gibt noch keine Artikel.',
      emptyNoMatch: 'Kein Artikel passt.',
      createFirst: 'Den ersten erstellen →',
      colArticle: 'Artikel',
      colKey: 'Kennung',
      colSection: 'Bereich',
      colLanguages: 'Sprachen',
      colStatus: 'Status',
      colUpdated: 'Aktualisiert',
      colActions: 'Aktionen',
      edit: 'Bearbeiten',
      deleteAll: 'Alle Sprachen löschen',
      confirmDeleteTpl: '„{title}“ in ALLEN Sprachen ({n}) löschen? Das ist endgültig und entfernt ihn auch aus der Wissensbasis des Assistenten.',
      published: 'Veröffentlicht',
      draft: 'Entwurf',
      missingTranslation: 'Noch nicht übersetzt',
      allPublished: 'Alle veröffentlicht',
      publishedCountTpl: '{pub}/{total} veröffentlicht',
      titleRequired: 'Titel und Slug sind Pflichtfelder.',
      saveFailed: 'Der Artikel konnte nicht gespeichert werden.',
      publishFailed: 'Die Veröffentlichung des Artikels konnte nicht geändert werden.',
      confirmUnpublish: 'Artikel zurückziehen? Er wird aus dem Assistenten und aus /help/ entfernt.',
      back: 'Zurück zum Hilfecenter',
      titlePlaceholder: 'Titel des Artikels…',
      titleShortPlaceholder: 'Titel…',
      savedTpl: 'Gespeichert {time}',
      view: 'Ansehen',
      saveDraft: 'Entwurf speichern',
      unpublish: 'Zurückziehen',
      republish: 'Erneut veröffentlichen',
      publish: 'Veröffentlichen',
      fieldSection: 'Bereich',
      noSection: '— Kein Bereich —',
      fieldCategory: 'Kategorie',
      categoryPlaceholder: 'z. B. Abrechnung, Erste Schritte…',
      fieldLanguage: 'Sprache',
      editorPlaceholder: 'Beginnen Sie zu schreiben…',
      editorTipTpl: 'Tipp: Geben Sie {key} ein, um die verfügbaren Blöcke zu sehen (Überschriften, Listen, Bilder, Tabellen, Code…).',
      featureOrderCreate: 'Auftrag erstellen',
      featureOrderDetail: 'Auftragsdetail',
      featureOrderList: 'Auftragsliste',
      featureCreditsBilling: 'Credits und Abrechnung',
      featureTeamManagement: 'Teamverwaltung',
      featureCertificate: 'Zertifikat',
      featureGlossary: 'Glossar',
      featureAccountSettings: 'Kontoeinstellungen',
      featureFaq: 'Häufige Fragen',
      groupLabel: 'Übersetzungsgruppe',
      keyLabel: 'Kennung:',
      publishedWithDraft: 'Veröffentlicht mit ausstehendem Entwurf',
      missingShort: 'Fehlt',
      missingVersionTpl: 'Dieser Artikel hat noch keine Version auf {lang}.',
      creating: 'Wird erstellt…',
      createTranslationTpl: 'Übersetzung auf {lang} erstellen',
      createFailed: 'Die Übersetzung konnte nicht erstellt werden.',
      featureReleaseNotes: 'Neuigkeiten',
      articleLoadFailed: 'Der Artikel konnte nicht geladen werden.',
    },
    marketingUi: {
      charsTpl: '{n} Zeichen',
      idealTpl: '(ideal {min}–{max})',
      noOgImage: 'Kein OG-Bild',
      noTitle: 'Ohne Titel',
      noDescription: 'Ohne Beschreibung',
      previewTitle: 'Vorschau: So sieht die veröffentlichte Seite aus',
      noContentYet: 'Noch kein Inhalt.',
      previewFooter: 'Genau das sehen Besucher, sobald Sie veröffentlichen.',
      close: 'Schließen',
      imageTooLargeTpl: 'Das Bild darf höchstens {n} MB groß sein.',
      uploadFailedTpl: 'Fehler {status} beim Hochladen des Bildes.',
      uploadTimeout: 'Der Upload hat länger als 30 s gedauert. Prüfen Sie Ihre Verbindung.',
      uploadError: 'Fehler beim Hochladen des Bildes. Bitte erneut versuchen.',
      uploadImageTpl: 'Bild hochladen (max. {n} MB)',
      upload: 'Hochladen',
      uploading: 'Wird hochgeladen…',
      clear: 'Leeren',
      imageLoaded: 'Bild geladen',
      previewAlt: 'Vorschau',
      editorPlaceholder: 'Beginnen Sie mit dem Inhalt der Landingpage…',
      loadingEditor: 'Editor wird geladen…',
      linkPrompt: 'Link-URL',
      youtubePrompt: 'URL des YouTube-Videos (https://youtube.com/watch?v=...)',
      editorUploadFailedTpl: 'Fehler {status}: Der Bildserver hat nicht korrekt geantwortet.',
      editorUploadTimeout: 'Der Upload hat länger als 30 Sekunden gedauert. Prüfen Sie Ihre Verbindung oder den Bilddienst.',
      bold: 'Fett',
      italic: 'Kursiv',
      strike: 'Durchgestrichen',
      inlineCode: 'Inline-Code',
      heading1: 'Überschrift 1',
      heading2: 'Überschrift 2',
      heading3: 'Überschrift 3',
      bulletList: 'Aufzählung',
      orderedList: 'Nummerierte Liste',
      quote: 'Zitat',
      divider: 'Trennlinie',
      link: 'Link',
      uploadImageCloud: 'Bild hochladen (Cloudinary, max. 5 MB)',
      insertYoutube: 'YouTube-Video einfügen',
      imageLabel: 'Bild:',
      alignLeft: 'Linksbündig',
      alignCenter: 'Zentrieren',
      alignRight: 'Rechtsbündig',
      uploadingImage: 'Bild wird hochgeladen…',
      undo: 'Rückgängig',
      redo: 'Wiederholen',
    },
    apiErrors: {
      fieldNotAllowedTpl: 'Das Feld „{field}“ darf bei diesem Vorgang nicht gesendet werden.',
      mustBeTextTpl: '{field} muss Text sein.',
      mustBeBooleanTpl: '{field} muss wahr oder falsch sein.',
      mustBeTypeTpl: '{field} hat ein ungültiges Format.',
      requiredTpl: '{field} ist ein Pflichtfeld.',
      minLengthTpl: '{field} muss mindestens {n} Zeichen haben.',
      maxLengthTpl: '{field} darf höchstens {n} Zeichen haben.',
      upstream: 'Der Marketing-Dienst antwortet nicht. Versuchen Sie es in ein paar Sekunden erneut.',
      notFound: 'Nicht gefunden.',
      tooLarge: 'Das Bild oder der Inhalt ist zu groß.',
      unauthorized: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
      forbidden: 'Sie haben keine Berechtigung für diese Aktion.',
      invalidLocale: 'Ungültige Sprache.',
      fieldSlug: 'Slug',
      fieldTitle: 'Titel',
      fieldContent: 'Inhalt',
      fieldOgImage: 'OG-Bild',
      fieldPublishedAt: 'Veröffentlichungsdatum',
      fieldExpiresAt: 'Ablaufdatum',
      fieldIsActive: 'Status',
      fieldKind: 'Typ',
      fieldLabelTpl: 'Beschriftung ({lang})',
      slugTaken: 'Es gibt bereits eine Landingpage mit diesem Slug. Wählen Sie einen anderen.',
      slugReserved: 'Dieser Slug ist reserviert: Unter dieser URL gibt es bereits eine Seite der App. Wählen Sie einen anderen.',
    },
    copyFields: {
      secHero: 'Hero-Bereich',
      secFeatures: 'Funktionen — Abschnitt',
      secFeatureCardTpl: 'Funktionen — Karte {n}',
      secFaq: 'FAQ — Abschnitt',
      secFaqItemTpl: 'FAQ — Frage {n}',
      secPricing: 'Preise',
      secCtaFinal: 'Abschluss-CTA',
      secFooter: 'Fußzeile',
      titleLine1: 'Titel — Zeile 1 (schwarz)',
      titleLine2: 'Titel — Zeile 2 (violett)',
      titleSizeDesktop: 'Titelgröße — Desktop (px)',
      titleSizeMobile: 'Titelgröße — Mobil (px)',
      titleSizeDesktopHint: 'Obergrenze für große Bildschirme. Leer = responsive Standardgröße. Empfohlen 48–80.',
      titleSizeMobileHint: 'Untergrenze auf Smartphones. Leer = 55 % des Desktop-Werts. Empfohlen 28–44.',
      subtitleSentence1: 'Untertitel — Satz 1',
      subtitleSentence2: 'Untertitel — Satz 2',
      ctaPrimary: 'Primäre Schaltfläche',
      ctaSecondary: 'Sekundäre Schaltfläche',
      ctaDemo: 'Schaltfläche „Demo buchen“',
      ctaDemoUrl: 'URL für die Demo-Buchung',
      title: 'Titel',
      subtitle: 'Untertitel',
      name: 'Name',
      description: 'Beschreibung',
      descriptionHover: 'Erweiterte Beschreibung (beim Darüberfahren)',
      question: 'Frage',
      answer: 'Antwort',
      titlePart1: 'Titel — Teil 1 (weiß)',
      titlePart2: 'Titel — Teil 2 (hellviolett)',
      button: 'Schaltfläche',
      tagline: 'Slogan',
      auto: 'Auto',
    },
    logs: {
      title: 'Aktivitätsprotokoll',
      subtitle: 'Ausführliches Protokoll aller Aktivitäten mit Credit-Verbrauch',
      totalLogs: 'Einträge gesamt',
      documents: 'Dokumente',
      translations: 'Übersetzungen',
      searchPlaceholder: 'Nach Auftrag, Konto oder Benutzer suchen...',
      allActions: 'Alle Aktionen',
      filterStatusCompleted: 'Status: abgeschlossen',
      actionAccountStatus: 'Kontostatus',
      actionAccountStatusChange: 'Änderung des Kontostatus',
      actionMemberUpdate: 'Mitglied aktualisiert',
      actionFeatureToggle: 'Funktion umgeschaltet',
      actionSettingsUpdate: 'Einstellungen aktualisiert',
      colOrder: 'Auftrag',
      colDetails: 'Details',
      noLogs: 'Keine Einträge gefunden',
      loadFailed: 'Die Einträge konnten nicht geladen werden.',
      pageOfTpl: 'Seite {page} von {pages}',
      totalTpl: '({n} insgesamt)',
      csvDate: 'Zeitpunkt',
    },
    webinar: {
      titleTpl: 'Anmeldungen · {slug}',
      subtitleTpl: 'Anmeldungen, erfasst über {endpoint} mit {field}.',
      reload: 'Neu laden',
      totalParticipants: 'Teilnehmende gesamt',
      language: 'Sprache',
      latestSignup: 'Letzte Anmeldung',
      searchPlaceholder: 'Nach E-Mail oder Handle suchen…',
      empty: 'Noch keine Teilnehmenden.',
      loadFailed: 'Die Anmeldungen konnten nicht geladen werden.',
      colEmail: 'E-Mail',
      colSource: 'Quelle',
      colDate: 'Datum',
      csvCreatedAt: 'Erstellt am',
    },
    support: {
      title: 'Support',
      subtitle: 'Posteingang der gesamten EZDocuAI-Plattform',
      searchPlaceholder: 'Nach Betreff oder Zusammenfassung suchen…',
      anyPriority: 'Beliebige Priorität',
      statusOpen: 'Offen',
      statusPending: 'Ausstehend',
      statusSolved: 'Gelöst',
      statusSnoozed: 'Zurückgestellt',
      statusSpam: 'Spam',
      priorityLow: 'Niedrig',
      priorityNormal: 'Normal',
      priorityHigh: 'Hoch',
      priorityUrgent: 'Dringend',
      channelEmail: 'E-Mail',
      channelChat: 'Chat',
      channelApi: 'API',
      channelForm: 'Formular',
      channelSlack: 'Slack',
      sentimentPositive: 'Positiv',
      sentimentNegative: 'Negativ',
      sentimentNeutral: 'Neutral',
      sentimentAngry: 'Verärgert',
      noTickets: 'Keine Tickets entsprechen den Filtern.',
      colSubject: 'Betreff',
      colChannel: 'Kanal',
      colPriority: 'Priorität',
      colStatus: 'Status',
      colSentiment: 'Stimmung',
      colCreated: 'Erstellt',
      noSubject: '(kein Betreff)',
      pageTpl: 'Seite {n}',
      connectError: 'Keine Verbindung zum Support-Posteingang möglich.',
      backToInbox: 'Zurück zum Posteingang',
      ticketNotFound: 'Ticket nicht gefunden',
      ticketLoadError: 'Das Ticket konnte nicht geladen werden.',
      timeNow: 'jetzt',
      timeMinTpl: 'vor {n} Min.',
      timeHourTpl: 'vor {n} Std.',
      timeDayTpl: 'vor {n} T.',
      createdTpl: 'Erstellt {time}',
      hideContext: 'Kontextbereich ausblenden',
      showContext: 'Kontextbereich einblenden',
      aiSummary: 'KI-Zusammenfassung',
      internalNotePlaceholder: 'Interne Notiz (nur für Agenten sichtbar)…',
      replyPlaceholder: 'Antwort an den Kunden schreiben…',
      send: 'Senden',
      internalNote: 'Interne Notiz',
      internalNoteNoEmail: 'Interne Notizen werden nie per E-Mail versendet',
      uncheckNoEmail: 'Abwählen, um dem Kunden keine E-Mail zu senden (die Antwort bleibt im Dashboard sichtbar)',
      notifyByEmail: 'Per E-Mail benachrichtigen',
      enterSendsTpl: '{enter} sendet · {shift} neue Zeile',
      ticketContext: 'Ticket-Kontext',
      closePanel: 'Bereich schließen',
      suggestedDraft: 'Vorgeschlagener Entwurf',
      generatedByAi: 'KI-generiert',
      aiBadge: 'KI',
      useReply: 'Antwort verwenden',
      copy: 'Kopieren',
      discard: 'Verwerfen',
      customer: 'Kunde',
      agent: 'Agent',
      aiAssistant: 'KI-Assistent',
      internalBadge: 'intern',
      ezdocuCustomer: 'EZDocuAI-Kunde',
      anonymousSender: 'Anonymer Absender',
      copyUserId: 'Benutzer-ID kopieren',
      visitorBadge: 'Besucher (nicht bei EZDocuAI registriert)',
      lastActivity: 'Letzte Aktivität:',
      lastLogin: 'Letzte Anmeldung:',
      lastPage: 'Letzte Seite:',
      timezone: 'Zeitzone:',
      signupDate: 'Registriert:',
      purchasesTitle: 'Käufe und Aufträge',
      statTotal: 'Gesamt',
      statCompleted: 'Abgeschlossen',
      statInProgress: 'In Bearbeitung',
      statCredits: 'Credits',
      accountName: 'Name',
      legalName: 'Firmenname',
      taxId: 'Steuer-ID',
      website: 'Website',
      accountStatus: 'Kontostatus',
      yes: 'Ja',
      no: 'Nein',
      dateFormat: 'Datumsformat',
      accountCreated: 'Konto erstellt',
      owner: 'Inhaber',
      accountDetails: 'Kontodetails',
      membersTitle: 'Kontomitglieder',
      noMembers: 'Keine Mitglieder.',
      inactive: 'Inaktiv',
      pending: 'Ausstehend',
      aiAssist: 'KI-Unterstützung',
      intentTpl: 'Absicht · {intent}',
      suggestedTags: 'Vorgeschlagene Tags',
      sessionReplay: 'Sitzungsaufzeichnung',
      sessionReplayDesc: 'Sehen Sie genau, was der Benutzer vor dem Öffnen des Tickets getan hat (Klicks, Navigation, Netzwerkanfragen).',
      openPosthog: 'In PostHog öffnen →',
      relatedOrder: 'Zugehöriger Auftrag',
      goToOrder: 'Zum Auftragsdetail →',
      relatedDocument: 'Betroffenes Dokument',
      openDocument: 'Dokument öffnen →',
      unassigned: 'Nicht zugewiesen',
      detailTags: 'Tags',
      noTags: 'Keine Tags',
      detailLanguage: 'Sprache',
      detailFirstResponse: 'Erste Antwort',
      detailResolved: 'Gelöst',
      detailSlaBreached: 'SLA überschritten',
      pastConversations: 'Frühere Unterhaltungen',
      firstTime: 'Dieser Kunde schreibt zum ersten Mal.',
      activityLog: 'Aktivitätsprotokoll',
      noEvents: 'Keine Ereignisse.',
      relToday: 'heute',
      relDaysTpl: '{n} T.',
      relWeeksTpl: '{n} Wo.',
      relMonthsTpl: '{n} Mon.',
      actorSystem: 'System',
      actorSomeone: 'Jemand',
      actCreated: 'hat das Ticket erstellt',
      actAssigned: 'hat das Ticket zugewiesen',
      actUnassigned: 'hat die Zuweisung aufgehoben',
      actStatusChanged: 'hat den Status geändert',
      actPriorityChanged: 'hat die Priorität geändert',
      actTagAdded: 'hat ein Tag hinzugefügt',
      actTagRemoved: 'hat ein Tag entfernt',
      actReplySent: 'hat eine Antwort gesendet',
      actNoteAdded: 'hat eine interne Notiz hinzugefügt',
      actResolved: 'hat das Ticket gelöst',
      actReopened: 'hat das Ticket wieder geöffnet',
      actSnoozed: 'hat das Ticket zurückgestellt',
      actMerged: 'hat das Ticket zusammengeführt',
      viewWidgetConversation: 'Widget-Unterhaltung ansehen',
      widgetConversation: 'Widget-Unterhaltung',
      messagesOne: '{n} Nachricht',
      messagesOther: '{n} Nachrichten',
      attachedImage: 'Angehängtes Bild',
      attachment: 'Anhang',
      attachedFile: 'Angehängte Datei',
      fileFallback: 'Datei',
      loading: 'Wird geladen…',
    },
  },
  adminPayments: {
    title: 'Zahlungen',
    transactionsOne: '{n} Transaktion',
    transactionsOther: '{n} Transaktionen',
    subtitle: 'Tarifkäufe, Credit-Pakete, Verlängerungen und automatische Aufladungen',
    refresh: 'Aktualisieren',
    exportExcel: 'Nach Excel exportieren',
    exporting: 'Wird exportiert…',
    exportError: 'Export fehlgeschlagen. Bitte versuchen Sie es erneut.',
    searchPlaceholder: 'Nach Kunde, E-Mail, Konto, Tarif oder Stripe-ID suchen…',
    countOf: '{n} von {total}',
    loading: 'Wird geladen…',
    empty: 'Noch keine Zahlungen erfasst.',
    emptyFiltered: 'Keine Zahlungen entsprechen diesen Filtern.',
    viewAccount: 'Konto ansehen',
    staleBackend: 'Der Server wendet diese Filter noch nicht an: Die Tabelle filtert nur die 200 neuesten Zahlungen, und die Summen beziehen sich auf alle Zahlungen. Die Excel-Datei ist vollständig und gefiltert.',
    filters: {
      period: 'Zeitraum',
      type: 'Typ',
      status: 'Status',
      from: 'Von',
      to: 'Bis',
      clear: 'Filter zurücksetzen',
      sinceDate: 'Ab {date}',
      untilDate: 'Bis {date}',
    },
    periods: {
      all: 'Gesamter Zeitraum',
      thisMonth: 'Dieser Monat',
      lastMonth: 'Letzter Monat',
      last30Days: 'Letzte 30 Tage',
      thisYear: 'Dieses Jahr',
      custom: 'Benutzerdefiniert',
    },
    categories: {
      all: 'Alle',
      plan: 'Tarife',
      credits: 'Credit-Pakete',
      autoRecharge: 'Automatische Aufladungen',
      refund: 'Rückerstattungen',
    },
    statusAll: 'Alle',
    statuses: {
      active: 'Aktiv',
      trial: 'Testphase',
      cancelsAtEnd: 'Wird gekündigt',
      canceled: 'Gekündigt',
      unpaid: 'Zahlungsverzug',
      incomplete: 'Unvollständig',
      unknown: 'Keine Daten',
      paid: 'Bezahlt',
      refund: 'Rückerstattung',
    },
    statusHelp: {
      active: 'Aktives Abonnement: verlängert sich automatisch.',
      cancelsAtEnd: 'Vom Kunden gekündigt: wird zum Ende des Zeitraums nicht verlängert.',
      unpaid: 'Stripe konnte die Verlängerung nicht abbuchen.',
      unknown: 'Stripe war nicht erreichbar; die nächste Abbuchung ist geschätzt.',
    },
    cycles: {
      yearly: 'Jährlich',
      monthly: 'Monatlich',
    },
    items: {
      plan: 'Tarif',
      creditPack: 'Credit-Paket',
      autoRecharge: 'Automatische Aufladung',
      refund: 'Rückerstattung',
    },
    cards: {
      revenue: 'Umsatz',
      total: 'Gesamt',
      netAndRefunds: 'Netto {net} · Rückerstattungen {refunds}',
      customersOne: '{n} Kunde',
      customersOther: '{n} Kunden',
      thisMonth: 'Dieser Monat',
      plans: 'Tarife',
      paymentsOne: '{n} Zahlung',
      paymentsOther: '{n} Zahlungen',
      creditPacks: 'Credit-Pakete',
      purchasesOne: '{n} Kauf',
      purchasesOther: '{n} Käufe',
      activeSubscriptions: 'Aktive Abonnements',
      today: 'Heute',
      mrr: 'MRR {usd}',
      cancelling: '{n} zum Laufzeitende gekündigt',
      unpaid: '{n} im Zahlungsverzug',
      unknown: '{n} ohne Daten',
      creditsSold: 'Verkaufte Credits',
    },
    columns: {
      date: 'Datum',
      customer: 'Kunde',
      account: 'Konto',
      item: 'Posten',
      cycle: 'Zyklus',
      status: 'Status',
      nextCharge: 'Nächste Abbuchung',
      description: 'Beschreibung',
      credits: 'Credits',
      amount: 'Betrag',
      stripeId: 'Stripe-ID',
      mode: 'Modus',
    },
    excel: {
      sheet: 'Zahlungen',
      date: 'Datum',
      customer: 'Kunde',
      email: 'E-Mail',
      account: 'Konto',
      type: 'Typ',
      cycle: 'Zyklus',
      status: 'Status',
      nextCharge: 'Nächste Abbuchung',
      description: 'Beschreibung',
      credits: 'Credits',
      amountUsd: 'Betrag USD',
      stripeId: 'Stripe-ID',
      mode: 'Modus',
    },
  },
  adminAiCosts: {
    title: 'KI-Kosten',
    subtitle: 'Was EZDocu für KI ausgibt, mit Claude (Anthropic) und Gemini (Google), nach Prozess, Modell, Tag und Konto.',
    refresh: 'Aktualisieren',
    exportExcel: 'Excel',
    exporting: 'Wird exportiert…',
    exportError: 'Die Excel-Datei konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    exportTruncated: 'Die Excel-Datei enthält nur die ersten {n} Zeilen. Grenzen Sie den Zeitraum ein, um den Rest zu sehen.',
    exportEmpty: 'Für diesen Zeitraum gibt es keine Zeilen zum Exportieren.',
    updatedAt: 'Aktualisiert um {time}',
    envSwitchLabel: 'Umgebung',
    envBadge: { production: 'Produktion', staging: 'Staging', qa: 'QA', local: 'Lokal' },
    filters: {
      period: 'Zeitraum',
      provider: 'Anbieter',
      allProviders: 'Alle',
      from: 'Von',
      to: 'Bis',
      apply: 'Anwenden',
      rangeTooLong: 'Der Zeitraum darf höchstens {n} Tage umfassen.',
      rangeIncomplete: 'Wählen Sie beide Daten.',
    },
    periods: {
      today: 'Heute',
      last7: 'Letzte 7 Tage',
      thisMonth: 'Dieser Monat',
      lastMonth: 'Letzter Monat',
      last30: 'Letzte 30 Tage',
      last90: 'Letzte 90 Tage',
      custom: 'Benutzerdefiniert',
    },
    kpis: {
      totalAi: 'KI-Ausgaben gesamt',
      platform: 'Plattform',
      callcenter: 'Callcenter',
      claude: 'Claude',
      gemini: 'Gemini',
      perPage: 'Kosten pro Seite',
      perOrder: 'Pro Auftrag {usd}',
      ofTotal: '{pct} der Gesamtsumme',
      callsOne: '{n} Aufruf',
      callsOther: '{n} Aufrufe',
      pagesOne: '{n} Seite',
      pagesOther: '{n} Seiten',
      ordersOne: '{n} Auftrag',
      ordersOther: '{n} Aufträge',
      vsPrevious: 'Im Vergleich zu {range}',
      noPrevious: 'Kein vergleichbarer Vorzeitraum',
      platformDeltaNote: 'Die Veränderung vergleicht nur die Plattform: Das Callcenter meldet keinen Vorzeitraum.',
      savingsShort: 'Gesch. Ersparnis {usd}',
      more: 'Höhere Ausgaben',
      less: 'Niedrigere Ausgaben',
    },
    charts: {
      byDay: 'Ausgaben pro Tag',
      byDayHint: 'US$ pro Tag, gestapelt nach Anbieter',
      byProcess: 'Nach Prozess',
      byProcessHint: 'Die 7 Prozesse mit den höchsten Ausgaben',
      others: 'Sonstige',
      usd: 'US$',
      calls: 'Aufrufe',
      total: 'Gesamt',
    },
    savings: {
      title: 'Geschätzte Ersparnis mit Gemini',
      note: 'Was die von Gemini beantworteten Aufrufe mit Claude gekostet hätten, abzüglich ihrer tatsächlichen Kosten. Schattentests werden separat ausgewiesen.',
      geminiCost: 'Kosten mit Gemini',
      claudeEstimate: 'Hätte mit Claude gekostet',
      savings: 'Ersparnis',
      shadow: 'Schattentests',
      none: 'Kein Prozess hat in diesem Zeitraum Gemini verwendet.',
      process: 'Prozess',
    },
    tables: {
      byModel: 'Nach Modell',
      byProcess: 'Nach Prozess',
      model: 'Modell',
      process: 'Prozess',
      provider: 'Anbieter',
      calls: 'Aufrufe',
      tokensIn: 'Eingabe',
      cacheRead: 'Cache-Lesen',
      cacheWrite: 'Cache-Schreiben',
      cacheSplit: 'L {read} · S {write}',
      tokensOut: 'Ausgabe',
      reasoning: 'Reasoning',
      avgSeconds: 'Ø Dauer',
      usd: 'US$',
      share: '% der Ausgaben',
      failed: 'Fehlgeschlagen',
      fallbacks: 'Ausweichmodelle',
      stages: 'Phasen',
      models: 'Modelle',
      providers: 'Anbieter',
      unknownPriceOne: '{n} Aufruf nutzte ein Modell ohne Preis: Er wurde zum höchsten Tarif berechnet.',
      unknownPriceOther: '{n} Aufrufe nutzten ein Modell ohne Preis: Sie wurden zum höchsten Tarif berechnet.',
    },
    top: {
      accounts: 'Konten mit den höchsten Ausgaben',
      orders: 'Aufträge mit den höchsten Ausgaben',
      account: 'Konto',
      order: 'Auftrag',
      ordersCount: 'Aufträge',
      pages: 'Seiten',
      usdPerPage: 'US$/Seite',
      noAccount: 'Konto aus einer anderen Umgebung',
      processes: 'Prozesse',
      empty: 'In diesem Zeitraum keine Ausgaben mit Kontobezug.',
    },
    environments: {
      title: 'Nach Umgebung',
      hint: 'Jede Umgebung hat ihren eigenen Schlüssel und ihr eigenes Guthaben.',
      unavailable: 'Keine Daten',
      notConfigured: 'Nicht konfiguriert',
      noRecord: 'Erfassung noch nicht aktiv',
      otherRows: 'Diese Datenbank enthält außerdem {usd} an Aufrufen aus „{env}“, die hier nicht mitgezählt werden.',
      current: 'Angezeigt',
    },
    callcenter: {
      title: 'Callcenter (Support)',
      subtitle: 'Widget-Chat und Support-Tickets von EZDocu, mit den Kosten ihrer KI.',
      cost: 'KI-Kosten',
      conversations: 'Unterhaltungen',
      messages: 'Nachrichten',
      tickets: 'Tickets',
      autoReplied: 'Automatische Antworten',
      escalated: 'Eskaliert',
      byDay: 'Ausgaben pro Tag',
      byProcessModel: 'Nach Prozess und Modell',
      noCostBefore: 'Keine Kostenerfassung vor dem {date}. Unterhaltungen, Nachrichten und Tickets werden trotzdem gezählt.',
      onlyProd: 'Das Callcenter bedient die Produktion: Seine Kosten fließen nur bei „Produktion“ in die Gesamtsumme ein.',
      unavailable: 'Die Callcenter-Nutzung ist nicht verfügbar: {reason}.',
      empty: 'Das Callcenter hat in diesem Zeitraum keine KI verwendet.',
      motivos: {
        'no-configurado': 'der Nutzungsschlüssel ist im Gateway nicht konfiguriert',
        timeout: 'das Callcenter hat nicht innerhalb von 5 s geantwortet',
        'no-autorizado': 'das Callcenter hat den Nutzungsschlüssel abgelehnt',
        'rango-invalido': 'das Callcenter akzeptiert diesen Zeitraum nicht',
        http: 'das Callcenter hat mit dem Fehler {code} geantwortet',
        red: 'keine Verbindung zum Callcenter möglich',
        'respuesta-invalida': 'das Callcenter hat in einem unerwarteten Format geantwortet',
      },
    },
    states: {
      loading: 'Wird geladen…',
      empty: 'Keine KI-Aufrufe in diesem Zeitraum',
      emptyHint: 'Versuchen Sie einen größeren Zeitraum.',
      noTable: 'Die Kostenerfassung ist in dieser Umgebung noch nicht aktiv: Die Migration 030 von processing-ms muss noch manuell angewendet werden.',
      error: 'Die KI-Kosten konnten nicht geladen werden ({reason}).',
      retry: 'Erneut versuchen',
      noRecordBefore: 'Keine Kostenerfassung vor dem {date}.',
      backfillNote: 'Enthält {usd} an geschätzter Historie aus der Zeit vor der Live-Erfassung.',
      notConfigured: 'Diese Umgebung ist auf dem Server nicht konfiguriert.',
    },
    groups: {
      'crear-orden': 'Auftrag anlegen',
      procesar: 'Verarbeiten',
      traducir: 'Übersetzen',
      revisar: 'Prüfen',
      glosario: 'Glossar',
      formato: 'Format',
      admin: 'Admin',
      latente: 'Nicht genutzt',
    },
    processes: {
      clasificacion: 'Dokumentklassifizierung',
      'clasificacion-sombra': 'Klassifizierung (Schattentest)',
      'giro-texto': 'Seitendrehung',
      'esquinas-foto': 'Fotozuschnitt',
      transcripcion: 'Seitentranskription',
      'marcas-bbox': 'Position von Stempeln und Unterschriften',
      'tablas-validador': 'Tabellenerkennung',
      'traduccion-html': 'Seitenweise Übersetzung',
      'traduccion-terminos': 'Begriffsliste',
      'traduccion-textos': 'Textübersetzung (Word/ODT/Blöcke)',
      'post-edicion': 'Post-Editing',
      'corpus-correcciones': 'Begriffe aus Korrekturen',
      'corpus-extractor': 'Glossar aus Textpaaren',
      'glosario-validador': 'Begriffsprüfung',
      'glosario-ingesta': 'Wörterbuchimport',
      'glosario-metadatos': 'Sprachen des Wörterbuchs',
      'cierre-formula': 'Schlussformel',
      'plantilla-nombre': 'Vorlagenname',
      'insights-chat': 'Admin-Assistent',
      'mensaje-compartir': 'Verbesserung der Teilen-Nachricht',
      'manuscrito-docx-legacy': 'Handschrift zu Word (alt)',
      'escaneo-foto-legacy': 'Foto-Scan (alt)',
      'fusion-parrafos': 'Absatzzusammenführung',
      preanalisis: 'Dokumentvoranalyse',
      'preproceso-ocr': 'OCR-Vorverarbeitung',
      'legacy-colores': 'Farben (alt)',
      'legacy-tablas-hoja': 'Tabellen pro Seite (alt)',
      'legacy-transcripcion-html': 'HTML-Transkription (alt)',
      traduccion: 'Übersetzung (Historie)',
      'widget-chat': 'Widget-Chat',
      autoresponder: 'Automatische Ticketantwort',
      tagger: 'Ticket-Verschlagwortung',
      summary: 'Gesprächszusammenfassung',
      embeddings: 'Embeddings für die Suche',
    },
    stages: {
      principal: 'Haupt',
      precalentado: 'Cache-Vorwärmen',
      antibucle: 'Schleifenschutz',
      'reintento-corte': 'Neuer Versuch nach Abbruch',
      'sin-contexto': 'Ohne Kontext',
      backfill: 'Geschätzte Historie',
    },
    providers: { anthropic: 'Claude (Anthropic)', gemini: 'Gemini (Google)', voyage: 'Voyage AI', other: 'Sonstige' },
    sources: { vivo: 'Live', backfill: 'Geschätzte Historie' },
    summaryCard: {
      title: 'KI-Kosten',
      seeDetail: 'Details ansehen',
      platformOnly: 'Nur die Plattform. Das Callcenter und die Aufschlüsselung nach Prozess finden Sie in den Details.',
      noData: 'Keine KI-Kostendaten für diesen Zeitraum.',
    },
    excel: {
      sheet: 'KI-Kosten',
      date: 'Datum',
      environment: 'Umgebung',
      provider: 'Anbieter',
      model: 'Modell',
      process: 'Prozess',
      processId: 'Prozess-ID',
      stage: 'Phase',
      calls: 'Aufrufe',
      failed: 'Fehlgeschlagen',
      fallbacks: 'Ausweichmodelle',
      shadow: 'Schatten',
      tokensUncached: 'Eingabe-Tokens',
      cacheRead: 'Cache-Tokens (Lesen)',
      cacheWrite: 'Cache-Tokens (Schreiben)',
      tokensOut: 'Ausgabe-Tokens',
      reasoning: 'Reasoning-Tokens',
      usd: 'US$',
      avgSeconds: 'Durchschnittliche Sekunden',
      source: 'Quelle',
      yes: 'Ja',
      no: 'Nein',
    },
  },
  glossary: {
    title: 'Globales Glossar',
    subtitle: 'Terminologie, die von allen Konten geteilt wird. Wird in automatischen Übersetzungen verwendet.',
    categoriesBtn: 'Kategorien',
    uploadFile: 'Datei hochladen',
    newTerm: 'Neuer Begriff',
    breadcrumbRoot: 'Glossar',
    categoriesWithDataTpl: 'Kategorien mit Begriffen ({n})',
    emptyCategoriesTpl: 'Leere Kategorien ({n})',
    termsCountOne: '{n} Begriff',
    termsCountOther: '{n} Begriffe',
    pairsCountOne: '{n} Paar',
    pairsCountOther: '{n} Paare',
    defsCountTpl: '{n} Def.',
    backToCategories: 'Kategorien',
    pairType: 'Zweisprachiges Paar',
    definitionType: 'Einsprachig (Definition)',
    pairTypeDescTpl: 'Begriff + Übersetzung. {n} Einträge.',
    definitionTypeDescTpl: 'Begriff + Definition. {n} Einträge.',
    backToTypes: 'Typen',
    langComboTermsTpl: '{n} Begriffe · {combo}',
    emptyType: 'Keine Einträge in diesem Typ.',
    deleteLangTitle: 'Begriffe löschen',
    deleteLangBodyTpl: 'Sie werden {n} Begriffe aus {cat} · {combo} löschen.',
    deleteCannotUndo: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    cancel: 'Abbrechen',
    deleteCountTpl: '{n} löschen',
    backToLanguages: 'Sprachen',
    filterByLetter: 'Nach Buchstaben filtern',
    allLetters: 'Alle',
    search: 'Suchen',
    searchPlaceholder: 'Begriff oder Übersetzung suchen...',
    onlyVerified: 'Nur verifizierte',
    refresh: 'Aktualisieren',
    downloadPdf: 'PDF herunterladen',
    generatingPdf: 'Wird erstellt…',
    downloadPdfTipFiltered: 'Download respektiert aktive Filter',
    downloadPdfTipAll: 'GESAMTES Glossar dieser Kategorie/Typ herunterladen',
    selectFilterCountTpl: 'Alle {n} Begriffe im Filter auswählen',
    selectedCountTpl: '{n} ausgewählt',
    allFilter: '(gesamter Filter)',
    verify: 'Verifizieren',
    unverify: 'Verifikation aufheben',
    clear: 'Löschen',
    pageXofYTpl: 'Seite {p} / {t}',
    letterLabelTpl: 'Buchstabe {l}',
    otherLetter: 'andere',
    noTerms: 'Keine Begriffe mit diesen Filtern.',
    previous: '← Zurück',
    next: 'Weiter →',
    term: 'Begriff',
    translation: 'Übersetzung',
    definition: 'Definition',
    source: 'Quelle',
    actions: 'Aktionen',
    verifiedTitle: 'Verifiziert · klicken zum Aufheben',
    unverifiedTitle: 'Nicht verifiziert · klicken zum Genehmigen',
    selectPage: 'Diese Seite auswählen',
    entryNewTitle: 'Neuer Begriff',
    entryEditTitle: 'Begriff bearbeiten',
    fieldCategory: 'Kategorie',
    fieldCategoryHelp: 'Gruppiert Begriffe nach Bereich (Recht, Medizin, Technik...). Wird verwendet, um beim Übersetzen das richtige Glossar vorzuschlagen.',
    fieldType: 'Typ',
    fieldTypeHelp: 'Übersetzungspaar = Quellbegriff + Zielbegriff in anderer Sprache. Definition (einsprachig) = Begriff + Erklärung in derselben Sprache.',
    fieldSourceTerm: 'Quellbegriff',
    fieldSourceTermHelp: 'Das Wort oder die Phrase wie im Originaldokument. In Kleinbuchstaben gespeichert für fallunabhängige Suche.',
    fieldLang: 'Sprache',
    fieldSourceLangHelp: 'Sprache des Quellbegriffs im ISO-639-1-Code (es, en, pt, fr, it, de).',
    fieldTranslation: 'Übersetzung',
    fieldTranslationHelp: 'Wie der Quellbegriff in die Zielsprache übersetzt werden soll. Wird als bevorzugte Referenz verwendet.',
    fieldTargetLangHelp: 'Sprache des übersetzten Begriffs (ISO-639-1).',
    fieldDefinition: 'Definition',
    fieldDefinitionHelp: 'Erklärung des Begriffs in derselben Sprache wie die Quelle. Nützlich für technische/juristische Begriffe ohne direkte Übersetzung.',
    fieldContext: 'Kontext (optional)',
    fieldContextHelp: 'Hinweise dazu, wann dieser Begriff gilt (Land, Teilbereich, Register). Nur Orientierung für den Prüfer.',
    fieldPriority: 'Priorität (0-100)',
    fieldPriorityHelp: 'Bei doppelten Begriffen gewinnt die höhere Priorität. 0 = normal, 50+ = bevorzugt, 100 = immer erzwingen.',
    fieldVerified: 'Verifiziert',
    fieldVerifiedHelp: 'Markiert von Menschen geprüfte Begriffe. Verifizierte haben Vorrang vor nicht verifizierten beim Übersetzen.',
    fieldSourceKind: 'Quelltyp',
    fieldSourceKindHelp: 'Woher der Begriff kommt: Manuell, PDF/CSV/TXT, KI (Claude), Web (öffentliche Seite), Kunde (privates Dokument).',
    fieldSourceLabel: 'Name / Referenz',
    fieldSourceLabelHelp: 'Lesbarer Name der Quelle für Audit. Erscheint in der Spalte Quelle der Tabelle.',
    fieldSourceUrl: 'URL (wenn aus dem Web)',
    fieldSourceUrlHelp: 'Kanonischer Link zur Originalseite. Wenn leer, wird kein Link in der Tabelle angezeigt.',
    fieldSourceUrlHint: 'Bsp: https://www.justicia.ar/herramientas/glosario',
    provenanceTitle: 'Quelle / Herkunft',
    selectPlaceholder: '— Auswählen —',
    entryPairOption: 'Übersetzungspaar',
    entryDefinitionOption: 'Definition (einsprachig)',
    save: 'Speichern',
    sourceTermPlaceholder: 'Bsp: Geburtsurkunde',
    translationPlaceholder: 'Bsp: birth certificate',
    definitionPlaceholder: 'Definition des Begriffs in derselben Quellsprache...',
    contextPlaceholder: 'Bsp: in juristischen Dokumenten in Kolumbien verwendet',
    sourceLabelPlaceholder: 'Bsp: Cabanellas 2023 / Kunde ACME',
    originalFile: 'Originaldatei',
    sourceManual: 'Manuell',
    sourcePdf: 'PDF',
    sourceCsv: 'CSV',
    sourceTxt: 'TXT',
    sourceAi: 'KI',
    sourceLearning: 'Übersetzung',
    sourceWeb: 'Web',
    sourceClient: 'Kunde',
    uploadTitle: 'Glossar hochladen',
    uploadConfirmTitle: 'Daten bestätigen',
    tabFile: 'Datei',
    tabUrl: 'URL',
    tabPaste: 'Text einfügen',
    uploadClickToSelect: 'Zum Auswählen klicken',
    uploadHint: 'PDF, CSV oder TXT · keine Größenbeschränkung',
    uploadAnalyzing: 'Claude analysiert die Datei…',
    urlFieldLabel: 'Glossar-URL',
    urlFieldHint: 'Bsp: https://www.justicia.ar/herramientas/glosario',
    analyzeUrl: 'URL analysieren',
    readingPage: 'Seite wird gelesen…',
    pageTitleLabel: 'Titel',
    pasteFieldLabel: 'Inhalt (aus Claude Max, Excel, Web, etc. einfügen)',
    pasteFieldHint: 'Als CSV erkannt bei Kommas + Zeilenumbrüchen; sonst als freier Text verarbeitet',
    pastePlaceholder: 'source_term,source_lang,target_term,target_lang,entry_type\nGeburtsurkunde,de,birth certificate,en,pair\n...',
    sourceName: 'Quellname',
    sourceNamePlaceholder: 'Bsp: Claude Max — Juristisches Glossar',
    originalUrlOptional: 'Original-URL (optional)',
    analyzeText: 'Text analysieren',
    analyzing: 'Analysiere…',
    claudeHelpTitle: '💡 Was Claude beim Hochladen macht:',
    claudeHelpDetectLangs: 'Erkennt Sprachen (Quelle / Ziel)',
    claudeHelpDetectType: 'Erkennt Typ (zweisprachiges Paar oder einsprachig)',
    claudeHelpSuggestCategory: 'Schlägt passende Kategorie vor',
    claudeHelpSaveSource: 'Speichert die Quelle (Datei / URL / Label) bei jedem Begriff',
    claudeAnalyzedTpl: 'Claude hat {file} analysiert ({chars} Zeichen). Überprüfen und bei Bedarf korrigieren.',
    destCategory: 'Zielkategorie',
    contentType: 'Inhaltstyp',
    pairOption: 'Zweisprachiges Paar',
    monolingualOption: 'Einsprachig',
    srcLang: 'Quellsprache',
    tgtLang: 'Zielsprache',
    savedSource: 'Quelle bei jedem Begriff gespeichert',
    changeSource: '← Quelle ändern',
    process: 'Verarbeiten',
    urlInvalid: 'Ungültige URL',
    urlEmpty: 'URL eingeben',
    urlNoText: 'Die Seite hat nicht genug Text zurückgegeben',
    pasteTooShort: 'Mindestens 200 Zeichen Inhalt einfügen',
    urlErrorGeneric: 'Fehler beim Analysieren der URL',
    detectError: 'Metadaten konnten nicht erkannt werden',
    uploadErrorGeneric: 'Upload-Fehler',
    confSure: 'sicher',
    confProbable: 'wahrscheinlich',
    confUnsure: 'unsicher',
    msgTermCreated: 'Begriff erstellt',
    msgTermUpdated: 'Begriff aktualisiert',
    msgTermDeleted: 'Begriff gelöscht',
    msgSaveError: 'Speicherfehler',
    msgBulkVerifiedTpl: '{n} Begriffe verifiziert',
    msgBulkUnverifiedTpl: '{n} Begriffe nicht verifiziert',
    msgVerifyError: 'Fehler beim Verifizieren',
    msgBulkDeletedTpl: '{n} Begriffe gelöscht',
    msgDeleteError: 'Fehler beim Löschen',
    msgPdfDownloadedTpl: 'PDF heruntergeladen ({n} Einträge)',
    msgPdfError: 'Fehler beim PDF-Export',
    errorFetchEntries: 'Fehler beim Abrufen der Einträge',
    helpAria: 'Hilfe',
    langNameEs: 'Spanisch',
    langNameEn: 'Englisch',
    langNamePt: 'Portugiesisch',
    langNameFr: 'Französisch',
    langNameIt: 'Italienisch',
    langNameDe: 'Deutsch',
    fileReadError: 'Die Datei konnte nicht gelesen werden',
    urlReadErrorTpl: '{url} konnte nicht gelesen werden',
    pasteLabelCsv: 'Eingefügter Text (CSV)',
    pasteLabelText: 'Eingefügter Text',
    noContent: 'Es gibt keinen Inhalt zum Importieren',
    charsCountTpl: '{n} Zeichen',
    jobTitle: 'Datei wird verarbeitet',
    jobSuccess: 'Import abgeschlossen',
    jobResultTpl: '{imported} Begriffe importiert · {duplicated} Duplikate übersprungen',
    jobTokensIn: 'Eingabe-Tokens',
    jobTokensOut: 'Ausgabe-Tokens',
    jobCacheHit: 'Cache-Treffer',
    jobCostUsd: 'Kosten USD',
    jobMethodModelTpl: 'Methode: {method} · Modell: {model}',
    jobError: 'Fehler bei der Verarbeitung der Datei',
    jobPreviewTpl: 'Vorschau: {n} extrahierte Begriffe',
    jobColSource: 'Quelle',
    jobColTarget: 'Ziel / Definition',
    jobShowingTpl: '200 von {n} werden angezeigt. Beim Bestätigen werden alle importiert.',
    jobDiscard: 'Verwerfen',
    jobConfirm: 'Import bestätigen',
    jobClose: 'Schließen',
    stageQueued: 'In der Warteschlange',
    stageExtracting: 'Text wird extrahiert',
    stageParsing: 'Wird analysiert',
    stageParsedTpl: '{done}/{total} Blöcke analysiert',
    stageAwaiting: 'Wartet auf Bestätigung durch den Admin',
    stageInserting: 'Begriffe werden gespeichert',
    stageDone: 'Fertig',
    stageCancelled: 'Abgebrochen',
    stageError: 'Fehler',
    catBackToGlossaries: 'Glossare',
    catTitle: 'Dokumentkategorien',
    catSubtitle: 'Dokumenttypen, nach denen die Begriffe des globalen Glossars eingeordnet werden. Systemkategorien können nicht gelöscht werden.',
    catNew: 'Neue Kategorie',
    catEdit: 'Kategorie bearbeiten',
    catCreated: 'Kategorie erstellt',
    catUpdated: 'Kategorie aktualisiert',
    catDeleted: 'Kategorie gelöscht',
    catCannotDelete: 'Löschen nicht möglich: Der Kategorie sind Begriffe zugeordnet.',
    catConfirmDeleteTpl: 'Kategorie „{name}“ löschen? Nur möglich, wenn ihr keine Begriffe zugeordnet sind.',
    catShowInactive: 'Inaktive anzeigen',
    catCountOne: '{n} Kategorie',
    catCountOther: '{n} Kategorien',
    catColKey: 'Schlüssel',
    catColName: 'Name (5 Sprachen)',
    catColTerms: 'Begriffe',
    catColActive: 'Aktiv',
    catColActions: 'Aktionen',
    catSystemTitle: 'Systemkategorie: kann nicht gelöscht werden',
    catSystemBadge: 'System',
    catActivate: 'Aktivieren',
    catDeactivate: 'Deaktivieren',
    catEditBtn: 'Bearbeiten',
    catDeleteBtn: 'Löschen',
    catEmpty: 'Es gibt noch keine Kategorien. Erstellen Sie die erste, um zu beginnen.',
    catFieldKey: 'Schlüssel (Slug)',
    catFieldKeyHint: 'Kleinbuchstaben, Bindestriche oder _. Später nicht änderbar.',
    catKeyPlaceholder: 'z. B. medical_lab',
    catFieldNameTpl: 'Name {lang}',
    catFieldDescription: 'Beschreibung (optional)',
    catFieldIcon: 'Symbol (optional)',
    catFieldIconHint: 'Emoji oder Name',
    catFieldOrder: 'Reihenfolge',
    catActiveLabel: 'Aktiv (zur Einordnung von Begriffen verfügbar)',
    catSave: 'Speichern',
  },
  sharedComponents: {
    notificationBell: {
      ariaLabel: 'Benachrichtigungen',
    },
    languageSelector: {
      tooltip: 'Sprache ändern',
    },
    professionalProfile: {
      associationSearchHint: 'Durchsuchen Sie 85+ verifizierte Verbände oder geben Sie "Andere" ein',
      associationSearchPlaceholder: 'Verband suchen (z. B. ATA, BDÜ, CTPCBA...)',
      noResults: 'Keine Ergebnisse',
    },
  },
  verifyPublic: {
    humanVerified: 'Menschlich verifiziert',
    kmsSigned: 'KMS-signiert',
    translationOnRecord: 'Übersetzung im Register',
    statusHashing: 'Datei wird überprüft…',
    statusPurgedWithHash: 'Diese Übersetzung wurde vom oben genannten Übersetzer abgeschlossen und signiert. Die Originaldatei wird nicht mehr auf unseren Servern gespeichert, aber Sie können Ihre Kopie unten hochladen, um zu prüfen, ob die Signatur übereinstimmt — die Datei wird in Ihrem Browser geprüft und verlässt Ihr Gerät nie.',
    statusWithHash: 'Diese Übersetzung wurde vom oben genannten Übersetzer abgeschlossen und signiert. Um zu bestätigen, dass die erhaltene PDF authentisch ist, laden Sie sie unten hoch — die Datei wird in Ihrem Browser geprüft und verlässt Ihr Gerät nie.',
    statusNoHash: 'Diese Übersetzung wurde vom oben genannten Übersetzer abgeschlossen und signiert. Der signierte Inhalt ist auf unseren Servern gespeichert und wurde nicht verändert.',
    documentVerifiedTitle: 'Dokument verifiziert',
    documentVerifiedDesc: 'Die hochgeladene Datei stimmt exakt mit der signierten Übersetzung überein. Dieses Dokument wurde nicht verändert.',
    fileMismatchTitle: 'Datei stimmt nicht überein',
    fileMismatchDesc: 'Die hochgeladene Datei stimmt nicht mit der signierten Übersetzung überein. Selbst geringfügige Aktionen wie erneutes Speichern oder Komprimieren können zu einer Abweichung führen. Bitte fordern Sie die signierte Datei an und versuchen Sie es erneut.',
    documentDetailsLabel: 'Dokumentdetails',
    documentField: 'Dokument',
    orderField: 'Auftrag',
    languagesField: 'Sprachen',
    pagesField: 'Seiten',
    verifiedByField: 'Verifiziert von',
    verifiedOnField: 'Verifiziert am',
    verifyIntegrityLabel: 'Dokumentintegrität prüfen',
    computingHash: 'Hash wird berechnet…',
    dropzoneTitlePurged: 'Laden Sie Ihre Kopie der signierten PDF hoch',
    dropzoneTitle: 'Laden Sie die vom Übersetzer bereitgestellte PDF hoch',
    dropzoneHintPurged: 'Die Datei befindet sich nicht mehr auf unseren Servern. Ihr Hash bleibt in unserer Datenbank signiert und wird ausschließlich in Ihrem Browser mit Ihrem verglichen.',
    dropzoneHint: 'Die Datei wird nur in Ihrem Browser geprüft. Sie verlässt Ihr Gerät nie.',
    fileNotAvailableBox: 'Ein direkter Dateivergleich ist für diesen Eintrag nicht verfügbar. Der Übersetzungsinhalt wurde zum Zeitpunkt der Verifizierung kryptografisch signiert und bleibt auf unseren Servern unverändert.',
    disclaimerPurged: 'Zero-Knowledge by Design: Die signierte Datei befindet sich nicht mehr auf unseren Servern, ihr kryptografischer Fingerabdruck wird jedoch dauerhaft gespeichert. Laden Sie Ihre Kopie hoch, um zu beweisen, dass sie mit der vom Übersetzer signierten Datei übereinstimmt.',
    disclaimerWithHash: 'Diese Seite allein bestätigt, dass eine Übersetzung bei diesem Fachmann registriert ist. Sie validiert die in Ihrem Besitz befindliche Datei erst, wenn Sie sie zum Vergleich hochladen.',
    disclaimerNoHash: 'Diese Seite bestätigt, dass eine Übersetzung bei diesem Fachmann registriert ist. Upload-basierter Dateivergleich ist für diesen Eintrag nicht verfügbar; die Integrität wird auf Inhaltsebene garantiert.',
    saveBtn: 'Diese Verifizierung speichern',
    verificationResultLabel: 'Verifizierungsergebnis',
    exactMatchTitle: 'Exakte Übereinstimmung bestätigt',
    exactMatchDesc: 'Die hochgeladene Datei ist identisch mit der signierten Übersetzung.',
    certificationStatementLabel: 'Zertifizierungserklärung',
    defaultCertStatement: 'Hiermit bestätige ich, dass dies nach bestem Wissen und Gewissen eine wahrheitsgetreue und genaue Übersetzung des Originaldokuments ist.',
    verifiedDisclaimer: 'Die hochgeladene Datei stimmt exakt mit der vom Übersetzer ausgestellten signierten Übersetzung überein. EZDocuAI prüft ausschließlich die Dateiintegrität. Der Übersetzer ist allein für den Inhalt und die Genauigkeit dieser Übersetzung verantwortlich.',
    reverifyBtn: 'Erneut verifizieren',
    fileMismatchResultTitle: 'Dateiabweichung erkannt',
    fileMismatchResultDesc: 'Die hochgeladene Datei stimmt nicht mit der signierten Übersetzung überein.',
    mismatchDisclaimer: 'EZDocuAI analysiert nicht, was geändert wurde. Wir prüfen nur, ob die hochgeladene Datei identisch mit der signierten Übersetzung ist.',
    inspectedCannotConfirmTitle: 'Wir können diese Datei nicht bestätigen',
    inspectedCannotConfirmDesc: 'Für diese Verifizierung wurde kein Datei-Hash gespeichert, daher können wir nicht bestätigen, ob die hochgeladene PDF die vom Übersetzer signierte ist. Fordern Sie die signierte Datei direkt vom Übersetzer an.',
    yourFileHashLabel: 'Hash Ihrer Datei (SHA-256)',
    inspectedDisclaimer: 'Ihre Datei hat Ihren Browser nie verlassen — wir haben nur den SHA-256 lokal berechnet und zu Ihrer Dokumentation auf dem Bildschirm belassen. Ein definitives Urteil über Übereinstimmung oder Abweichung ist nur bei Verifizierungen möglich, bei denen der Hash der signierten PDF zum Zeitpunkt der Signatur gespeichert wurde.',
    tryAgainBtn: 'Erneut versuchen',
    contactTranslatorBtn: 'Übersetzer kontaktieren',
    mailtoSubject: 'Verifizierungsabweichung – {order}',
    mailtoBody: 'Sehr geehrte(r) {translator},\n\nIch habe versucht, eine Übersetzung über EZDocuAI zu verifizieren, und die hochgeladene Datei stimmte nicht mit der signierten Version im Register überein.\n\nAuftrag: {order}\nDokument: {document}\n\nKönnten Sie mir bitte eine neue beglaubigte digitale Kopie zur Verfügung stellen?\n\nVielen Dank.',
    cryptographicDetails: 'Kryptografische Details',
    verificationIdLabel: 'Verifizierungs-ID',
    documentHashLabel: 'Dokument-Hash (SHA-256)',
    contentHashLabel: 'Inhalts-Hash (SHA-256)',
    localVerificationNote: 'Lokale Verifizierung: Die Datei wird in Ihrem Browser geprüft und nie auf einen Server hochgeladen.',
    verificationIssuedAt: 'Verifizierung ausgestellt am {date} um {time} UTC',
    poweredBy: 'Bereitgestellt von',
    footerDisclaimer: 'EZDocuAI ist ausschließlich ein Technologieanbieter. Wir bewerten nicht den Inhalt von Dokumenten, die Genauigkeit von Übersetzungen oder die rechtliche Konformität. Diese Seite bestätigt lediglich die technische Integrität der digitalen Datei.',
    zeroKnowledgeEncrypted: 'Zero-Knowledge-verschlüsselt',
    notFoundTitle: 'Verifizierung nicht gefunden',
    notFoundDesc: 'Das Übersetzungsverifizierungszertifikat, das Sie suchen, existiert nicht oder die ID ist ungültig.',
    goToHome: 'Zu EZDocuAI',
  },
};
